
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3cmwu", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2543f6b5f5c59170$export$6503ec6e8aabbaf; }, function (v) { return $2543f6b5f5c59170$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2543f6b5f5c59170$export$f7ad0328861e2f03; }, function (v) { return $2543f6b5f5c59170$export$f7ad0328861e2f03 = v; });
var $2543f6b5f5c59170$export$6503ec6e8aabbaf;
var $2543f6b5f5c59170$export$f7ad0328861e2f03;
"use strict";
var $2543f6b5f5c59170$var$mapping = new Map();
function $2543f6b5f5c59170$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2543f6b5f5c59170$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2543f6b5f5c59170$var$resolve(id) {
    var resolved = $2543f6b5f5c59170$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2543f6b5f5c59170$export$6503ec6e8aabbaf = $2543f6b5f5c59170$var$register;
$2543f6b5f5c59170$export$f7ad0328861e2f03 = $2543f6b5f5c59170$var$resolve;

});

parcelRegister("lnr8b", function(module, exports) {
var $f900ca9e826c78c5$var$core = module.exports = {
    version: "2.6.12"
};
if (typeof __e == "number") __e = $f900ca9e826c78c5$var$core; // eslint-disable-line no-undef

});

parcelRegister("k8fni", function(module, exports) {

var $dQBEM = parcelRequire("dQBEM");

var $9Kh92 = parcelRequire("9Kh92");

module.exports = (parcelRequire("bLxkk")) ? function(object, key, value) {
    return $dQBEM.f(object, key, $9Kh92(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("dQBEM", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $a14d578d28325c83$export$2d1720544b23b823; }, function (v) { return $a14d578d28325c83$export$2d1720544b23b823 = v; });
var $a14d578d28325c83$export$2d1720544b23b823;

var $9C5yR = parcelRequire("9C5yR");

var $3VI75 = parcelRequire("3VI75");

var $aWQkR = parcelRequire("aWQkR");
var $a14d578d28325c83$var$dP = Object.defineProperty;

$a14d578d28325c83$export$2d1720544b23b823 = (parcelRequire("bLxkk")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $9C5yR(O);
    P = $aWQkR(P, true);
    $9C5yR(Attributes);
    if ($3VI75) try {
        return $a14d578d28325c83$var$dP(O, P, Attributes);
    } catch (e) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("9C5yR", function(module, exports) {

var $iqLaL = parcelRequire("iqLaL");
module.exports = function(it) {
    if (!$iqLaL(it)) throw TypeError(it + " is not an object!");
    return it;
};

});
parcelRegister("iqLaL", function(module, exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

});


parcelRegister("3VI75", function(module, exports) {



module.exports = !(parcelRequire("bLxkk")) && !(parcelRequire("01ncm"))(function() {
    return Object.defineProperty((parcelRequire("79BiK"))("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("bLxkk", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("01ncm"))(function() {
    return Object.defineProperty({}, "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("01ncm", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("79BiK", function(module, exports) {

var $iqLaL = parcelRequire("iqLaL");

var $aSeGt = parcelRequire("aSeGt");
var $53564ef7388bd079$require$document = $aSeGt.document;
// typeof document.createElement is 'object' in old IE
var $53564ef7388bd079$var$is = $iqLaL($53564ef7388bd079$require$document) && $iqLaL($53564ef7388bd079$require$document.createElement);
module.exports = function(it) {
    return $53564ef7388bd079$var$is ? $53564ef7388bd079$require$document.createElement(it) : {};
};

});
parcelRegister("aSeGt", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $7eaa567ec143f9df$var$global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = $7eaa567ec143f9df$var$global; // eslint-disable-line no-undef

});



parcelRegister("aWQkR", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $iqLaL = parcelRequire("iqLaL");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$iqLaL(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !$iqLaL(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !$iqLaL(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !$iqLaL(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("9Kh92", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("gXO7r", function(module, exports) {
var $c599089bc84ceebb$var$id = 0;
var $c599089bc84ceebb$var$px = Math.random();
module.exports = function(key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++$c599089bc84ceebb$var$id + $c599089bc84ceebb$var$px).toString(36));
};

});

parcelRegister("7tVes", function(module, exports) {

var $lnr8b = parcelRequire("lnr8b");

var $aSeGt = parcelRequire("aSeGt");
var $5727a2f240e6c335$var$SHARED = "__core-js_shared__";
var $5727a2f240e6c335$var$store = $aSeGt[$5727a2f240e6c335$var$SHARED] || ($aSeGt[$5727a2f240e6c335$var$SHARED] = {});

(module.exports = function(key, value) {
    return $5727a2f240e6c335$var$store[key] || ($5727a2f240e6c335$var$store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: $lnr8b.version,
    mode: (parcelRequire("1wMnh")) ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("1wMnh", function(module, exports) {
module.exports = false;

});


parcelRegister("k0xSC", function(module, exports) {

var $aSeGt = parcelRequire("aSeGt");
var $e90e1699ee3365f0$require$document = $aSeGt.document;
module.exports = $e90e1699ee3365f0$require$document && $e90e1699ee3365f0$require$document.documentElement;

});

parcelRegister("cAEsp", function(module, exports) {
var $92a83ac8c47411b6$var$toString = {}.toString;
module.exports = function(it) {
    return $92a83ac8c47411b6$var$toString.call(it).slice(8, -1);
};

});

parcelRegister("1Q5lc", function(module, exports) {

var $156eca5f9f9d5968$var$store = (parcelRequire("7tVes"))("wks");

var $gXO7r = parcelRequire("gXO7r");

var $aSeGt = parcelRequire("aSeGt");
var $156eca5f9f9d5968$require$Symbol = $aSeGt.Symbol;
var $156eca5f9f9d5968$var$USE_SYMBOL = typeof $156eca5f9f9d5968$require$Symbol == "function";
var $156eca5f9f9d5968$var$$exports = module.exports = function(name) {
    return $156eca5f9f9d5968$var$store[name] || ($156eca5f9f9d5968$var$store[name] = $156eca5f9f9d5968$var$USE_SYMBOL && $156eca5f9f9d5968$require$Symbol[name] || ($156eca5f9f9d5968$var$USE_SYMBOL ? $156eca5f9f9d5968$require$Symbol : $gXO7r)("Symbol." + name));
};
$156eca5f9f9d5968$var$$exports.store = $156eca5f9f9d5968$var$store;

});

parcelRegister("9lJXd", function(module, exports) {
"use strict";

var $1wMnh = parcelRequire("1wMnh");

var $aHywL = parcelRequire("aHywL");

var $38Rz6 = parcelRequire("38Rz6");

var $k8fni = parcelRequire("k8fni");

var $lwojb = parcelRequire("lwojb");

var $kpuHn = parcelRequire("kpuHn");

var $bwFml = parcelRequire("bwFml");

var $71Be0 = parcelRequire("71Be0");

var $6ce9b8ba5e4a79c0$var$ITERATOR = (parcelRequire("1Q5lc"))("iterator");
var $6ce9b8ba5e4a79c0$var$BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
var $6ce9b8ba5e4a79c0$var$FF_ITERATOR = "@@iterator";
var $6ce9b8ba5e4a79c0$var$KEYS = "keys";
var $6ce9b8ba5e4a79c0$var$VALUES = "values";
var $6ce9b8ba5e4a79c0$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $kpuHn(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$6ce9b8ba5e4a79c0$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $6ce9b8ba5e4a79c0$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $6ce9b8ba5e4a79c0$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + " Iterator";
    var DEF_VALUES = DEFAULT == $6ce9b8ba5e4a79c0$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$6ce9b8ba5e4a79c0$var$ITERATOR] || proto[$6ce9b8ba5e4a79c0$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
    var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $71Be0($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $bwFml(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$1wMnh && typeof IteratorPrototype[$6ce9b8ba5e4a79c0$var$ITERATOR] != "function") $k8fni(IteratorPrototype, $6ce9b8ba5e4a79c0$var$ITERATOR, $6ce9b8ba5e4a79c0$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $6ce9b8ba5e4a79c0$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$1wMnh || FORCED) && ($6ce9b8ba5e4a79c0$var$BUGGY || VALUES_BUG || !proto[$6ce9b8ba5e4a79c0$var$ITERATOR])) $k8fni(proto, $6ce9b8ba5e4a79c0$var$ITERATOR, $default);
    // Plug for library
    $lwojb[NAME] = $default;
    $lwojb[TAG] = $6ce9b8ba5e4a79c0$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($6ce9b8ba5e4a79c0$var$VALUES),
            keys: IS_SET ? $default : getMethod($6ce9b8ba5e4a79c0$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $38Rz6(proto, key, methods[key]);
        } else $aHywL($aHywL.P + $aHywL.F * ($6ce9b8ba5e4a79c0$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("aHywL", function(module, exports) {

var $aSeGt = parcelRequire("aSeGt");

var $lnr8b = parcelRequire("lnr8b");

var $k8fni = parcelRequire("k8fni");

var $38Rz6 = parcelRequire("38Rz6");

var $c5eX0 = parcelRequire("c5eX0");
var $7ca8b3f9a80dd02e$var$PROTOTYPE = "prototype";
var $7ca8b3f9a80dd02e$var$$export = function(type, name, source) {
    var IS_FORCED = type & $7ca8b3f9a80dd02e$var$$export.F;
    var IS_GLOBAL = type & $7ca8b3f9a80dd02e$var$$export.G;
    var IS_STATIC = type & $7ca8b3f9a80dd02e$var$$export.S;
    var IS_PROTO = type & $7ca8b3f9a80dd02e$var$$export.P;
    var IS_BIND = type & $7ca8b3f9a80dd02e$var$$export.B;
    var target = IS_GLOBAL ? $aSeGt : IS_STATIC ? $aSeGt[name] || ($aSeGt[name] = {}) : ($aSeGt[name] || {})[$7ca8b3f9a80dd02e$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $lnr8b : $lnr8b[name] || ($lnr8b[name] = {});
    var expProto = exports[$7ca8b3f9a80dd02e$var$PROTOTYPE] || (exports[$7ca8b3f9a80dd02e$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $c5eX0(out, $aSeGt) : IS_PROTO && typeof out == "function" ? $c5eX0(Function.call, out) : out;
        // extend global
        if (target) $38Rz6(target, key, out, type & $7ca8b3f9a80dd02e$var$$export.U);
        // export
        if (exports[key] != out) $k8fni(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$aSeGt.core = $lnr8b;
// type bitmap
$7ca8b3f9a80dd02e$var$$export.F = 1; // forced
$7ca8b3f9a80dd02e$var$$export.G = 2; // global
$7ca8b3f9a80dd02e$var$$export.S = 4; // static
$7ca8b3f9a80dd02e$var$$export.P = 8; // proto
$7ca8b3f9a80dd02e$var$$export.B = 16; // bind
$7ca8b3f9a80dd02e$var$$export.W = 32; // wrap
$7ca8b3f9a80dd02e$var$$export.U = 64; // safe
$7ca8b3f9a80dd02e$var$$export.R = 128; // real proto method for `library`
module.exports = $7ca8b3f9a80dd02e$var$$export;

});
parcelRegister("38Rz6", function(module, exports) {

var $aSeGt = parcelRequire("aSeGt");

var $k8fni = parcelRequire("k8fni");

var $fmYbJ = parcelRequire("fmYbJ");

var $249bab5af8843783$var$SRC = (parcelRequire("gXO7r"))("src");

var $l27yQ = parcelRequire("l27yQ");
var $249bab5af8843783$var$TO_STRING = "toString";
var $249bab5af8843783$var$TPL = ("" + $l27yQ).split($249bab5af8843783$var$TO_STRING);

(parcelRequire("lnr8b")).inspectSource = function(it) {
    return $l27yQ.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == "function";
    if (isFunction) $fmYbJ(val, "name") || $k8fni(val, "name", key);
    if (O[key] === val) return;
    if (isFunction) $fmYbJ(val, $249bab5af8843783$var$SRC) || $k8fni(val, $249bab5af8843783$var$SRC, O[key] ? "" + O[key] : $249bab5af8843783$var$TPL.join(String(key)));
    if (O === $aSeGt) O[key] = val;
    else if (!safe) {
        delete O[key];
        $k8fni(O, key, val);
    } else if (O[key]) O[key] = val;
    else $k8fni(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $249bab5af8843783$var$TO_STRING, function toString() {
    return typeof this == "function" && this[$249bab5af8843783$var$SRC] || $l27yQ.call(this);
});

});
parcelRegister("fmYbJ", function(module, exports) {
var $b3079937f304223f$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $b3079937f304223f$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("l27yQ", function(module, exports) {

module.exports = (parcelRequire("7tVes"))("native-function-to-string", Function.toString);

});


parcelRegister("c5eX0", function(module, exports) {
// optional / simple context binding

var $arSKg = parcelRequire("arSKg");
module.exports = function(fn, that, length) {
    $arSKg(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("arSKg", function(module, exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
};

});



parcelRegister("lwojb", function(module, exports) {
module.exports = {};

});

parcelRegister("kpuHn", function(module, exports) {
"use strict";

var $fp98v = parcelRequire("fp98v");

var $9Kh92 = parcelRequire("9Kh92");

var $bwFml = parcelRequire("bwFml");
var $edbdf48a4001cc7e$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("k8fni"))($edbdf48a4001cc7e$var$IteratorPrototype, (parcelRequire("1Q5lc"))("iterator"), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $fp98v($edbdf48a4001cc7e$var$IteratorPrototype, {
        next: $9Kh92(1, next)
    });
    $bwFml(Constructor, NAME + " Iterator");
};

});
parcelRegister("fp98v", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $9C5yR = parcelRequire("9C5yR");

var $c88eg = parcelRequire("c88eg");

var $kXqYo = parcelRequire("kXqYo");

var $b3704714d3e7b4cb$var$IE_PROTO = (parcelRequire("5joQV"))("IE_PROTO");
var $b3704714d3e7b4cb$var$Empty = function() {};
var $b3704714d3e7b4cb$var$PROTOTYPE = "prototype";


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b3704714d3e7b4cb$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("79BiK"))("iframe");
    var i = $kXqYo.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    (parcelRequire("k0xSC")).appendChild(iframe);
    iframe.src = "javascript:"; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    $b3704714d3e7b4cb$var$createDict = iframeDocument.F;
    while(i--)delete $b3704714d3e7b4cb$var$createDict[$b3704714d3e7b4cb$var$PROTOTYPE][$kXqYo[i]];
    return $b3704714d3e7b4cb$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b3704714d3e7b4cb$var$Empty[$b3704714d3e7b4cb$var$PROTOTYPE] = $9C5yR(O);
        result = new $b3704714d3e7b4cb$var$Empty();
        $b3704714d3e7b4cb$var$Empty[$b3704714d3e7b4cb$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b3704714d3e7b4cb$var$IE_PROTO] = O;
    } else result = $b3704714d3e7b4cb$var$createDict();
    return Properties === undefined ? result : $c88eg(result, Properties);
};

});
parcelRegister("c88eg", function(module, exports) {

var $dQBEM = parcelRequire("dQBEM");

var $9C5yR = parcelRequire("9C5yR");

var $iqr3M = parcelRequire("iqr3M");

module.exports = (parcelRequire("bLxkk")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $9C5yR(O);
    var keys = $iqr3M(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$dQBEM.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("iqr3M", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $bOrdd = parcelRequire("bOrdd");

var $kXqYo = parcelRequire("kXqYo");
module.exports = Object.keys || function keys(O) {
    return $bOrdd(O, $kXqYo);
};

});
parcelRegister("bOrdd", function(module, exports) {

var $fmYbJ = parcelRequire("fmYbJ");

var $5j9rP = parcelRequire("5j9rP");

var $899978f912146f5d$var$arrayIndexOf = (parcelRequire("cezGf"))(false);

var $899978f912146f5d$var$IE_PROTO = (parcelRequire("5joQV"))("IE_PROTO");
module.exports = function(object, names) {
    var O = $5j9rP(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $899978f912146f5d$var$IE_PROTO) $fmYbJ(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($fmYbJ(O, key = names[i++])) ~$899978f912146f5d$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("5j9rP", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $hktEa = parcelRequire("hktEa");

var $dugQJ = parcelRequire("dugQJ");
module.exports = function(it) {
    return $hktEa($dugQJ(it));
};

});
parcelRegister("hktEa", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $cAEsp = parcelRequire("cAEsp");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return $cAEsp(it) == "String" ? it.split("") : Object(it);
};

});

parcelRegister("dugQJ", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("cezGf", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $5j9rP = parcelRequire("5j9rP");

var $lpbNh = parcelRequire("lpbNh");

var $7egGB = parcelRequire("7egGB");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5j9rP($this);
        var length = $lpbNh(O.length);
        var index = $7egGB(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("lpbNh", function(module, exports) {
// 7.1.15 ToLength

var $asutB = parcelRequire("asutB");
var $f95514c60292bfc3$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $f95514c60292bfc3$var$min($asutB(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("asutB", function(module, exports) {
// 7.1.4 ToInteger
var $79d428e567c36da7$var$ceil = Math.ceil;
var $79d428e567c36da7$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $79d428e567c36da7$var$floor : $79d428e567c36da7$var$ceil)(it);
};

});


parcelRegister("7egGB", function(module, exports) {

var $asutB = parcelRequire("asutB");
var $5436c8b683f3fbde$var$max = Math.max;
var $5436c8b683f3fbde$var$min = Math.min;
module.exports = function(index, length) {
    index = $asutB(index);
    return index < 0 ? $5436c8b683f3fbde$var$max(index + length, 0) : $5436c8b683f3fbde$var$min(index, length);
};

});


parcelRegister("5joQV", function(module, exports) {

var $3de2014eb2b55cc2$var$shared = (parcelRequire("7tVes"))("keys");

var $gXO7r = parcelRequire("gXO7r");
module.exports = function(key) {
    return $3de2014eb2b55cc2$var$shared[key] || ($3de2014eb2b55cc2$var$shared[key] = $gXO7r(key));
};

});


parcelRegister("kXqYo", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

});




parcelRegister("bwFml", function(module, exports) {

var $dQBEM = parcelRequire("dQBEM");
var $8642c3f7351982b8$require$def = $dQBEM.f;

var $fmYbJ = parcelRequire("fmYbJ");

var $8642c3f7351982b8$var$TAG = (parcelRequire("1Q5lc"))("toStringTag");
module.exports = function(it, tag, stat) {
    if (it && !$fmYbJ(it = stat ? it : it.prototype, $8642c3f7351982b8$var$TAG)) $8642c3f7351982b8$require$def(it, $8642c3f7351982b8$var$TAG, {
        configurable: true,
        value: tag
    });
};

});


parcelRegister("71Be0", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $fmYbJ = parcelRequire("fmYbJ");

var $fmmKl = parcelRequire("fmmKl");

var $51d5807ec094207a$var$IE_PROTO = (parcelRequire("5joQV"))("IE_PROTO");
var $51d5807ec094207a$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $fmmKl(O);
    if ($fmYbJ(O, $51d5807ec094207a$var$IE_PROTO)) return O[$51d5807ec094207a$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $51d5807ec094207a$var$ObjectProto : null;
};

});
parcelRegister("fmmKl", function(module, exports) {
// 7.1.13 ToObject(argument)

var $dugQJ = parcelRequire("dugQJ");
module.exports = function(it) {
    return Object($dugQJ(it));
};

});



parcelRegister("dDEjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBootstrap = module.exports.SHELL_MARKED_EVENTS = module.exports.AuthState = module.exports.UNIFIED_SHELL_CLIENTID = module.exports.UNIFIED_SHELL_APPID = module.exports.UNIFIED_SHELL_APIKEY = void 0;

var $jBKJw = parcelRequire("jBKJw");

var $hCG2Z = parcelRequire("hCG2Z");

var $1HQDe = parcelRequire("1HQDe");

var $7CZdW = parcelRequire("7CZdW");

var $iNslS = parcelRequire("iNslS");

var $3r4G2 = parcelRequire("3r4G2");

var $3LITL = parcelRequire("3LITL");

var $9OLey = parcelRequire("9OLey");

var $bd520608efc7e7f4$var$_metrics = $bd520608efc7e7f4$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $bd520608efc7e7f4$var$_ServiceWorkerRegisterService = $bd520608efc7e7f4$var$_interopRequireDefault((parcelRequire("3e6zu")));

var $apIgy = parcelRequire("apIgy");

var $iJaYo = parcelRequire("iJaYo");
function $bd520608efc7e7f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd520608efc7e7f4$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $bd520608efc7e7f4$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $bd520608efc7e7f4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bd520608efc7e7f4$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bd520608efc7e7f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $bd520608efc7e7f4$var$UNIFIED_SHELL_APIKEY = "exc_app";
module.exports.UNIFIED_SHELL_APIKEY = $bd520608efc7e7f4$var$UNIFIED_SHELL_APIKEY;
const $bd520608efc7e7f4$var$UNIFIED_SHELL_APPID = "shell";
module.exports.UNIFIED_SHELL_APPID = $bd520608efc7e7f4$var$UNIFIED_SHELL_APPID;
const $bd520608efc7e7f4$var$UNIFIED_SHELL_CLIENTID = "exc_app";
module.exports.UNIFIED_SHELL_CLIENTID = $bd520608efc7e7f4$var$UNIFIED_SHELL_CLIENTID;
const $bd520608efc7e7f4$var$AUTOMATION_CLIENT_HOLDER = "exc-automation-client";
let $bd520608efc7e7f4$var$AuthState; // Should extend this interface to the entire object managed by UnifiedShellSessionService.js
module.exports.AuthState = $bd520608efc7e7f4$var$AuthState;
(function(AuthState) {
    AuthState["RELOAD"] = "RELOAD";
    AuthState["LOGIN"] = "LOGIN";
    AuthState["NO_AUTH"] = "NO_AUTH";
})($bd520608efc7e7f4$var$AuthState || (module.exports.AuthState = $bd520608efc7e7f4$var$AuthState = {}));
const $bd520608efc7e7f4$var$SHELL_MARKED_EVENTS = [
    "AppAssembly.done",
    "AppAssembly.start",
    "Auth.ClusterToken",
    "Auth.tokenPrefetch",
    "Auth.SSO",
    "CustomToken.done",
    "CustomToken.start",
    "Discovery.failure",
    "Discovery.start",
    "Discovery.success",
    "ErrorMessage",
    "IframeTimer.start",
    "PostAuth.loaded",
    "Reload.Reason",
    "Sandbox.connected",
    "Sandbox.onMessage.ping",
    "Sandbox.reconnected",
    "Sandbox.secondPing",
    "ServiceWorker.active",
    "ServiceWorker.appsVersionUpdated",
    "ServiceWorker.installing",
    "ServiceWorker.liveHtml",
    "ServiceWorker.noHtmlUpdates",
    "ServiceWorker.waiting",
    "shellInitDataQuery.data.initialized",
    "shellInitDataQuery.failure",
    "shellInitDataQuery.start",
    "Shell.done",
    "Shell.isLoginFlow.done",
    "Shell.notPermissioned",
    "Shell.start",
    "SolutionSwitcher.Load",
    "Start",
    "SwitchAccount.start",
    "SwitchAccount.switchDone",
    "SwitchAccount.authProcessDone",
    "exc.metrics.pageState.load.done"
];
module.exports.SHELL_MARKED_EVENTS = $bd520608efc7e7f4$var$SHELL_MARKED_EVENTS;
const $bd520608efc7e7f4$var$getLocalConfig = ()=>{
    try {
        const localConfigs = window.localStorage.getItem("unifiedShellConfig");
        return localConfigs ? JSON.parse(localConfigs) : {};
    } catch  {
        return {};
    }
};
const $bd520608efc7e7f4$var$win = window;
const $bd520608efc7e7f4$var$resolveGqlPromise = (clusterData)=>!clusterData || "error" in clusterData ? (0, $3LITL.initializeShellDataForLogin)({}) : clusterData;
class $bd520608efc7e7f4$var$BootstrapServiceImpl {
    constructor(){
        $bd520608efc7e7f4$var$_defineProperty(this, "_authInfoPromise", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_authInformation", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_accountClusterPromise", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_clientId", $bd520608efc7e7f4$var$UNIFIED_SHELL_CLIENTID);
        $bd520608efc7e7f4$var$_defineProperty(this, "_ims", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_loaded", false);
        $bd520608efc7e7f4$var$_defineProperty(this, "_authConfigResolve", $iNslS.NOOP);
        $bd520608efc7e7f4$var$_defineProperty(this, "_bootstrapData", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_activeCdn", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_config", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_demoMode", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_devMode", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_localConfigs", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_metricsEnv", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "_serviceWorker", new $bd520608efc7e7f4$var$_ServiceWorkerRegisterService.default());
        $bd520608efc7e7f4$var$_defineProperty(this, "_shellConfig", void 0);
        $bd520608efc7e7f4$var$_defineProperty(this, "metrics", $bd520608efc7e7f4$var$_metrics.default.create("exc.core.services.BootstrapService"));
        $bd520608efc7e7f4$var$_defineProperty(this, "getSid", ()=>(this._ims?.getAccessToken() || {}).sid || "");
        $bd520608efc7e7f4$var$_defineProperty(this, "isDemoMode", ()=>this._demoMode);
        $bd520608efc7e7f4$var$_defineProperty(this, "isDevMode", ()=>this._devMode);
        $bd520608efc7e7f4$var$_defineProperty(this, "inAutomation", ()=>(window !== window.parent || window.navigator.webdriver) && ("Cypress" in window || "UnifiedShellTestClient" in window));
        (0, $apIgy.setAuthPromise)(new Promise((resolve)=>this._authConfigResolve = resolve));
        this._bootstrapData = $bd520608efc7e7f4$var$win["exc-bootstrap"] || {};
        delete $bd520608efc7e7f4$var$win["exc-bootstrap"];
        if (window._srp && window.config) {
            // Since config.cdn always points at front door, use _srp.cdn to point at the actual CDN.
            // This code can be removed after content server is updated to default Shell to AWS.
            window.config.cdn = window._srp.cdn;
            window.config.cdnFallback = window._srp.fallbackLocations;
        }
        this._shellConfig = {
            scriptsPath: "/assets",
            ...$bd520608efc7e7f4$var$win.config || {
                cdn: "",
                env: "dev"
            }
        };
        const environment = this._shellConfig.env = this._shellConfig.env.toLowerCase();
        const imsEnv = (0, $hCG2Z.getQueryValue)("ims");
        let iframeUseSameOrigin = false;
        const client = this.getAutomationClient(); // Allow EXC client override on prod, and other clients override on non-prod.
        if (environment !== "prod" && imsEnv !== "prod" || client.startsWith($bd520608efc7e7f4$var$UNIFIED_SHELL_CLIENTID)) {
            if ($bd520608efc7e7f4$var$win.forceIframeUseSameOrigin) iframeUseSameOrigin = true;
            if (this.inAutomation()) {
                iframeUseSameOrigin = this.sameOriginUnderAutomation();
                client && (this._clientId = client);
            }
        }
        this._config = (0, $1HQDe.getConfiguration)({
            ...this._shellConfig,
            environment: environment,
            iframeUseSameOrigin: iframeUseSameOrigin
        }, this._clientId, imsEnv);
        this._localConfigs = $bd520608efc7e7f4$var$getLocalConfig();
        this._demoMode = (0, $hCG2Z.getQueryValue)("demo") === "true";
        this._devMode = this._localConfigs.devmodeEnabled || (0, $hCG2Z.getQueryValue)("devmode") === "true";
        this._metricsEnv = this._devMode ? "dev" : environment;
        this.initMetrics();
        this.config.cdn || (this.config.cdn = location.origin);
        let { cdn: cdn } = this.config;
        if ($bd520608efc7e7f4$var$win._srp?.resourceURL && $bd520608efc7e7f4$var$win._srp.resourceURL !== cdn) {
            cdn = $bd520608efc7e7f4$var$win._srp.resourceURL;
            this.metrics.event("Shell.CDNFallback", `Using ${cdn} for static assets.`, {
                level: $bd520608efc7e7f4$var$_metrics.Level.WARN
            });
        }
        this._activeCdn = cdn;
        (0, $jBKJw.setPingEndpoint)(this._config);
    }
    initMetrics() {
        const { env: env, spaVersion: spaVersion = "local.development" } = this._shellConfig;
        const mode = (0, $hCG2Z.getQueryValue)("metricsmode") || this.config.environment === "prod" && "quiet";
        const metricsConfig = {
            analytics: {
                script: env === "prod" ? "//exc-unifiedcontent.experience.adobe.net/static/launch/a7d65461e54e/bca0d85cdac1/launch-73fb0b595c8c.min.js" : "//assets.adobedtm.com/a7d65461e54e/bca0d85cdac1/launch-e6337088c5a2-staging.min.js",
                solution: "exc" // initial value
            },
            application: {
                id: "unified-shell",
                solution: {
                    id: "n/a"
                },
                version: spaVersion
            },
            environment: this._metricsEnv
        };
        mode && (metricsConfig.mode = mode); // Update opt out based on local storage cached version of user consent.
        const consentCache = (0, $7CZdW.getCachedConsent)();
        (0, $7CZdW.onConsent)(consentCache, this.metrics, false);
        $9OLey.Internal.configureMetrics(metricsConfig); // Adds a filter to Metrics which will create performance marks
        // for the events listed in SHELL_MARKED_EVENTS
        (0, $iNslS.markEventsPerformance)(window, $bd520608efc7e7f4$var$SHELL_MARKED_EVENTS, (event)=>`us_${event.toLowerCase().replace(/[ ().\-&]+/g, "_")}`);
        const solutionCount = Object.keys(this._shellConfig.solutions || {}).length;
        this.metrics.event("Start", {
            ...this._shellConfig,
            solutionCount: solutionCount
        });
        if (!solutionCount || !this._shellConfig.tis) this.metrics.error("Invalid Config", $bd520608efc7e7f4$var$win.config);
    }
    load() {
        if (!this._loaded) {
            this._loaded = true;
            this._serviceWorker.load(); // The account cluster flow also loads IMS lib, which acquires an access token if needed.
            this.getAccountCluster();
        }
    }
    async checkAuthState(hasToken, fromIMS, localSessionId) {
        let authState = $bd520608efc7e7f4$var$AuthState.NO_AUTH;
        if (hasToken) {
            // User is authenticated.
            authState = $bd520608efc7e7f4$var$AuthState.RELOAD;
            const authSessionId = this.getSid();
            if (fromIMS && localSessionId === authSessionId) this.metrics.event("Auth.alreadyLoggedIn");
             // If the user is authenticated and sessionId is empty or out of date,
            // treat it as login to trigger SSO handler in Core.
            if (localSessionId !== authSessionId) {
                authState = $bd520608efc7e7f4$var$AuthState.LOGIN;
                localSessionId && $iJaYo.storage.local.set("unifiedShellSession", {});
                fromIMS || this.metrics.event("Auth.SSO", {
                    authSessionId: !!authSessionId,
                    referrer: document.referrer,
                    storageSessionId: !!localSessionId
                });
            }
        }
        return authState;
    }
    async getToken(promise, filter) {
        try {
            const tokenProfile = await promise;
            if ("error" in tokenProfile) {
                const error = (0, $iNslS.getErrorMessage)(tokenProfile.error);
                this.metrics.error("Failed to prefetch token", {
                    error: error
                });
                return {
                    access_token: ""
                };
            }
            if (tokenProfile.access_token && tokenProfile.userId) {
                const { access_token: access_token, ...profile } = tokenProfile;
                this.metrics.event("Auth.tokenPrefetch", {
                    filter: filter
                });
                return {
                    access_token: access_token,
                    profile: profile
                };
            }
            this.metrics.error("Failed to prefetch token - Invalid response", {
                error: tokenProfile
            });
        } catch (err) {
            const error = (0, $iNslS.getErrorMessage)(err);
            this.metrics.error("Failed to prefetch token", {
                error: error
            });
        }
        return {
            access_token: ""
        };
    }
    async loadIMS() {
        const { filter: filter, tokenPromise: tokenPromise } = this._bootstrapData;
        const fromIMS = window.location.hash.includes("from_ims");
        try {
            let prefetchedProfile;
            let token = [
                "dev",
                "qa"
            ].includes(this._config.environment) ? (0, $hCG2Z.getQueryValue)("customtoken") || "" : "";
            token && this.metrics.info("customtoken exists"); // Debugging to determine if needed
            if (!token && tokenPromise) {
                const { access_token: access_token, profile: profile } = await this.getToken(tokenPromise, filter);
                prefetchedProfile = profile;
                token = access_token;
            }
            const imsObjects = await (0, $3r4G2.getIMSObjects)({
                clientId: this._clientId,
                env: this._config.serviceEnvironment,
                profile: prefetchedProfile,
                token: token
            });
            const { adobeIMS: adobeIMS } = imsObjects;
            this._ims = adobeIMS; // Check for custom query.
            const hasToken = adobeIMS.isSignedInUser();
            const { activeOrg: activeOrg, session: session } = hasToken ? await $iJaYo.storage.local.get("unifiedShellSession") || {} : {};
            const authState = await this.checkAuthState(hasToken, fromIMS, session); // If this is a whole new Unified Shell version, let's download it while the user is in SUSI.
            if (authState === $bd520608efc7e7f4$var$AuthState.NO_AUTH) {
                this.metrics.event("Login.imsSSO.ready", "Invalid session: imsSSO login required");
                this._serviceWorker.prepareForLogin();
            } else {
                (0, $jBKJw.checkCDN)();
                this.configureNetwork();
            } // Clean token from URL if it exists
            const cleanedHash = (0, $hCG2Z.cleanTokenFromHash)(location.hash);
            if (cleanedHash) {
                this.metrics.warn("Access token found in window hash");
                location.hash = cleanedHash;
            }
            this._authInformation = {
                ...imsObjects,
                activeOrg: activeOrg,
                authState: authState,
                fromIMS: fromIMS
            };
        } catch (err) {
            const error = err?.message || "Unknown Error";
            this.metrics.error("Failed to initialize IMS lib", {
                error: error,
                stack: err?.stack
            });
            this._serviceWorker.prepareForLogin();
            this._authInformation = {
                authState: $bd520608efc7e7f4$var$AuthState.NO_AUTH,
                error: error,
                fromIMS: fromIMS
            };
        }
        return this._authInformation;
    }
    getAuthInformation() {
        if (!this._authInfoPromise) this._authInfoPromise = this.loadIMS();
        return this._authInfoPromise;
    }
    get authInformation() {
        return this._authInformation;
    }
    get config() {
        return this._config;
    }
    configureNetwork(imsOrg, sandbox, orgRegion) {
        const { token: imsToken } = this._ims?.getAccessToken() || {};
        if (!imsToken) {
            this.metrics.warn("Can not configure network module without a token.");
            return;
        }
        this._authConfigResolve();
        $9OLey.Internal.configureNetwork({
            apiGatewayUrl: this._config.endpoints.apiGateway,
            apiKey: $bd520608efc7e7f4$var$UNIFIED_SHELL_APIKEY,
            appId: $bd520608efc7e7f4$var$UNIFIED_SHELL_APPID,
            imsOrg: imsOrg,
            imsToken: imsToken,
            ioGatewayUrl: this.config.endpoints.ioGateway,
            ioRegionSpecificMap: this.config.endpoints.regionGatewayIoMap,
            isAWSOrg: orgRegion ? (0, $iNslS.isAWSOrgRegion)(orgRegion) : false,
            orgRegion: orgRegion,
            sandbox: sandbox,
            xqlGatewayUrl: this.config.endpoints.xql
        });
    }
    async getAccountCluster() {
        const { activeOrg: activeOrg, authState: authState } = this._authInformation || await this.getAuthInformation();
        const { shellDataPromise: shellDataPromise } = this._bootstrapData;
        const { tenant: selectedOrg } = (0, $hCG2Z.getCurrentTenantAndPath)();
        if (!this._accountClusterPromise) switch(authState){
            case $bd520608efc7e7f4$var$AuthState.LOGIN:
                this._accountClusterPromise = shellDataPromise ? shellDataPromise.then($bd520608efc7e7f4$var$resolveGqlPromise) : (0, $3LITL.initializeShellDataForLogin)({
                    selectedOrg: selectedOrg
                });
                break;
            case $bd520608efc7e7f4$var$AuthState.RELOAD:
                this._accountClusterPromise = (0, $3LITL.initializeShellDataForReload)({
                    selectedOrg: selectedOrg || activeOrg
                });
                break;
            default:
                // No response if user is not authenticated, return undefined.
                this._accountClusterPromise = Promise.resolve(undefined);
        }
        return this._accountClusterPromise;
    }
    get localSolutions() {
        if (this._devMode && this._localConfigs.solutions) return this._localConfigs.solutions;
    }
    get metricsEnv() {
        return this._metricsEnv;
    }
    get activeCdn() {
        return this._activeCdn;
    }
    get clientId() {
        return this._clientId;
    }
    sameOriginUnderAutomation() {
        const w = window;
        const config = w.Cypress?.config ? w.Cypress.config() : {};
        if ("iframeUseSameOrigin" in config) return !!config.iframeUseSameOrigin;
        return true;
    }
    getAutomationClient() {
        const w = window;
        const config = w.Cypress?.config ? w.Cypress.config() : {}; // Developers can add the `UnifiedShellTestClient` property on the window
        // to tell the Shell which client ID to use.
        if (w.UnifiedShellTestClient && !Object.keys(config).length) config[$bd520608efc7e7f4$var$AUTOMATION_CLIENT_HOLDER] = w.UnifiedShellTestClient === "inherit" ? $bd520608efc7e7f4$var$UNIFIED_SHELL_CLIENTID : w.UnifiedShellTestClient;
        return w[$bd520608efc7e7f4$var$AUTOMATION_CLIENT_HOLDER] || config[$bd520608efc7e7f4$var$AUTOMATION_CLIENT_HOLDER] || "";
    }
}
let $bd520608efc7e7f4$var$bootstrap;
/**
 * Returns an instance of the Bootstrap service.
 */ const $bd520608efc7e7f4$var$getBootstrap = ()=>{
    if (!$bd520608efc7e7f4$var$bootstrap) $bd520608efc7e7f4$var$bootstrap = new $bd520608efc7e7f4$var$BootstrapServiceImpl();
    return $bd520608efc7e7f4$var$bootstrap;
};
module.exports.getBootstrap = $bd520608efc7e7f4$var$getBootstrap;

});
parcelRegister("jBKJw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.waitForPingSuccess = module.exports.checkCDN = module.exports.setPingEndpoint = void 0;

var $iNslS = parcelRequire("iNslS");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $ee7e5aadbac30ccf$var$GEO_HEADER = "x-geo";
const $ee7e5aadbac30ccf$var$PING_ENDPOINT = "/check/ping.json";
const $ee7e5aadbac30ccf$var$PING_TIMEOUT = 20000;
const $ee7e5aadbac30ccf$var$MAX_DELAY = 8000;
let $ee7e5aadbac30ccf$var$pingPromise;
let $ee7e5aadbac30ccf$var$cdn = "";
const $ee7e5aadbac30ccf$var$setPingEndpoint = (config)=>{
    // We should only ping Front Door, hence using API Gateway instead of CDN.
    // This is because Cloudfront does not have a ping endpoint yet.
    $ee7e5aadbac30ccf$var$cdn = config.endpoints.apiGateway;
};
module.exports.setPingEndpoint = $ee7e5aadbac30ccf$var$setPingEndpoint;
const $ee7e5aadbac30ccf$var$ping = async (pingTimeout = $ee7e5aadbac30ccf$var$PING_TIMEOUT)=>{
    const controller = new AbortController();
    const signal = controller.signal;
    let country = "";
    const start = Date.now();
    let duration = 0;
    const timeout = setTimeout(()=>controller.abort(), pingTimeout);
    try {
        // Use Date.now() for cache busting
        const url = `${$ee7e5aadbac30ccf$var$cdn}${$ee7e5aadbac30ccf$var$PING_ENDPOINT}?cacheBust=${start}`;
        const res = await fetch(url, {
            signal: signal
        });
        clearTimeout(timeout);
        duration = Date.now() - start;
        country = res.headers.get($ee7e5aadbac30ccf$var$GEO_HEADER) || "";
        if (res.ok) return {
            country: country,
            duration: duration,
            success: true
        };
        return {
            country: country,
            duration: duration,
            errorDescription: `${res.status} - ${res.statusText}`,
            success: false
        };
    } catch (err) {
        clearTimeout(timeout);
        duration = duration || Date.now() - start;
        let errorDescription = (0, $iNslS.getErrorMessage)(err);
        if (controller.signal.aborted) errorDescription = `Aborted after ${$ee7e5aadbac30ccf$var$PING_TIMEOUT}ms`;
        return {
            duration: duration,
            errorDescription: errorDescription,
            success: false
        };
    }
};
const $ee7e5aadbac30ccf$var$checkCDN = ()=>{
    if (!$ee7e5aadbac30ccf$var$pingPromise) $ee7e5aadbac30ccf$var$pingPromise = $ee7e5aadbac30ccf$var$ping();
    return $ee7e5aadbac30ccf$var$pingPromise;
};
module.exports.checkCDN = $ee7e5aadbac30ccf$var$checkCDN;
const $ee7e5aadbac30ccf$var$waitForPingSuccess = async (onSuccess)=>{
    let inPing = false;
    let delay = 1000;
    const pingOnce = async ()=>{
        if (!inPing) {
            inPing = true;
            try {
                const { success: success } = await $ee7e5aadbac30ccf$var$ping(5000);
                inPing = false;
                if (success) return onSuccess();
            } catch  {
                inPing = false;
            }
            delay = Math.min(delay * 2, $ee7e5aadbac30ccf$var$MAX_DELAY);
            setTimeout(pingOnce, delay);
        }
    };
    setTimeout(pingOnce, delay);
};
module.exports.waitForPingSuccess = $ee7e5aadbac30ccf$var$waitForPingSuccess;

});
parcelRegister("iNslS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.markEventsPerformance = $daf2cbaf2596b644$var$markEventsPerformance;
module.exports.extractTokenMetadata = $daf2cbaf2596b644$var$extractTokenMetadata;
module.exports.getOperationName = $daf2cbaf2596b644$var$getOperationName;
Object.defineProperty(module.exports, "Events", {
    enumerable: true,
    get: function() {
        return $8u9YV.Events;
    }
});
Object.defineProperty(module.exports, "EventsThirdParty", {
    enumerable: true,
    get: function() {
        return $8u9YV.EventsThirdParty;
    }
});
module.exports.isAWSOrgRegion = module.exports.digitalDataUpdated = module.exports.sanitizeConfiguration = module.exports.KEYS_WITH_PII = module.exports.runWithTimeout = module.exports.getErrorMessage = module.exports.NOOP = module.exports.wait = module.exports.throttleQueue = module.exports.BROWSER_FILTER_PARAMS = void 0;

var $8u9YV = parcelRequire("8u9YV");
var $daf2cbaf2596b644$var$__assign = function() {
    $daf2cbaf2596b644$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $daf2cbaf2596b644$var$__assign.apply(this, arguments);
};
var $daf2cbaf2596b644$var$DEFAULT_EXPIRES_IN = 3600000; // Contains the events that should be marked.
var $daf2cbaf2596b644$var$eventsMapping = {};
var $daf2cbaf2596b644$var$BROWSER_FILTER_PARAMS = new Set([
    "_mr",
    "shell_domain",
    "shell_forceReload"
]);
/**
 * Setup the events marker by using the filter approach documented here:
 * https://git.corp.adobe.com/exc/metrics-sdk-js/blob/master/README.md#filter
 * @param win Window object
 * @param eventsToMark An array of events to be marked
 * @param transformFunc a function to transform event names used to enforce a naming convention.
 */ module.exports.BROWSER_FILTER_PARAMS = $daf2cbaf2596b644$var$BROWSER_FILTER_PARAMS;
function $daf2cbaf2596b644$var$markEventsPerformance(win, eventsToMark, transformFunc) {
    if (transformFunc === void 0) transformFunc = function(a) {
        return a;
    };
    var performance = win.performance, internal = win["exc-module-runtime"].internal; // Filter function
    function metricsWrite(record) {
        if (record.event) {
            var events = Array.isArray(record.event) ? record.event : [
                record.event
            ];
            events.forEach(function(event) {
                return event in $daf2cbaf2596b644$var$eventsMapping && performance.mark($daf2cbaf2596b644$var$eventsMapping[event]);
            });
        }
        return Promise.resolve(record);
    }
    eventsToMark.forEach(function(event) {
        $daf2cbaf2596b644$var$eventsMapping[event] = transformFunc(event);
    });
    if (typeof (performance === null || performance === void 0 ? void 0 : performance.mark) === "function") internal.setFilter(metricsWrite);
}
/**
 * Throttle function invocations. Used to batch certain operations such as queue processing.
 * @param fn - Function
 * @param timeout - Throttling timeout (ms)
 * @param immediateAfterIdle - If there were no invocations for the defined period
 * (timeoutMs), process immediatelly.
 * @param win - Window
 */ var $daf2cbaf2596b644$var$throttleQueue = function(fn, timeout, immediateAfterIdle, win) {
    if (immediateAfterIdle === void 0) immediateAfterIdle = false;
    if (win === void 0) win = window;
    var setTimeout = win.setTimeout;
    var ready = true;
    var lastInvocation = Date.now();
    return function() {
        var _this = this;
        if (ready) {
            if (immediateAfterIdle && Date.now() - lastInvocation > timeout) {
                fn.apply(this);
                lastInvocation = Date.now();
                return;
            }
            ready = false;
            setTimeout(function() {
                fn.apply(_this);
                lastInvocation = Date.now();
                ready = true;
            }, timeout);
        }
    };
};
/**
 * Extracts metadata from the IMS token by base64 decoding the middle section
 * and parsing it into JSON.
 * @param {string} token The IMS token to extract metadata from.
 * @returns {Object} The extracted metadata.
 */ module.exports.throttleQueue = $daf2cbaf2596b644$var$throttleQueue;
function $daf2cbaf2596b644$var$extractTokenMetadata(token) {
    try {
        var middleBits = token.split(".")[1];
        var tokenMetadata = JSON.parse(atob(middleBits));
        tokenMetadata.created_at = parseInt(tokenMetadata.created_at, 10) || Date.now();
        tokenMetadata.expires_in = parseInt(tokenMetadata.expires_in, 10) || $daf2cbaf2596b644$var$DEFAULT_EXPIRES_IN;
        return tokenMetadata;
    } catch (_a) {
        return null;
    }
}
var $daf2cbaf2596b644$var$wait = function(ms, win) {
    if (win === void 0) win = window;
    return new Promise(function(resolve) {
        return win.setTimeout(resolve, ms);
    });
};
module.exports.wait = $daf2cbaf2596b644$var$wait;
var $daf2cbaf2596b644$var$NOOP = function() {};
module.exports.NOOP = $daf2cbaf2596b644$var$NOOP;
function $daf2cbaf2596b644$var$getOperationName(query) {
    if (query === void 0) query = "";
     // Extract operation name from query
    var name = /(query|mutation) ?(\w+)/.exec(query);
    return name && name.length ? name[2] : undefined;
}
var $daf2cbaf2596b644$var$getErrorMessage = function(err, defaultMessage) {
    if (defaultMessage === void 0) defaultMessage = "Unknown Error";
    if (err && typeof err === "object" && typeof err.message === "string") return err.message;
    if (typeof err === "string") return err;
    return defaultMessage;
};
/**
 * Awaits a promise up to a certain timeout.
 * If the timeout is due before the promise resolves, resolves with a predefined payload.
 * @template T
 * @param promise to await.
 * @param timeout - Timeout (ms)
 * @param timeoutResponse - Timeout response
 * @param win - Window
 */ module.exports.getErrorMessage = $daf2cbaf2596b644$var$getErrorMessage;
var $daf2cbaf2596b644$var$runWithTimeout = function(promise, timeout, timeoutResponse, win) {
    if (win === void 0) win = window;
    return Promise.race([
        promise,
        new Promise(function(resolve) {
            return win.setTimeout(function() {
                return resolve(timeoutResponse);
            }, timeout);
        })
    ]);
};
module.exports.runWithTimeout = $daf2cbaf2596b644$var$runWithTimeout;
var $daf2cbaf2596b644$var$KEYS_WITH_PII = new Set([
    "imsInfo",
    "imsProfile",
    "imsToken",
    "shellInfo"
]);
module.exports.KEYS_WITH_PII = $daf2cbaf2596b644$var$KEYS_WITH_PII;
var $daf2cbaf2596b644$var$sanitizeConfiguration = function(config) {
    var sanitized = $daf2cbaf2596b644$var$__assign({}, config);
    $daf2cbaf2596b644$var$KEYS_WITH_PII.forEach(function(piiKey) {
        return delete sanitized[piiKey];
    });
    return sanitized;
};
module.exports.sanitizeConfiguration = $daf2cbaf2596b644$var$sanitizeConfiguration;
var $daf2cbaf2596b644$var$digitalDataUpdated = function(detail, win) {
    if (win === void 0) win = window;
    return win.dispatchEvent(new CustomEvent("digitalData", {
        detail: detail
    }));
};
/**
 * Validate if the region is an AWS org region for determining the correct URL to hit.
 * @param region - Region to validate.
 * @returns Whether or not the region is an AWS org region.
 */ module.exports.digitalDataUpdated = $daf2cbaf2596b644$var$digitalDataUpdated;
var $daf2cbaf2596b644$var$AWS_REGIONS = new Set([
    "VA6"
]);
var $daf2cbaf2596b644$var$isAWSOrgRegion = function(region) {
    return $daf2cbaf2596b644$var$AWS_REGIONS.has(region);
};
module.exports.isAWSOrgRegion = $daf2cbaf2596b644$var$isAWSOrgRegion;

});
parcelRegister("8u9YV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = module.exports.EventsThirdParty = void 0;
var $62d8de3c02caa31d$var$__assign = function() {
    $62d8de3c02caa31d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $62d8de3c02caa31d$var$__assign.apply(this, arguments);
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // Events that are sent by our own code as opposed to messages receieved through API calls
var $62d8de3c02caa31d$var$InternalEvents = {
    ACTIVE: "ACTIVE",
    CLICK: "CLICK",
    COACH_MARK_POSITIONED: "COACH_MARK_POSITIONED",
    COMPONENT_CLOSE_COMPLETE: "COMPONENT_CLOSE_COMPLETE",
    DEPRECATION_WARNING: "DEPRECATION_WARNING",
    DONE: "DONE",
    FOCUS: "FOCUS",
    GAINSIGHT_INIT: "GAINSIGHT_INIT",
    GLOBAL_DIALOG_OPEN: "GLOBAL_DIALOG_OPEN",
    HERO_CLICK: "HERO_CLICK",
    HISTORY: "HISTORY",
    KEYPRESS: "KEYPRESS",
    LOST_AUTH: "LOST_AUTH",
    NOT_INITIALIZED: "NOT_INITIALIZED",
    NPS: "NPS",
    PING: "PING",
    PONG: "PONG",
    QUEUE: "QUEUE",
    READY: "READY",
    RECENT_EVENT: "RECENT_EVENT",
    SKIP_MENU_FOCUS: "SKIP_MENU_FOCUS",
    TOAST_SUPRESSED: "TOAST_SUPRESSED",
    USER_INPUT: "USER_INPUT"
}; // Internal events and APIs that are approved for 3rd party use
var $62d8de3c02caa31d$var$EventsThirdParty = $62d8de3c02caa31d$var$__assign($62d8de3c02caa31d$var$__assign({}, $62d8de3c02caa31d$var$InternalEvents), {
    AUTH_EXPIRATION: "AUTH_EXPIRATION",
    BLOCK_NAVIGATION: "BLOCK_NAVIGATION",
    CAN_TAKEOVER: "CAN_TAKEOVER",
    CONFIGURE: "CONFIGURE",
    CUSTOM_FEEDBACK: "CUSTOM_FEEDBACK",
    CUSTOM_HELP_BUTTON_CLICK: "CUSTOM_HELP_BUTTON_CLICK",
    CUSTOM_SEARCH: "CUSTOM_SEARCH",
    DATA_FULFILL: "DATA_FULFILL",
    DATA_REQUEST: "DATA_REQUEST",
    IFRAME_RELOAD: "IFRAME_RELOAD",
    MODULES_DATA: "MODULES_DATA",
    NOT_FOUND: "NOT_FOUND",
    OPEN_HELP_CENTER: "OPEN_HELP_CENTER",
    PERMISSIONS: "PERMISSIONS",
    SHELL_REDIRECT: "SHELL_REDIRECT",
    SHELL_SETTINGS: "SHELL_SETTINGS",
    SKIP_MENU_GET_LIST: "SKIP_MENU_GET_LIST",
    SKIP_MENU_SET_LIST: "SKIP_MENU_SET_LIST"
}); // All internal events and APIs
module.exports.EventsThirdParty = $62d8de3c02caa31d$var$EventsThirdParty;
var $62d8de3c02caa31d$var$Events = $62d8de3c02caa31d$var$__assign($62d8de3c02caa31d$var$__assign({}, $62d8de3c02caa31d$var$EventsThirdParty), {
    AEM_INSTANCES: "AEM_INSTANCES",
    AFTER_PRINT_HANDLER: "AFTER_PRINT_HANDLER",
    AI_MESSAGE: "AI_MESSAGE",
    APP_CACHE: "APP_CACHE",
    APP_DATA: "APP_DATA",
    BEFORE_PRINT_HANDLER: "BEFORE_PRINT_HANDLER",
    CLIPBOARD_WRITE: "CLIPBOARD_WRITE",
    COMPONENT_CLOSE: "COMPONENT_CLOSE",
    COMPONENT_OPEN: "COMPONENT_OPEN",
    CONSENT_GET: "CONSENT_GET",
    CONSENT_UPDATE: "CONSENT_UPDATE",
    CUSTOM_HERO_CLICK: "CUSTOM_HERO_CLICK",
    CUSTOM_LEFT_NAV_CLICK: "CUSTOM_LEFT_NAV_CLICK",
    CUSTOM_PROFILE_BUTTON_CLICK: "CUSTOM_PROFILE_BUTTON_CLICK",
    CUSTOM_PROFILE_CLICK: "CUSTOM_PROFILE_CLICK",
    CUSTOM_TOKEN: "CUSTOM_TOKEN",
    DATA_PREFETCH: "DATA_PREFETCH",
    EXC_PULSE: "EXC_PULSE",
    EXC_SETTINGS: "EXC_SETTINGS",
    EXTENDED_SHELL_INFO: "EXTENDED_SHELL_INFO",
    FEATURE_FLAGS: "FEATURE_FLAGS",
    FEEDBACK_CONFIG: "FEEDBACK_CONFIG",
    FULFILLABLE_ITEMS: "FULFILLABLE_ITEMS",
    GENERATE_SUBORG: "GENERATE_SUBORG",
    JIRA_SUBMIT: "JIRA_SUBMIT",
    NAV_ITEM_CLICK: "NAV_ITEM_CLICK",
    PRINT_NOW: "PRINT_NOW",
    PULSE_BUTTON: "PULSE_BUTTON",
    RUNTIME_REQ: "RUNTIME_REQ",
    RUNTIME_RESP: "RUNTIME_RESP",
    SESSION: "SESSION",
    SPA_SRC_DOC: "SPA_SRC_DOC",
    TITLE: "TITLE",
    TRIGGER_NPS: "TRIGGER_NPS"
});
module.exports.Events = $62d8de3c02caa31d$var$Events;

});



parcelRegister("hCG2Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCurrentTenantAndPath = module.exports.getTenantAndPath = module.exports.cleanTokenFromHash = module.exports.getQueryValue = module.exports.getQueryParams = module.exports.hashToPath = void 0;

var $9B59M = parcelRequire("9B59M");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /**
 * Removes #/ from the hash.
 * @param options - Object containing optional hash and option to remove first /.
 * @returns Cleaned hash.
 */ var $cd469a0050209d85$var$hashToPath = function(options) {
    if (options === void 0) options = {};
    var hash = options.hash !== undefined ? options.hash : window.location.hash;
    return options.removePrecedingSlash ? hash.replace(/^#\//, "") : hash.replace(/^#/, "");
};
/**
 * Get query params from string or window location.
 * @param {string} query - Full query string.
 * @returns {Object} Query params and values.
 */ module.exports.hashToPath = $cd469a0050209d85$var$hashToPath;
var $cd469a0050209d85$var$getQueryParams = function(query) {
    return (0, $9B59M.parse)((query || window.location.search).replace(/^\?/, ""));
};
/**
 * Get the value of a 'shell_' config query param.
 * @param {string} path - Name of shell config param.
 * @returns {string} Value of the query parameter.
 */ module.exports.getQueryParams = $cd469a0050209d85$var$getQueryParams;
var $cd469a0050209d85$var$getQueryValue = function(param, prefix) {
    if (prefix === void 0) prefix = "shell";
    return $cd469a0050209d85$var$getQueryParams()["".concat(prefix, "_").concat(param)];
};
/**
 * Cleans token information from the url and returns the new hash.
 * @param hash - The hash string to clean.
 * @returns Cleaned path.
 */ module.exports.getQueryValue = $cd469a0050209d85$var$getQueryValue;
var $cd469a0050209d85$var$cleanTokenFromHash = function(hash) {
    var tokenRegex = /#?access_token=[^&]*&token_type=bearer&expires_in=\d*/;
    if (hash.match(tokenRegex)) return hash.replace(tokenRegex, "");
};
module.exports.cleanTokenFromHash = $cd469a0050209d85$var$cleanTokenFromHash;
var $cd469a0050209d85$var$getTenantAndPath = function(path) {
    var tenant;
    var matches = path.match(/^(\/@([^/]*))?(\/.*)$/);
    if (matches) {
        path = matches[3];
        tenant = matches[2];
    }
    return {
        path: path,
        tenant: tenant
    };
};
module.exports.getTenantAndPath = $cd469a0050209d85$var$getTenantAndPath;
var $cd469a0050209d85$var$getCurrentTenantAndPath = function() {
    var _a = window.location, hash = _a.hash, origin = _a.origin;
    var path = $cd469a0050209d85$var$hashToPath({
        hash: hash
    });
    if (!path.startsWith("/")) // If getCurrentTenantAndPath is called before "createHashHistory" is called
    // the hash might not start with /. This can happen right after login where hash
    // has the form of #old_hash=xxx - As a future improvement this method can try to
    // extract the tenant from old_hash, this is already done in prefetch-token.js
    return $cd469a0050209d85$var$getTenantAndPath("/");
     // Now that we have correct hash value, we can convert it into a path and
    // then parse it to find the tenant and path properties.
    var pathname = new URL("".concat(origin).concat(path)).pathname;
    return $cd469a0050209d85$var$getTenantAndPath(pathname);
};
module.exports.getCurrentTenantAndPath = $cd469a0050209d85$var$getCurrentTenantAndPath;

});
parcelRegister("9B59M", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $6fcb91c2478659e7$export$98e6a39c04603d36; }, function (v) { return $6fcb91c2478659e7$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $6fcb91c2478659e7$export$fac44ee5b035f737; }, function (v) { return $6fcb91c2478659e7$export$fac44ee5b035f737 = v; });
var $6fcb91c2478659e7$export$2f872c0f2117be69;
var $6fcb91c2478659e7$export$98e6a39c04603d36;
var $6fcb91c2478659e7$export$c564cdbbe6da493;
var $6fcb91c2478659e7$export$fac44ee5b035f737;
"use strict";

$6fcb91c2478659e7$export$2f872c0f2117be69 = $6fcb91c2478659e7$export$98e6a39c04603d36 = (parcelRequire("g4AJw"));

$6fcb91c2478659e7$export$c564cdbbe6da493 = $6fcb91c2478659e7$export$fac44ee5b035f737 = (parcelRequire("2FE0d"));

});
parcelRegister("g4AJw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $bb398382ab8c9588$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$bb398382ab8c9588$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($bb398382ab8c9588$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $bb398382ab8c9588$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRegister("2FE0d", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $1f1e70c6fe9dbc74$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $1f1e70c6fe9dbc74$var$map($1f1e70c6fe9dbc74$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($1f1e70c6fe9dbc74$var$stringifyPrimitive(k)) + eq;
        if ($1f1e70c6fe9dbc74$var$isArray(obj[k])) return $1f1e70c6fe9dbc74$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($1f1e70c6fe9dbc74$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($1f1e70c6fe9dbc74$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($1f1e70c6fe9dbc74$var$stringifyPrimitive(name)) + eq + encodeURIComponent($1f1e70c6fe9dbc74$var$stringifyPrimitive(obj));
};
var $1f1e70c6fe9dbc74$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $1f1e70c6fe9dbc74$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $1f1e70c6fe9dbc74$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("1HQDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getConfiguration = module.exports.getServiceEnvironment = void 0;

var $ehZqD = parcelRequire("ehZqD");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $e51a0eb526d64c06$var$BASE_CONFIG = {
    endpoints: {
        apiGateway: "https://exc-unifiedcontent.experience-qa.adobe.net",
        cdn: "https://experience-qa.adobe.net",
        // QA does not have a CDN.
        ioGateway: "https://experience-qa.adobe.io",
        regionGatewayIoMap: {
            va7: "https://experience-qa.adobe.io"
        },
        translation: "https://mt-stage.adobe.io",
        xql: "https://platform-int.adobe.io/data/xql/graphql"
    }
};
const $e51a0eb526d64c06$var$PROD_CONFIG = {
    ...$e51a0eb526d64c06$var$BASE_CONFIG,
    endpoints: {
        apiGateway: "https://exc-unifiedcontent.experience.adobe.net",
        cdn: "https://cdn.experience.adobe.net",
        ioGateway: "https://experience.adobe.io",
        regionGatewayIoMap: {
            aus5: "https://experience-aus5.adobe.io",
            nld2: "https://experience-nld2.adobe.io",
            va7: "https://experience-va7.adobe.io"
        },
        translation: "https://mt.adobe.io",
        xql: "https://platform.adobe.io/data/xql/graphql"
    }
};
/* eslint-disable sort-keys */ const $e51a0eb526d64c06$var$ENV_TO_IMS = {
    test: "stage",
    dev: "stage",
    qa: "stage",
    stage: "stage",
    prod: "prod"
};
/* eslint-enable sort-keys */ const $e51a0eb526d64c06$var$getServiceEnvironment = (env, imsEnv)=>{
    if (env === "prod" && imsEnv === "stage") return "stage";
    return imsEnv === "prod" ? "prod" : env;
};
module.exports.getServiceEnvironment = $e51a0eb526d64c06$var$getServiceEnvironment;
const $e51a0eb526d64c06$var$getConfiguration = (config, clientId, imsEnv = "")=>{
    const { cdn: cdn = "", environment: environment = "dev", iframeUseSameOrigin: iframeUseSameOrigin = false, scripts: scripts = {}, scriptsPath: scriptsPath = "/assets", region: region } = config;
    const faviconDefault = document.querySelector('link[rel*="icon"]');
    const configEnvMap = {
        dev: $e51a0eb526d64c06$var$BASE_CONFIG,
        prod: $e51a0eb526d64c06$var$PROD_CONFIG,
        qa: $e51a0eb526d64c06$var$BASE_CONFIG,
        stage: {
            ...$e51a0eb526d64c06$var$BASE_CONFIG,
            endpoints: {
                ...$e51a0eb526d64c06$var$BASE_CONFIG.endpoints,
                apiGateway: "https://exc-unifiedcontent.experience-stage.adobe.net",
                cdn: "https://cdn.experience-stage.adobe.net",
                ioGateway: "https://experience-stage.adobe.io",
                regionGatewayIoMap: {
                    nld2: "https://experience-stage-nld2.adobe.io",
                    va7: "https://experience-stage-va7.adobe.io"
                },
                xql: "https://platform-stage.adobe.io/data/xql/graphql"
            }
        },
        test: $e51a0eb526d64c06$var$BASE_CONFIG
    };
    if (!(environment in configEnvMap)) throw new Error(`Invalid environment ${environment}`);
    const defaultConfig = {
        environment: environment,
        favicon: faviconDefault ? faviconDefault.href : undefined,
        iframeUseSameOrigin: iframeUseSameOrigin,
        ims: (0, $ehZqD.getIMSConfig)(imsEnv || $e51a0eb526d64c06$var$ENV_TO_IMS[environment], clientId),
        serviceEnvironment: $e51a0eb526d64c06$var$getServiceEnvironment(environment, imsEnv)
    };
    const environmentConfig = imsEnv ? configEnvMap[imsEnv] : configEnvMap[environment];
    return {
        cdn: cdn,
        region: region,
        scripts: scripts,
        scriptsPath: scriptsPath,
        ...defaultConfig,
        ...environmentConfig
    };
};
module.exports.getConfiguration = $e51a0eb526d64c06$var$getConfiguration;

});
parcelRegister("ehZqD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIMSConfig = module.exports.getRedirectUri = void 0;

var $k6Zw0 = parcelRequire("k6Zw0");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $119dd9c7cbbe2d85$var$getRedirectUri = (win = window)=>{
    const { href: href } = win.location;
    const domain = /https?:\/\/(.+\.)experience/.exec(href);
    return domain ? href.replace(domain[1], "") : href;
};
module.exports.getRedirectUri = $119dd9c7cbbe2d85$var$getRedirectUri;
const $119dd9c7cbbe2d85$var$getIMSConfig = (environment, clientId, scopes)=>({
        client_id: clientId,
        environment: environment,
        redirect_uri: $119dd9c7cbbe2d85$var$getRedirectUri(),
        scope: scopes || (environment === "prod" ? $k6Zw0.SHELL_PROD_SCOPES : $k6Zw0.SHELL_STAGE_SCOPES)
    });
module.exports.getIMSConfig = $119dd9c7cbbe2d85$var$getIMSConfig;

});
parcelRegister("k6Zw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHELL_STAGE_SCOPES = module.exports.SHELL_PROD_SCOPES = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $f27c566b5df1ff96$var$SHELL_PROD_SCOPES = [
    "ab.manage",
    "account_cluster.read",
    "additional_info",
    "additional_info.job_function",
    "additional_info.projectedProductContext",
    "additional_info.roles",
    "AdobeID",
    "adobeio.appregistry.read",
    "adobeio_api",
    "audiencemanager_api",
    "creative_cloud",
    "mps",
    "openid",
    "org.read",
    "pps.read",
    "read_organizations",
    "read_pc",
    "read_pc.acp",
    "read_pc.dma_tartan",
    "session"
].join(",");
module.exports.SHELL_PROD_SCOPES = $f27c566b5df1ff96$var$SHELL_PROD_SCOPES;
const $f27c566b5df1ff96$var$SHELL_STAGE_SCOPES = [
    "ab.manage",
    "account_cluster.read",
    "additional_info",
    "additional_info.job_function",
    "additional_info.projectedProductContext",
    "additional_info.roles",
    "AdobeID",
    "adobeio.appregistry.read",
    "adobeio_api",
    "audiencemanager_api",
    "creative_cloud",
    "mps",
    "openid",
    "org.read",
    "pps.read",
    "read_organizations",
    "read_pc",
    "read_pc.acp",
    "read_pc.dma_tartan",
    "session"
].join(",");
module.exports.SHELL_STAGE_SCOPES = $f27c566b5df1ff96$var$SHELL_STAGE_SCOPES;

});



parcelRegister("7CZdW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateCachedConsent = module.exports.onConsent = module.exports.getCachedConsent = void 0;

var $iJaYo = parcelRequire("iJaYo");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $c9c93c02ff971be2$var$CONSENT_STORAGE_KEY = "shellUserConsent";
const $c9c93c02ff971be2$var$STORAGE_DURATION = 315360000000; // 10 years
const $c9c93c02ff971be2$var$getCachedConsent = ()=>{
    try {
        return $iJaYo.storage.local.getSync($c9c93c02ff971be2$var$CONSENT_STORAGE_KEY);
    } catch  {
        return null;
    }
};
module.exports.getCachedConsent = $c9c93c02ff971be2$var$getCachedConsent;
const $c9c93c02ff971be2$var$onConsent = (data, metrics, updateStorage = true)=>{
    if (typeof data?.adobeUsageDataCollection === "boolean") {
        window.adobeMetrics?.optOut?.(!data.adobeUsageDataCollection);
        metrics.event(data.adobeUsageDataCollection ? "EIM_OPT_IN" : "EIM_OPT_OUT");
    }
    data && updateStorage && $c9c93c02ff971be2$var$updateCachedConsent(data);
};
module.exports.onConsent = $c9c93c02ff971be2$var$onConsent;
const $c9c93c02ff971be2$var$updateCachedConsent = (data)=>{
    const cached = $c9c93c02ff971be2$var$getCachedConsent();
    return $iJaYo.storage.local.set($c9c93c02ff971be2$var$CONSENT_STORAGE_KEY, {
        ...cached,
        ...data
    }, $c9c93c02ff971be2$var$STORAGE_DURATION);
};
module.exports.updateCachedConsent = $c9c93c02ff971be2$var$updateCachedConsent;

});
parcelRegister("iJaYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "storage", {
    enumerable: true,
    get: function() {
        return $fwqnC.storage;
    }
});
Object.defineProperty(module.exports, "getLocalCache", {
    enumerable: true,
    get: function() {
        return $fapYZ.getLocalCache;
    }
});
Object.defineProperty(module.exports, "getSessionCache", {
    enumerable: true,
    get: function() {
        return $fapYZ.getSessionCache;
    }
});

var $fwqnC = parcelRequire("fwqnC");

var $fapYZ = parcelRequire("fapYZ");

});
parcelRegister("fwqnC", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.storage = exports.StorageInstance = void 0;

var _metrics = _interopRequireDefault((parcelRequire("17AVh")));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var __assign = function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ var EXPIRE_ON_LOGOUT = 0; // Theshold for storage is 1MB
var THRESHOLD = 1000000;
var compression;


var StorageInstance = /** @class */ function() {
    function StorageInstance(windowStorage) {
        var _this = this;
        this.metrics = _metrics.default.create("exc.storage.Storage");
        var expirationDict = windowStorage.getItem("shellStorageExpiration");
        this.expirationDict = expirationDict ? JSON.parse(expirationDict) : {};
        this.storage = windowStorage;
        setInterval(function() {
            return _this.trackExpiration();
        }, 60000);
    }
    /**
   * Returns item from storage.
   * @param key Key with which to query storage.
   * @returns Promise which resolves to the value in storage.
   */ StorageInstance.prototype.get = function(key) {
        return __awaiter(this, void 0, Promise, function() {
            var _a, compressed, json, _b;
            return __generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this.getFromStorage(key) || {}, compressed = _a.compressed, json = _a.json;
                        if (!json) return [
                            2,
                            null
                        ];
                        if (!(compressed === "Y")) return [
                            3,
                            3
                        ];
                        _b = compression;
                        if (_b) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.resolve().then(function() {
                                return (parcelRequire("uYURx"));
                            }).then((res)=>_interopRequireWildcard(res))
                        ];
                    case 1:
                        _b = _c.sent();
                        _c.label = 2;
                    case 2:
                        compression = _b;
                        json = compression.decompress(json, key);
                        _c.label = 3;
                    case 3:
                        return [
                            2,
                            JSON.parse(json)
                        ];
                }
            });
        });
    };
    /**
   * Pull data from storage and do some small checks to ensure it's valid.
   * @param key Key with which to query storage.
   * @returns compressed and json values or null.
   */ StorageInstance.prototype.getFromStorage = function(key) {
        var stringValue = this.storage.getItem(key);
        if (!stringValue) return null;
         // Split the compressed/json part from the rest.
        var _a = stringValue.split(/\|(.+)/), compressed = _a[0], json = _a[1];
        if (!json) {
            this.remove(key);
            return null;
        }
        var expirationTime = this.expirationDict[key]; // If the key has expired, remove it
        if (expirationTime > 0 && expirationTime < Date.now()) {
            this.metrics.event("storage expiration", "Key ".concat(key, " expired at ").concat(expirationTime), {
                expirationTime: expirationTime,
                key: key
            });
            this.remove(key);
            return null;
        }
        return {
            compressed: compressed,
            json: json
        };
    };
    /**
   * Sychronous version of get. Compression is NOT supported in this method.
   * @param key Key with which to query storage.
   * @returns Value in storage.
   */ StorageInstance.prototype.getSync = function(key) {
        var _a = this.getFromStorage(key) || {}, compressed = _a.compressed, json = _a.json;
        return json && compressed === "N" ? JSON.parse(json) : null;
    };
    /**
   * Returns item expiration time for the key.
   * @param expirationInMs Expiration time to be set.
   * @returns 0 if it expires at logout, or the expiration time.
   */ StorageInstance.prototype.getExpireTime = function(expirationInMs) {
        return expirationInMs ? Date.now() + expirationInMs : EXPIRE_ON_LOGOUT;
    };
    /**
   * Stores the updated expirationDict in storage.
   */ StorageInstance.prototype.storeExpirationDictionary = function() {
        try {
            this.storage.setItem("shellStorageExpiration", JSON.stringify(this.expirationDict));
        } catch (domException) {
            if (domException instanceof DOMException) this.metrics.warn("Failed to set expiration dictionary in storage.", {
                error: domException.name
            });
        }
    };
    /**
   * Updates a key
   * @template T
   * @param key Key with which to query storage.
   * @param value T Value must be an object of key value pairs.
   * @param expirationInMs Expiration time for the storage entry.
   * @param compress Whether or not to force compress.
   */ StorageInstance.prototype.update = function(key, value, expirationInMs, compress) {
        return __awaiter(this, void 0, Promise, function() {
            var storedValue;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.get(key)
                        ];
                    case 1:
                        storedValue = _a.sent() || {};
                        storedValue = __assign(__assign({}, storedValue), value);
                        this.set(key, storedValue, expirationInMs, compress);
                        return [
                            2
                        ];
                }
            });
        });
    };
    /**
   * Sets a key value pair in browser storage.
   * @param key Key with which to query storage.
   * @param value Value to be put into storage
   * @param expirationInMs Expiration time for the storage entry.
   * @param compress Whether or not to force compress.
   */ StorageInstance.prototype.set = function(key, value, expirationInMs, compress) {
        return __awaiter(this, void 0, Promise, function() {
            var json, compressed, expirationTimestamp, _a;
            return __generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        json = JSON.stringify(value);
                        compressed = false;
                        expirationTimestamp = this.getExpireTime(expirationInMs);
                        if (!(json.length > THRESHOLD || compress)) return [
                            3,
                            3
                        ];
                        _a = compression;
                        if (_a) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.resolve().then(function() {
                                return (parcelRequire("uYURx"));
                            }).then((res)=>_interopRequireWildcard(res))
                        ];
                    case 1:
                        _a = _b.sent();
                        _b.label = 2;
                    case 2:
                        compression = _a;
                        json = compression.compress(json, key);
                        compressed = true;
                        _b.label = 3;
                    case 3:
                        try {
                            this.storage.setItem(key, "".concat(compressed ? "Y" : "N", "|").concat(json));
                        } catch (domException) {
                            if (domException instanceof DOMException) this.metrics.warn("Failed to set item in storage.", {
                                compressed: compressed,
                                error: domException.name,
                                key: key,
                                rawSize: json.length
                            });
                        }
                        this.storeExpireTime(key, expirationTimestamp);
                        return [
                            2
                        ];
                }
            });
        });
    };
    /**
   * Removes item from storage.
   * @param key Key with which to query storage.
   */ StorageInstance.prototype.remove = function(key) {
        this.storage.removeItem(key);
        delete this.expirationDict[key];
        this.storeExpirationDictionary();
    };
    /**
   * Clears all values or those determined by a filter function.
   * @param filter Function to filter which keys to clear
   */ StorageInstance.prototype.clear = function(filter) {
        var _this = this;
        Object.keys(this.expirationDict).forEach(function(key) {
            if (!filter || filter(key)) {
                _this.storage.removeItem(key);
                delete _this.expirationDict[key];
            }
        });
        this.storeExpirationDictionary();
    };
    /**
   * Clears values containg an expiration time of 0, denoting that
   * they should be cleared on logout.
   */ StorageInstance.prototype.clearOnLogout = function() {
        var _this = this;
        this.clear(function(key) {
            return _this.expirationDict[key] === EXPIRE_ON_LOGOUT;
        });
    };
    /**
   * Stores or updates an expiration time for a key.
   * @param key Key with which to query storage.
   * @param expirationTimestamp Expiration timestamp in ms.
   */ StorageInstance.prototype.storeExpireTime = function(key, expirationTimestamp) {
        this.expirationDict[key] = expirationTimestamp;
        this.storeExpirationDictionary();
    };
    /**
   * Function to check which storage entries have expired and remove them.
   */ StorageInstance.prototype.trackExpiration = function() {
        var _this = this;
        Object.keys(this.expirationDict).forEach(function(key) {
            var value = _this.expirationDict[key];
            if (value > 0 && value < Date.now()) {
                _this.metrics.event("storage expiration", "Key ".concat(key, " expired at ").concat(value), {
                    expirationTime: value,
                    key: key
                });
                _this.storage.removeItem(key);
                delete _this.expirationDict[key];
            }
        });
        this.storeExpirationDictionary();
    };
    return StorageInstance;
}();
exports.StorageInstance = StorageInstance;
var local;
var session;
try {
    local = new StorageInstance(localStorage);
    session = new StorageInstance(sessionStorage);
} catch (_a) {
    // Unified Shell will show an error if storage is blocked by the browser.
    // This code is needed to make sure the import of this module does not break execution.
    local = {};
    session = {};
}
var storage = {
    local: local,
    session: session
};
exports.storage = storage;

});
parcelRegister("17AVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Events", {
    enumerable: true,
    get: function() {
        return $hNRfl.Events;
    }
});
Object.defineProperty(module.exports, "Level", {
    enumerable: true,
    get: function() {
        return $hCZmk.Level;
    }
});
module.exports.default = void 0;

var $ihFuI = parcelRequire("ihFuI");

var $hNRfl = parcelRequire("hNRfl");

var $hCZmk = parcelRequire("hCZmk");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * API used to log messages, errors, events, metrics and analytics that get pushed to our telemetry
 * system.
 *
 * The main goal of this project is to provide solutions that are integrating with Unified-Shell and
 * running on Adobe Experience Cloud as much telemetry information as possible "for free" and a
 * convenient integration option to collect custom, application specific metrics.
 *
 * ***Import:***
 *
 * ```typescript
 * import metrics from '@adobe/exc-app/metrics';
 * ```
 *
 * ***Type:***
 *
 * [MetricsApi](../interfaces/metrics.metricsapi.md#interface-metricsapi)
 *
 * ***Usage:***
 *
 * ```typescript
 * import metrics from '@adobe/exc-app/metrics';
 *
 * class MyClass {
 *   constructor() {
 *     this.metrics = metrics.create('exc.landing-page.recents');
 *   }
 *
 *   async someOperation() {
 *     const timer = this.metrics.start('MyClass.someOperation');
 *     try {
 *       await performOperation();
 *       timer.time('done');
 *     } catch(err) {
 *       this.metrics.error(error);
 *       throw err;
 *     }
 *   }
 * }
 * ```
 * @packageDocumentation
 * @module metrics
 * @preferred
 */ const $2ba03e6b0f524230$var$api = (0, $ihFuI.connect)("metrics", [
    [
        "create",
        true
    ]
]);
var $2ba03e6b0f524230$var$_default = $2ba03e6b0f524230$var$api;
/**
 * @ignore
 */ /**
 * @ignore
 */ module.exports.default = $2ba03e6b0f524230$var$_default;

});
parcelRegister("ihFuI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getImpl = $86c424642254473b$var$getImpl;
module.exports.connect = $86c424642254473b$var$connect;
module.exports.default = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module "index"
 */ /**
 * Gets the implementation for the module.
 * @ignore
 * @param moduleName The name of the module.
 * @returns The implementation.
 */ function $86c424642254473b$var$getImpl(moduleName) {
    const emr = window["exc-module-runtime"];
    if (!emr) throw new Error(`module-runtime APIs not available (Fetching ${moduleName}).`);
    return emr[moduleName];
}
/**
 * Connects attributes of the specified API.
 * @ignore
 * @param apiName Name of the API.
 * @param attributes The attributes to connect.
 * @returns The API instance.
 */ function $86c424642254473b$var$connect(apiName, attributes) {
    const api = {};
    attributes.forEach((feature)=>{
        const featureName = feature[0];
        if (feature[1]) api[featureName] = (...args)=>{
            return $86c424642254473b$var$getImpl(apiName)[featureName](...args);
        };
        else Object.defineProperty(api, featureName, {
            get: ()=>{
                return $86c424642254473b$var$getImpl(apiName)[featureName];
            },
            set: (value)=>{
                $86c424642254473b$var$getImpl(apiName)[featureName] = value;
            }
        });
    });
    return api;
}
var $86c424642254473b$var$_default = window;
module.exports.default = $86c424642254473b$var$_default;

});

parcelRegister("hNRfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Events = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Named events in loading lifecycle
 */ /**
 * @ignore
 */ let $efe83ebcc18aeda4$var$Events;
module.exports.Events = $efe83ebcc18aeda4$var$Events;
(function(Events) {
    Events["PAGE_LOAD_DONE"] = "exc.metrics.pageState.load.done";
    Events["PAGE_LOAD_START"] = "exc.metrics.pageState.load.start";
    Events["SPINNER_DONE"] = "exc.metrics.pageState.spinner.done";
    Events["SPINNER_START"] = "exc.metrics.pageState.spinner.start";
})($efe83ebcc18aeda4$var$Events || (module.exports.Events = $efe83ebcc18aeda4$var$Events = {}));

});

parcelRegister("hCZmk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Level = void 0;
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @packageDocumentation
 * @module metrics
 */ /**
 * Log levels, for RecordType == Log.
 */ /**
 * @ignore
 */ let $3b24a67bcf808bc9$var$Level;
module.exports.Level = $3b24a67bcf808bc9$var$Level;
(function(Level) {
    Level["ERROR"] = "ERROR";
    Level["WARN"] = "WARN";
    Level["INFO"] = "INFO";
    Level["DEBUG"] = "DEBUG";
    Level["TRACE"] = "TRACE";
})($3b24a67bcf808bc9$var$Level || (module.exports.Level = $3b24a67bcf808bc9$var$Level = {}));

});


parcelRegister("uYURx", function(module, exports) {

var $Ha5sG = parcelRequire("Ha5sG");
module.exports = Promise.all([
    $Ha5sG("1vCZj"),
    $Ha5sG("hdSxF")
]).then(()=>parcelRequire("2QQAQ"));

});
parcelRegister("Ha5sG", function(module, exports) {
"use strict";

function $081bd75a75e47148$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3cmwu")).resolve(id));
}
module.exports = $081bd75a75e47148$var$load;

});



parcelRegister("fapYZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalCache = $b0abf1d3a4e8bf0b$var$getLocalCache;
module.exports.getSessionCache = $b0abf1d3a4e8bf0b$var$getSessionCache;
module.exports.StorageCache = module.exports.DEFAULT_CACHE_TTL = void 0;

var $fwqnC = parcelRequire("fwqnC");
var $b0abf1d3a4e8bf0b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b0abf1d3a4e8bf0b$var$__generator = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // If a user does not open any discovery based solution in 28 days, cache will be removed.
var $b0abf1d3a4e8bf0b$var$DEFAULT_CACHE_TTL = 2419200; // 4 weeks (seconds).
module.exports.DEFAULT_CACHE_TTL = $b0abf1d3a4e8bf0b$var$DEFAULT_CACHE_TTL;
var $b0abf1d3a4e8bf0b$var$StorageCache = /** @class */ function() {
    function StorageCache(storageInstance, storageKey, cacheExpiry) {
        if (cacheExpiry === void 0) cacheExpiry = $b0abf1d3a4e8bf0b$var$DEFAULT_CACHE_TTL;
        this.storageKey = storageKey;
        this.storage = storageInstance;
        this.cacheExpiry = cacheExpiry;
    }
    /**
   * Reads the entire cache from storage.
   * @returns {{[key: string]: T}} Cache content
   * @private
   */ StorageCache.prototype.read = function() {
        return $b0abf1d3a4e8bf0b$var$__awaiter(this, void 0, Promise, function() {
            return $b0abf1d3a4e8bf0b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.storage.get(this.storageKey)
                        ];
                    case 1:
                        return [
                            2,
                            _a.sent() || {}
                        ];
                }
            });
        });
    };
    /**
   * Writes the entire cache to storage, removing expired items along the way.
   * @param {[key: string]: T} cache - Cache content
   * @private
   */ StorageCache.prototype.write = function(cache) {
        return $b0abf1d3a4e8bf0b$var$__awaiter(this, void 0, Promise, function() {
            var now, key;
            return $b0abf1d3a4e8bf0b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        now = Date.now(); // Remove any expired entries
                        for(key in cache)if (cache[key].expires < now) delete cache[key];
                        return [
                            4,
                            this.storage.set(this.storageKey, cache, this.cacheExpiry * 1000)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    /**
   * Returns a cached entry if exists and valid.
   * @param {string} key - Entry key
   *
   * @returns {CacheEntry} Cached entry
   */ StorageCache.prototype.get = function(key) {
        return $b0abf1d3a4e8bf0b$var$__awaiter(this, void 0, Promise, function() {
            var cache, entry;
            return $b0abf1d3a4e8bf0b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.read()
                        ];
                    case 1:
                        cache = _a.sent();
                        entry = cache[key];
                        if (entry && entry.expires > Date.now()) return [
                            2,
                            entry
                        ];
                        return [
                            2
                        ];
                }
            });
        });
    };
    /**
   * Stores an entry in the cache.
   * @param {string} key - Entry key
   * @param {CacheEntry} entry to be cached.
   */ StorageCache.prototype.set = function(key, entry) {
        return $b0abf1d3a4e8bf0b$var$__awaiter(this, void 0, Promise, function() {
            var cache;
            return $b0abf1d3a4e8bf0b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.read()
                        ];
                    case 1:
                        cache = _a.sent();
                        cache[key] = entry;
                        return [
                            4,
                            this.write(cache)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    /**
   * Removes an entry from the cache if exists.
   * @param {string} key - Entry key
   */ StorageCache.prototype.remove = function(key) {
        return $b0abf1d3a4e8bf0b$var$__awaiter(this, void 0, Promise, function() {
            var cache;
            return $b0abf1d3a4e8bf0b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4,
                            this.read()
                        ];
                    case 1:
                        cache = _a.sent();
                        if (!cache[key]) return [
                            3,
                            3
                        ];
                        delete cache[key];
                        return [
                            4,
                            this.write(cache)
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
    };
    return StorageCache;
}();
module.exports.StorageCache = $b0abf1d3a4e8bf0b$var$StorageCache;
function $b0abf1d3a4e8bf0b$var$getLocalCache(storageKey, cacheExpiry) {
    return new $b0abf1d3a4e8bf0b$var$StorageCache($fwqnC.storage.local, storageKey, cacheExpiry);
}
function $b0abf1d3a4e8bf0b$var$getSessionCache(storageKey, cacheExpiry) {
    return new $b0abf1d3a4e8bf0b$var$StorageCache($fwqnC.storage.session, storageKey, cacheExpiry);
}

});



parcelRegister("3r4G2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIMSObjects = $d00b6ec1a888de7d$var$getIMSObjects;

var $5zc7g = parcelRequire("5zc7g");

var $iNslS = parcelRequire("iNslS");

var $ehZqD = parcelRequire("ehZqD");

var $3O0eZ = parcelRequire("3O0eZ");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ /* eslint-disable sort-keys */ const $d00b6ec1a888de7d$var$ENVS = {
    test: $3O0eZ.IEnvironment.STAGE,
    dev: $3O0eZ.IEnvironment.STAGE,
    qa: $3O0eZ.IEnvironment.STAGE,
    stage: $3O0eZ.IEnvironment.STAGE,
    prod: $3O0eZ.IEnvironment.PROD
};
/* eslint-enable sort-keys */ const $d00b6ec1a888de7d$var$storedEvents = [];
let $d00b6ec1a888de7d$var$imsPromise;
const $d00b6ec1a888de7d$var$handleEvent = (event, store = true, detail)=>{
    store && $d00b6ec1a888de7d$var$storedEvents.push(event);
    document.dispatchEvent(new CustomEvent(event, {
        detail: detail
    }));
};
const $d00b6ec1a888de7d$var$getIMS = async (adobeid, token, profile)=>{
    const adobeIMS = new $5zc7g.AdobeIMS(adobeid);
    if (token) {
        const { expires_in: expires_in, sid: sid = "" } = (0, $iNslS.extractTokenMetadata)(token) || {};
        expires_in && adobeIMS.setStandAloneToken({
            expirems: expires_in,
            sid: sid,
            token: token
        });
        profile && adobeIMS["profileService"].saveProfileToStorage(profile);
    }
    await adobeIMS.initialize();
    return {
        adobeid: adobeid,
        adobeIMS: adobeIMS,
        storedEvents: $d00b6ec1a888de7d$var$storedEvents
    };
};
function $d00b6ec1a888de7d$var$getIMSObjects({ clientId: clientId, env: env = "dev", profile: profile, scopes: scopes, token: token = "" }) {
    if (!$d00b6ec1a888de7d$var$imsPromise) {
        const config = (0, $ehZqD.getIMSConfig)($d00b6ec1a888de7d$var$ENVS[env], clientId, scopes);
        const adobeid = {
            ...config,
            locale: window.navigator.language,
            onAccessToken: (token)=>$d00b6ec1a888de7d$var$handleEvent("auth.accesstoken", false, token),
            onAccessTokenHasExpired: ()=>$d00b6ec1a888de7d$var$handleEvent("auth.accesstokenexpired", true),
            onError: (error, message)=>$d00b6ec1a888de7d$var$handleEvent("auth.error", true, {
                    error: error,
                    message: message
                }),
            onReady: null,
            onReauthAccessToken: null
        };
        $d00b6ec1a888de7d$var$imsPromise = $d00b6ec1a888de7d$var$getIMS(adobeid, token, profile);
    }
    return $d00b6ec1a888de7d$var$imsPromise;
}

});
parcelRegister("5zc7g", function(module, exports) {
"use strict";
var $40d99ea1022b4a68$var$__assign = module.exports && module.exports.__assign || function() {
    $40d99ea1022b4a68$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40d99ea1022b4a68$var$__assign.apply(this, arguments);
};
var $40d99ea1022b4a68$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $40d99ea1022b4a68$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $40d99ea1022b4a68$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $46lF8 = parcelRequire("46lF8");

var $40d99ea1022b4a68$var$Log_1 = $40d99ea1022b4a68$var$__importDefault((parcelRequire("545sK")));

var $FRmK4 = parcelRequire("FRmK4");

var $TpXdn = parcelRequire("TpXdn");

var $lU5Be = parcelRequire("lU5Be");

var $343mA = parcelRequire("343mA");

var $hk0ws = parcelRequire("hk0ws");

var $c7IJY = parcelRequire("c7IJY");

var $cGX1o = parcelRequire("cGX1o");

var $gwRwe = parcelRequire("gwRwe");

var $csDaY = parcelRequire("csDaY");

var $40d99ea1022b4a68$var$UrlHelper_1 = $40d99ea1022b4a68$var$__importDefault((parcelRequire("fiyt1")));

var $40d99ea1022b4a68$var$FragmentHelper_1 = $40d99ea1022b4a68$var$__importDefault((parcelRequire("hsEsQ")));

var $6l4f6 = parcelRequire("6l4f6");

var $iWL10 = parcelRequire("iWL10");

var $fwlYT = parcelRequire("fwlYT");

var $aCG43 = parcelRequire("aCG43");

var $40d99ea1022b4a68$var$TokenAutoRefresh_1 = $40d99ea1022b4a68$var$__importDefault((parcelRequire("ejCBD")));

var $h0Bwb = parcelRequire("h0Bwb");

var $40d99ea1022b4a68$var$Environment_1 = $40d99ea1022b4a68$var$__importDefault((parcelRequire("1Sn1w")));

var $1V6oS = parcelRequire("1V6oS");

var $8vy8k = parcelRequire("8vy8k");

var $kTYb4 = parcelRequire("kTYb4");

var $hzAhd = parcelRequire("hzAhd");

var $piMW2 = parcelRequire("piMW2");
/**
 * Class used as a facade for ims library in order to provide public access to library functionalities
 *
 */ var $40d99ea1022b4a68$var$AdobeIMS = /** @class */ function() {
    /**
     * @constructor adobeData {AdobeIdData}
     * If adobeData is not null, the adobeIdData instance will be created based on these values
     *
     * if no adobeData, the imsLibrary try to read these values from window.adobeid
     *
     * After this AdobeIms class is created, it can be accessed by window[{adobeData.clientId}]
    */ function AdobeIMS(adobeData) {
        var _this = this;
        if (adobeData === void 0) adobeData = null;
        /**
         * flag used to block the access to signin, signout functions in case the library is not fully initialized
         * { Boolean }; true if library is initialized, otherwise false
         */ this.initialized = false;
        /**
         *
         * @param authUrlRedirectResponse {String} represents the authorization redirect response
         */ this.onPopupMessage = function(authUrlRedirectResponse) {
            if (!!authUrlRedirectResponse && !!_this.adobeIdData.onModalModeSignInComplete) {
                var response = _this.tokenService.getTokenFromFragment(authUrlRedirectResponse);
                if (response instanceof $hzAhd.TokenFields) {
                    _this.tokenService.addTokenToStorage(response);
                    if (_this.adobeIdData.onModalModeSignInComplete(response)) return Promise.resolve();
                }
            }
            $40d99ea1022b4a68$var$UrlHelper_1.default.replaceUrl(authUrlRedirectResponse);
            return _this.initialize();
        };
        /**
         * Method used to redirect the user to signin url
         *
         * <uml>
         * start
         * :SignIn;
         * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
         * :Create the redirect url using external parameters. state object will be part of redirect url;
         * :user must enter the credentials and after that is redirected to initial uri;
         * :initialize method is used which will trigger the onAccessToken;
         * end
         * </uml>
         *
         *
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
         * @param grantType {IGrantTypes} represents the grant type used for sign in flow
         *
        */ this.signIn = function(externalParameters, contextToBePassedOnRedirect, grantType) {
            if (externalParameters === void 0) externalParameters = {};
            if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
            return $40d99ea1022b4a68$var$__awaiter(_this, void 0, void 0, function() {
                var _a, adobeIdData, csrfService, nonce, authorizeRequestData;
                return $40d99ea1022b4a68$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.checkInitialized();
                            _a = this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
                            nonce = csrfService.initialize();
                            return [
                                4 /*yield*/ ,
                                adobeIdData.createRedirectRequest(externalParameters, contextToBePassedOnRedirect, nonce, grantType)
                            ];
                        case 1:
                            authorizeRequestData = _b.sent();
                            this.signInservice.signIn(authorizeRequestData);
                            return [
                                2 /*return*/ ,
                                Promise.resolve()
                            ];
                    }
                });
            });
        };
        /**
         * method used to sign in using an external token
         * @param token { String } token used for authorize; if the token is empty, the user will be redirected to the sign in screen
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
         */ this.authorizeToken = function(token, externalParameters, contextToBePassedOnRedirect, grantType) {
            if (token === void 0) token = "";
            if (externalParameters === void 0) externalParameters = {};
            if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            return adobeIdData.createRedirectRequest(externalParameters, contextToBePassedOnRedirect, nonce, grantType).then(function(authorizeRequestData) {
                new $FRmK4.SignInService().authorizeToken(token, authorizeRequestData);
            });
        };
        /**
         * Method used to reAuthenticate the user
         *
         * <uml>
         * start
         * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
         * :Create the redirect url using external parameters. state object will be part of redirect url;
         * :SignIn;
         * :user must enter the credentials and after that is redirected to initial uri;
         * :initialize method is used which will trigger the token and profile;
         * end
         *
         * </uml>
         *
         * @param requestedParameters object sent from outside in order to use diferent values for reAuthenticate
         * @param contextToBePassedOnRedirect {Object | undefined} represents the context which is passed during redirect
         * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
         *
        */ this.reAuthenticate = function(requestedParameters, reauth, contextToBePassedOnRedirect, grantType) {
            if (requestedParameters === void 0) requestedParameters = {};
            if (reauth === void 0) reauth = $c7IJY.IReauth.check;
            if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
            _this.checkInitialized();
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            return adobeIdData.createReAuthenticateRedirectRequest(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType).then(function(authorizeRequestData) {
                _this.signInservice.signIn(authorizeRequestData);
            });
        };
        /**
         * sign in with social providers
         * @param providerName provider name used for sign in
         * @param externalParameters external parameters sent by developer
         * @param contextToBePassedOnRedirect {Object} state of the application
         */ this.signInWithSocialProvider = function(providerName, externalParameters, contextToBePassedOnRedirect, grantType) {
            if (externalParameters === void 0) externalParameters = {};
            if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
            _this.checkInitialized();
            if (!providerName) throw new Error("please provide the provider name");
            var _a = _this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
            var nonce = csrfService.initialize();
            adobeIdData.createSocialProviderRedirectRequest(providerName, externalParameters, contextToBePassedOnRedirect, nonce, grantType).then(function(authorizeRequestData) {
                _this.signInservice.signIn(authorizeRequestData);
            });
        };
        /**
         *  Method used for sign out the user
         *
         * <uml>
         * start
         * :Signout;
         * :Create the redirect url;
         * :remove the token and profile from storage;
         * :initialize method is used which will redirect the app to initial url;
         * end
         * </uml>
         *
         * @param externalParameters {Object} object sent from outside in order to have the possibility to override the default values when the redirect uri is created
         *
        */ this.signOut = function(externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            _this.checkInitialized();
            _this.tokenService.purge();
            _this.profileService.removeProfile();
            var _a = _this.adobeIdData, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, adobeIdRedirectUri = _a.redirect_uri;
            var redirectRequest = {
                adobeIdRedirectUri: adobeIdRedirectUri,
                apiParameters: apiParameters,
                clientId: clientId,
                externalParameters: externalParameters
            };
            var signOutService = new $lU5Be.SignOutService();
            signOutService.signOut(redirectRequest);
        };
        /**
         * Retrieve the access token that satisfies the provided PBA policy, with a validity of at least [given] millis.
         * If the current access token in Storage satisfies the policy and is valid for at least the required time,
         * it will be returned.
         *
         * Otherwise, we will call the /check/token API with the pba_policy as parameter.
         *
         * The API will either return a token, if the current user session knobs satisfy the policy, or it will return a
         * PBA ride error, with a jump url, so the user performs the required actions for the session to become compliant
         * with the policy.
         *
         *
         * @param pbaPolicy - policy identifier (name)
         * @param validAtLeastMillis - value in millis. If the current token's expiry time is sooner than this, the token will
         * be considered unusable
         * @param contextToBePassedOnRedirect - in case a PBA ride error is thrown, this will be sent on the redirect back to
         * the lib
         * @param externalParameters - any other parameters to be sent to the check/token API
         */ this.getTokenForPBAPolicy = function(pbaPolicy, validAtLeastMillis, contextToBePassedOnRedirect, externalParameters) {
            if (pbaPolicy === void 0) pbaPolicy = "";
            if (validAtLeastMillis === void 0) validAtLeastMillis = 10000;
            if (externalParameters === void 0) externalParameters = {};
            var _a;
            var tokenInfo = _this.getAccessToken();
            // if this access token can be used, return it
            if (tokenInfo && Date.now() + validAtLeastMillis < tokenInfo.expire.getTime() && (!pbaPolicy || ((_a = tokenInfo.pbaSatisfiedPolicies) === null || _a === void 0 ? void 0 : _a.includes(pbaPolicy)))) return Promise.resolve(tokenInfo);
            // otherwise we need to call check token to obtain a new one
            var _b = _this, adobeIdData = _b.adobeIdData, csrfService = _b.csrfService;
            var nonce = csrfService.initialize();
            externalParameters.state = adobeIdData.createRedirectState(contextToBePassedOnRedirect, nonce);
            externalParameters.redirect_uri = $piMW2.RedirectHelper.createRedirectUrl(adobeIdData.redirect_uri, adobeIdData.client_id, externalParameters, "check_token", adobeIdData.scope);
            if (pbaPolicy) externalParameters.pba_policy = pbaPolicy;
            return _this.refreshToken(externalParameters);
        };
        /**
         * Refresh the existing token.
         *
         * <uml>
         * start
         * :refreshToken;
         * :call backend: ims/check/v4/token?client_id;
         * :read the token and profile;
         * :triggerOnAccessToken;
         * if (profile) then (yes)
         * else (nothing)
         * :call backend to get the profile ;
         * endif
         * end
         * </uml>
         *
         * @param externalParameters {Object} external parameters sent from outside of the library
         * @param autoRefresh {boolean} undocumented flag signaling that the call was made from auto-refresh context. do not set!
         * Note: if refresh token API fails, the triggerOnAccessTokenHasExpired will be triggered
        */ this.refreshToken = function(externalParameters, autoRefresh) {
            if (externalParameters === void 0) externalParameters = {};
            if (autoRefresh === void 0) autoRefresh = false;
            // It is possible that the client app has better user activity detection (eg. frames)
            // in which case it may call refreshToken with userInactiveSince. If that is the case,
            // TokenAutoRefresh should be updated with the new data, to be used when auto-refreshing.
            if (!autoRefresh && externalParameters.userInactiveSince) {
                var userInactiveSince = externalParameters.userInactiveSince;
                var lastUserInteraction = Date.now() - userInactiveSince * 1000;
                if (lastUserInteraction > $40d99ea1022b4a68$var$TokenAutoRefresh_1.default.lastUserInteraction) $40d99ea1022b4a68$var$TokenAutoRefresh_1.default.lastUserInteraction = lastUserInteraction;
            }
            return _this.tokenService.refreshToken(externalParameters).then(function(tokenResponse) {
                return _this.onTokenProfileReceived(tokenResponse);
            }).catch(function(ex) {
                $40d99ea1022b4a68$var$Log_1.default.error("refresh token error", ex);
                if (ex instanceof $aCG43.HttpErrorResponse) return Promise.reject(ex);
                var rideResult = _this.verifyRideErrorExceptionStrict(ex);
                if (rideResult) return rideResult;
                _this.profileService.removeProfile();
                _this.onTokenExpired();
                return Promise.reject(ex);
            });
        };
        /**
         * retreive a new token and profile for the input user id
         * @param externalParameters {Object} external parameters sent from outside of the library
         * @param userId {String} represents the user id used to get the new token and profile
         */ this.switchProfile = function(userId, externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            if (!userId) return Promise.reject(new Error("Please provide the user id for switchProfile"));
            return _this.tokenService.switchProfile(userId, externalParameters).then(function(tokenResponse) {
                return _this.onTokenProfileReceived(tokenResponse);
            }).catch(function(ex) {
                return _this.verifyRideErrorException(ex);
            });
        };
        /**
         *
         * @param instance { AdobeIMS } instance of AdobeIMS
         */ this.triggerOnImsInstance = function(instance) {
            var evt = document.createEvent("CustomEvent");
            var evtData = {
                clientId: _this.adobeIdData.client_id,
                instance: instance
            };
            evt.initCustomEvent($h0Bwb.ON_IMSLIB_INSTANCE, false, false, evtData);
            window.dispatchEvent(evt);
        };
        /**
           * process the initialize exception;
           * this method is the first method called in case there was an error during initialize flow;
           * check if the exception type is TokenExpiredException and pass the flow to the verifyCsrfException
           * @param initializeException represent the exception received during the initialize
           */ this.processInitializeException = function(initializeException) {
            if (initializeException === void 0) initializeException = {};
            var handlers = _this.adobeIdData.handlers;
            $40d99ea1022b4a68$var$Log_1.default.warn("initialize", initializeException);
            if (initializeException instanceof $8vy8k.ModalSignInEvent) // this happens when popup window redirects and the state from fragment contains imslibmodal property as true
            return _this.notifyParentAboutModalSignIn(initializeException);
            _this.restoreHash();
            if (initializeException instanceof $iWL10.TokenExpiredException) handlers.triggerOnAccessTokenHasExpired();
            return Promise.reject(initializeException);
        };
        /**
         * method called in case of exception on initialize.
         * if error is RideError, it redirects to the jump url from RideException.jump.
         * @return a rejected promise with the given ex
         */ this.verifyRideErrorException = function(ex) {
            return $40d99ea1022b4a68$var$__awaiter(_this, void 0, void 0, function() {
                return $40d99ea1022b4a68$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(ex instanceof $fwlYT.RideException)) return [
                                3 /*break*/ ,
                                4
                            ];
                            if (!!this.adobeIdData.overrideErrorHandler && !this.adobeIdData.overrideErrorHandler(ex)) return [
                                2 /*return*/ ,
                                Promise.reject(ex)
                            ];
                            if (!ex.isPbaExpiredIdleSessionWorkaround) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.signIn()
                            ];
                        case 1:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            if (!ex.jump) return [
                                3 /*break*/ ,
                                4
                            ];
                            return [
                                4 /*yield*/ ,
                                $40d99ea1022b4a68$var$UrlHelper_1.default.replaceUrlAndWait(ex.jump, 10000)
                            ];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            return [
                                2 /*return*/ ,
                                Promise.reject(ex)
                            ];
                    }
                });
            });
        };
        /**
         * Same as verifyRideErrorExceptionStrict, but returns null if ex is not RideException
         */ this.verifyRideErrorExceptionStrict = function(ex) {
            if (!(ex instanceof $fwlYT.RideException)) return null;
            return _this.verifyRideErrorException(ex);
        };
        /**
         * method called in case of exception on initialize.  if error type is CSRF, it calls the signOut methods
         */ this.verifyCsrfException = function(ex) {
            var errorType = ex.type;
            if (errorType && errorType === $6l4f6.IErrorType.CSRF) _this.signOut();
            return Promise.reject(ex);
        };
        /**
         * method called after a successful call to the getTokenAndProfile method in order to process the token response
         * tokenProfile: TokenProfileResponse - contains the token fields and eventually the user profile
         * @returns Promise
         */ this.processTokenResponse = function(tokenProfile) {
            var handlers = _this.adobeIdData.handlers;
            var tokenFields = tokenProfile.tokenFields, profile = tokenProfile.profile;
            var token = tokenFields.tokenValue, state = tokenFields.state, expire = tokenFields.expire, sid = tokenFields.sid, userId = tokenFields.user_id, _a = tokenFields.other, other = _a === void 0 ? {} : _a, impersonatorId = tokenFields.impersonatorId, isImpersonatedSession = tokenFields.isImpersonatedSession, pbaSatisfiedPolicies = tokenFields.pbaSatisfiedPolicies;
            $40d99ea1022b4a68$var$Log_1.default.info("token", token);
            if (other.from_ims) $40d99ea1022b4a68$var$UrlHelper_1.default.setHash(other.old_hash || "");
            _this.profileService.removeProfileIfOtherUser(userId);
            var notificationData = {
                token: token,
                expire: expire,
                sid: sid,
                impersonatorId: impersonatorId,
                isImpersonatedSession: isImpersonatedSession,
                pbaSatisfiedPolicies: pbaSatisfiedPolicies
            };
            tokenFields.isReauth() ? handlers.triggerOnReauthAccessToken(notificationData) : _this.tokenReceived(notificationData);
            if (profile) _this.profileService.saveProfileToStorage(profile);
            return Promise.resolve(state);
        };
        /**
         * method used during initialization in order to get a ijt token
         * https://wiki.corp.adobe.com/display/ims/Implicit+Jump+Tokens
         * @returns {Promise<any>} ijt response
         * @param {string} ijt value used for token excahnge (other than the one from adobeid)
         * @usage adobeIMS.adobeIdData.ijt = 'ijtValue' followed by adobeIMS.initialize()
         */ this.exchangeIjt = function(ijt) {
            var adobeIjt = _this.adobeIdData.ijt;
            if (!ijt && !adobeIjt) return Promise.reject(new Error("please set the adobeid.ijt value"));
            return _this.tokenService.exchangeIjt(ijt || adobeIjt).then(function(resp) {
                if (resp.profile) _this.profileService.saveProfileToStorage(resp.profile);
                else _this.profileService.removeProfile();
                return Promise.resolve(resp);
            });
        };
        this.adobeIdData = new $343mA.AdobeIdData(adobeData);
        var _a = this.adobeIdData, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, scope = _a.scope, useLocalStorage = _a.useLocalStorage, autoValidateToken = _a.autoValidateToken, modalMode = _a.modalMode, modalSettings = _a.modalSettings;
        this.imsApis = new $hk0ws.ImsApis(apiParameters);
        this.csrfService = new $46lF8.CsrfService(clientId);
        this.serviceRequest = {
            clientId: clientId,
            scope: scope,
            imsApis: this.imsApis
        };
        this.tokenService = new $csDaY.TokenService($40d99ea1022b4a68$var$__assign($40d99ea1022b4a68$var$__assign({}, this.serviceRequest), {
            useLocalStorage: useLocalStorage,
            autoValidateToken: autoValidateToken
        }), this.csrfService);
        this.profileService = new $gwRwe.ProfileService(this.serviceRequest);
        this.signInservice = modalMode ? new $TpXdn.SignInModalService(this.onPopupMessage, modalSettings) : new $FRmK4.SignInService();
    }
    Object.defineProperty(AdobeIMS.prototype, "version", {
        /**
         * represents the adobe ims library version
         */ get: function() {
            return $40d99ea1022b4a68$var$Environment_1.default.jslibver;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdobeIMS.prototype, "adobeid", {
        /**
         * AdobeIdData
         * the values for adobeId are read from window.adobeid or passed by using the constructor
        */ get: function() {
            return $40d99ea1022b4a68$var$__assign({}, this.adobeIdData);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * enable the logging mechanism
     */ AdobeIMS.prototype.enableLogging = function() {
        $40d99ea1022b4a68$var$Log_1.default.enableLogging();
    };
    /**
     * disable the logging mechanism
     */ AdobeIMS.prototype.disableLogging = function() {
        $40d99ea1022b4a68$var$Log_1.default.disableLogging();
    };
    /**
     * function used to check is initialized; in case of false, an error is triggered
     */ AdobeIMS.prototype.checkInitialized = function() {
        if (this.initialized) return;
    //   throw new Error( 'the imslib is not yet initialized' );
    };
    /**
     * Method used to redirect the user to the signup screen
     *
     * <uml>
     * start
     * :Create the state object by using appCode, appVersion (used on server side) from adobeId.analytics and contextToBePassedOnRedirect;
     * :Create the redirect url using external parameters. state object will be part of redirect url;
     * :SignUp;
     * :initialize method is used which will trigger the token and profile;
     * end
     *
     * </uml>
     *
     * @param requestedParameters object sent from outside in order to use diferent values for signUp
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     *
    */ AdobeIMS.prototype.signUp = function(requestedParameters, contextToBePassedOnRedirect) {
        var _this = this;
        if (requestedParameters === void 0) requestedParameters = {};
        this.checkInitialized();
        var _a = this, adobeIdData = _a.adobeIdData, csrfService = _a.csrfService;
        if (!adobeIdData) throw new Error("no adobeId on reAuthenticate");
        var nonce = csrfService.initialize();
        return adobeIdData.createSignUpRedirectRequest(requestedParameters, contextToBePassedOnRedirect, nonce).then(function(authorizeRequestData) {
            _this.signInservice.signIn(authorizeRequestData);
        });
    };
    /**
     * @function Method used to check if the user is signed in or not.
     * if local storage contains a token and is validated (only against expiration), the result is true
     * returns {boolean}
    */ AdobeIMS.prototype.isSignedInUser = function() {
        return this.getAccessToken() || this.getReauthAccessToken() ? true : false;
    };
    /**
     * @function Method used to get the user profile in case the user is logged)
     * returns {IDictionary | null}  representing the user profile or null
    */ AdobeIMS.prototype.getProfile = function() {
        var _this = this;
        var profile = this.profileService.getProfileFromStorage();
        if (profile) return Promise.resolve(profile);
        var tokenInfo = this.getAccessToken() || this.getReauthAccessToken();
        if (!tokenInfo) {
            var profileException = "please login before getting the profile";
            return Promise.reject(new $cGX1o.ProfileException(profileException));
        }
        return this.profileService.getProfile(tokenInfo.token).then(function(profile) {
            return Promise.resolve(profile);
        }).catch(function(ex) {
            $40d99ea1022b4a68$var$Log_1.default.error("get profile exception ", ex);
            if (!(ex instanceof $aCG43.HttpErrorResponse)) return Promise.reject(new $cGX1o.ProfileException(ex.message || ex));
            return _this.refreshToken().then(function(tokenResponse) {
                return Promise.resolve(tokenResponse.profile);
            });
        });
    };
    /**
     * @function Returns the URL of the user avatar
     * @param {UserId} userId
    */ AdobeIMS.prototype.avatarUrl = function(userId) {
        return this.imsApis.avatarUrl(userId);
    };
    /**
      * method used to retrieve the token release flags
    */ AdobeIMS.prototype.getReleaseFlags = function(decode) {
        if (decode === void 0) decode = false;
        return decode ? this.tokenService.getDecodedReleaseFlags() : this.tokenService.getReleaseFlags();
    };
    /**
      *
      * Returns the access token value from the local storage
      *
      * <uml>
      * start
      * :getAccessToken;
      * :check the local storage;
      * :if token exists, it is validated against expiration;
      * :if valid the token is returned otherwise an empty token;
      * end
      * </uml>
      *
    */ AdobeIMS.prototype.getAccessToken = function() {
        return this.getTokenFromStorage(false);
    };
    /**
     *
     * Returns the reauth access token value from the local storage
     *
     * <uml>
     * start
     * :getReauthAccessToken;
     * :check the local storage;
     * :if token exists, it is validated against expiration;
     * :if valid the token is returned otherwise an empty token;
     * end
     * </uml>
     *
   */ AdobeIMS.prototype.getReauthAccessToken = function() {
        return this.getTokenFromStorage(true);
    };
    AdobeIMS.prototype.getTokenFromStorage = function(isReauth) {
        var tokenFields = this.tokenService.getTokenFieldsFromStorage(isReauth);
        if (!tokenFields) return null;
        var token = tokenFields.tokenValue, expire = tokenFields.expire, sid = tokenFields.sid, impersonatorId = tokenFields.impersonatorId, isImpersonatedSession = tokenFields.isImpersonatedSession, pbaSatisfiedPolicies = tokenFields.pbaSatisfiedPolicies;
        return {
            token: token,
            expire: expire,
            sid: sid,
            impersonatorId: impersonatorId,
            isImpersonatedSession: isImpersonatedSession,
            pbaSatisfiedPolicies: pbaSatisfiedPolicies
        };
    };
    /**
     * method used to get the social providers.
     * returns Promise - can be used to determine when the call has been ended and read the social providers response
     */ AdobeIMS.prototype.listSocialProviders = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var client_id = _this.adobeIdData.client_id;
            _this.imsApis.listSocialProviders({
                client_id: client_id
            }).then(function(response) {
                resolve(response);
            }).catch(function(ex) {
                reject(ex);
            });
        });
    };
    /**
     *
     * @param token {string} represents the access token
     * @param expire {Date} the date when the token will expire
     */ AdobeIMS.prototype.tokenReceived = function(tokenInfo) {
        var handlers = this.adobeIdData.handlers;
        handlers.triggerOnAccessToken(tokenInfo);
        $40d99ea1022b4a68$var$TokenAutoRefresh_1.default.startAutoRefreshFlow({
            expire: tokenInfo.expire,
            refreshTokenMethod: this.refreshToken
        });
    };
    /**
     * method used to process the token and profile
     * @param tokenResponse {IRefreshTokenResponse} represents the token and profile received from back-end
     */ AdobeIMS.prototype.onTokenProfileReceived = function(tokenResponse) {
        var tokenInfo = tokenResponse.tokenInfo, profile = tokenResponse.profile;
        $40d99ea1022b4a68$var$Log_1.default.info("token", tokenInfo);
        this.tokenReceived(tokenInfo);
        this.profileService.saveProfileToStorage(profile);
        return Promise.resolve(tokenResponse);
    };
    /**
     * @returns a promise which is resolved as true in case the token is valid otherwise false
     * validate the existing token;
     */ AdobeIMS.prototype.validateToken = function() {
        var _this = this;
        return this.tokenService.validateToken().then(function() {
            return Promise.resolve(true);
        }).catch(function(ex) {
            $40d99ea1022b4a68$var$Log_1.default.warn("validate token exception", ex);
            if (ex instanceof $aCG43.HttpErrorResponse) return Promise.reject(false);
            _this.profileService.removeProfile();
            return Promise.reject(false);
        });
    };
    /**
     * method used in case the existent token has expired
     */ AdobeIMS.prototype.onTokenExpired = function() {
        var handlers = this.adobeIdData.handlers;
        this.tokenService.purge();
        handlers.triggerOnAccessTokenHasExpired();
    };
    /**
     * set a new token into the local storage
     * @param tokenInfo {tokenInfo} represents the token/ expire information used by library
     */ AdobeIMS.prototype.setStandAloneToken = function(standaloneToken) {
        return this.tokenService.setStandAloneToken(standaloneToken);
    };
    /**
     * Method called on library initialization or page reloading
     * <uml>
     * start
     * :initialize method;
     * :get token;
     * if (fragment) then (yes)
     * :returns the token from fragment;
     * else (check local storage)
     * :returns the token from local storage;
     * endif
     * :if no token: return triggerOnAccessTokenHasExpired;
     * :triggerOnAccessToken;
     * :back-end: calls getProfile ;
     * :triggerOnReady ;
     * end
     * </uml>
     *
     * Note: this method is automatically called on every page reload;
    */ AdobeIMS.prototype.initialize = function() {
        var _this = this;
        var _a = this.adobeIdData, handlers = _a.handlers, standalone = _a.standalone, ijt = _a.ijt;
        var state = null;
        if (standalone) this.setStandAloneToken(standalone);
        var initializationMethod = ijt ? this.exchangeIjt : this.tokenService.getTokenAndProfile;
        return initializationMethod().then(this.processTokenResponse, function(ex) {
            return _this.processInitializeException(ex).catch(function(ex) {
                return _this.verifyRideErrorException(ex);
            }).catch(function(ex) {
                return _this.verifyCsrfException(ex).catch(function(ex) {
                    return $40d99ea1022b4a68$var$Log_1.default.info("initialize exception ended", ex);
                });
            });
        }).then(function(stateValue) {
            state = stateValue;
        }).finally(function() {
            $40d99ea1022b4a68$var$Log_1.default.info("onReady initialization");
            window.addEventListener($h0Bwb.ASK_FOR_IMSLIB_INSTANCE_DOM_EVENT_NAME, function() {
                _this.triggerOnImsInstance(_this);
            }, false);
            handlers.triggerOnReady(state ? state.context : null);
            _this.triggerOnImsInstance(_this);
            _this.initialized = true;
            return Promise.resolve(state);
        });
    };
    /**
     * pass the redirect url from the popup window to parent
     * @param modalSignInEvent {ModalSignInEvent} represents the redirect url after user has signed in
     */ AdobeIMS.prototype.notifyParentAboutModalSignIn = function(modalSignInEvent) {
        var href = window.location.href.replace("imslibmodal", "wasmodal");
        if (window.opener) {
            window.opener.postMessage(href, window.location.origin);
            window.close();
        } else window["" + modalSignInEvent.wndRedirectPropName] = href;
        return Promise.reject("popup");
    };
    /**
     * restore the window hash value to the initial one
     */ AdobeIMS.prototype.restoreHash = function() {
        var fragmentValues = $40d99ea1022b4a68$var$FragmentHelper_1.default.fragmentToObject();
        if (!fragmentValues || !fragmentValues.from_ims) return;
        $40d99ea1022b4a68$var$UrlHelper_1.default.setHash(fragmentValues.old_hash || "");
    };
    /**
     * Exchange the user's access_token for a Transitory Access Code (TAC) for target client and scope
     * @see {@link https://wiki.corp.adobe.com/display/ims/Transitory+Authorization+Codes |Transitory Authorization Codes}
     * @param tacRequest {ITransitoryAuthorizationRequest}
     * @param externalParameters {IDictionary} object used in order to update the default api values
     */ AdobeIMS.prototype.getTransitoryAuthorizationCode = function(tacRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        tacRequest = tacRequest || {};
        tacRequest.response_type = tacRequest.response_type || "code";
        tacRequest.target_client_id = tacRequest.target_client_id || this.adobeIdData.client_id;
        tacRequest.target_scope = tacRequest.target_scope || this.adobeIdData.scope;
        return this.imsApis.getTransitoryAuthorizationCode(tacRequest, externalParameters, this.adobeIdData.client_id);
    };
    /**
     * Allows a client to launch a system-browser and arrive at another IMS-integrated application
     * https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ims&title=IMS+API+-+jumptoken
     * @param jumpTokenRequest {IJumpTokenRequest}
     * @param externalParameters {object} object used to override the default request values
     * @returns IJumpTokenResponse
     */ AdobeIMS.prototype.jumpToken = function(jumpTokenRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        jumpTokenRequest.target_client_id = jumpTokenRequest.target_client_id || this.adobeIdData.client_id;
        jumpTokenRequest.target_scope = jumpTokenRequest.target_scope || this.adobeIdData.scope;
        return this.imsApis.jumpToken(jumpTokenRequest, externalParameters, this.adobeIdData.client_id);
    };
    AdobeIMS.prototype.getVerifierByKey = function(nonce) {
        return new $kTYb4.CodeChallenge().getVerifierByKey(nonce);
    };
    /**
     * The purpose is to sign in with a social account without navigating outside the page (i.e. via Ajax calls only)
     * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1106020498} Social Headless API
     * @param socialHeadlessSignInRequest {ISocialHeadlessSignInRequest} containing the social provider and the token obtained
     * @param externalParameters {object} object used to override the default request values
     * @returns TokenProfileResponse with the response from the IJT exchange
     * Will initiate a signIn flow if the response is a ride error of type 'ride_AdobeID_social`
     */ AdobeIMS.prototype.socialHeadlessSignIn = function(socialHeadlessSignInRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        return $40d99ea1022b4a68$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $40d99ea1022b4a68$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.imsApis.socialHeadlessSignIn(socialHeadlessSignInRequest, externalParameters).then(function(ijtResponse) {
                        return _this.exchangeIjt(ijtResponse.token);
                    }).catch(function(err) {
                        if (err.error === "ride_AdobeID_social") _this.signIn();
                        return Promise.reject(err);
                    })
                ];
            });
        });
    };
    return AdobeIMS;
}();
module.exports.AdobeIMS = $40d99ea1022b4a68$var$AdobeIMS;

});
parcelRegister("46lF8", function(module, exports) {
"use strict";
var $2fc886ac731259ce$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2fc886ac731259ce$var$StorageFactory_1 = $2fc886ac731259ce$var$__importDefault((parcelRequire("c6yNM")));

var $f4yrM = parcelRequire("f4yrM");
/**
 * nonce key used for store the Csrf nonce value
 */ var $2fc886ac731259ce$var$NONCE = "nonce";
var $2fc886ac731259ce$var$NONCE_LENGTH = 16;
module.exports.ONE_HOUR = 12960000;
/**
 * class used for the CSRF process
 */ var $2fc886ac731259ce$var$CsrfService = /** @class */ function() {
    /**
     *
     * @param clientId {String} the client id used for Csrf
     */ function CsrfService(clientId) {
        /**
         * represents the Storage instance used during Csrf flow
         */ this.storageInstance = null;
        /**
         * represents the storage key used to save the nonce values for current client Id
         */ this.nonceStorageKey = "";
        this.nonceStorageKey = "" + $2fc886ac731259ce$var$NONCE + clientId;
    }
    Object.defineProperty(CsrfService.prototype, "storage", {
        get: function() {
            if (!this.storageInstance) this.storageInstance = $2fc886ac731259ce$var$StorageFactory_1.default.getAvailableStorage();
            return this.storageInstance;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts the CSRF process by trying to save a random string value to available storage
     * @returns the nonce value
     */ CsrfService.prototype.initialize = function() {
        if (!this.isStorageAvailable()) return "";
        var nonce = CsrfService.generateNonce();
        var nonceStorageValue = this.getNonceFromStorage() || {};
        nonceStorageValue = this.clearOlderNonceKeys(nonceStorageValue);
        this.addNonceToObject(nonceStorageValue, nonce);
        this.saveNonceValuesToStorage(nonceStorageValue);
        return nonce.value;
    };
    /**
     *
     * @param nonceStorageValue represents the object used to store the nonce values
     * @param nonce represents the nonce value
     */ CsrfService.prototype.addNonceToObject = function(nonceStorageValue, nonce) {
        nonceStorageValue[nonce.value] = nonce.expiry;
    };
    /**
     * clears the local storage keys older than 1h
     * @param nonceStorageValue local storage object used to store nonce
     */ CsrfService.prototype.clearOlderNonceKeys = function(nonceStorageValue, olderThan) {
        if (olderThan === void 0) olderThan = module.exports.ONE_HOUR;
        var oneHourAgo = Date.now() - olderThan;
        var expiry = 0;
        Object.keys(nonceStorageValue).forEach(function(key) {
            expiry = parseInt(nonceStorageValue[key]);
            if (expiry < oneHourAgo) delete nonceStorageValue[key];
        });
        return nonceStorageValue;
    };
    /**
     * @param fragmentNonce represents the nonce value received after redirect from ims
     * @returns {boolean} true if nonce is valid, otherwise false
     */ CsrfService.prototype.verify = function(fragmentNonce) {
        if (!this.isStorageAvailable()) return true;
        var storageNonce = this.getNonceFromStorage();
        if (!storageNonce) return false;
        var nonceStorageValue = this.clearOlderNonceKeys(storageNonce);
        var isValidCsrf = (nonceStorageValue[fragmentNonce] || null) !== null;
        if (isValidCsrf) this.clearNonceValueFromStorage(nonceStorageValue, fragmentNonce);
        return isValidCsrf;
    };
    /**
     *
     * @param nonceStorageValue represents the saved nonce values into the Storage
     * @param fragmentNonce is nonce value which will be removed from Storage
     */ CsrfService.prototype.clearNonceValueFromStorage = function(nonceStorageValue, fragmentNonce) {
        delete nonceStorageValue[fragmentNonce];
        this.saveNonceValuesToStorage(nonceStorageValue);
    };
    /**
     * Returns the nonce values from storage as an Object or null
     * @returns {IDictionary | null}
     */ CsrfService.prototype.getNonceFromStorage = function() {
        var nonce = this.storage.getItem(this.nonceStorageKey);
        return nonce ? JSON.parse(nonce) : null;
    };
    /**
   * @param nonceValues the nonce values which will be saved to Storage
   */ CsrfService.prototype.saveNonceValuesToStorage = function(nonceValues) {
        this.storage.setItem(this.nonceStorageKey, JSON.stringify(nonceValues));
    };
    /**
     * function used to check if the local or session storage is available
     */ CsrfService.prototype.isStorageAvailable = function() {
        return !(this.storage instanceof $f4yrM.MemoryStorage);
    };
    /**
     * generate random string based on crypto object
     */ CsrfService.cryptoRndomString = function() {
        if (!window.crypto) return "";
        var array = new Uint32Array(3);
        window.crypto.getRandomValues(array);
        return array.join("").substr(0, $2fc886ac731259ce$var$NONCE_LENGTH);
    };
    /**
     * @function randomString
     * used to generate a random string during the initialization of Csrf process
     */ CsrfService.randomString = function() {
        var cryptorandomString = CsrfService.cryptoRndomString();
        if (cryptorandomString) return cryptorandomString;
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for(var i = 0; i < $2fc886ac731259ce$var$NONCE_LENGTH; i++)text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    };
    /**
     * generate a key value pair used for nonce
     * @returns INonce object
     */ CsrfService.generateNonce = function() {
        return {
            value: CsrfService.randomString(),
            expiry: new Date().getTime().toString()
        };
    };
    return CsrfService;
}();
module.exports.CsrfService = $2fc886ac731259ce$var$CsrfService;

});
parcelRegister("c6yNM", function(module, exports) {
"use strict";
var $8d010a87fdae3684$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f4yrM = parcelRequire("f4yrM");

var $h0Bwb = parcelRequire("h0Bwb");

var $8d010a87fdae3684$var$Log_1 = $8d010a87fdae3684$var$__importDefault((parcelRequire("545sK")));
/**
 * A cross-browser way to use `sessionStorage`
 *
 * @exports storage
 * @requires MemoryStorage
 */ var $8d010a87fdae3684$var$StorageFactory = /** @class */ function() {
    function StorageFactory() {
        this.memoryStorageInstance = null;
    }
    Object.defineProperty(StorageFactory.prototype, "memoryStorage", {
        get: function() {
            if (!this.memoryStorageInstance) this.memoryStorageInstance = new $f4yrM.MemoryStorage();
            return this.memoryStorageInstance;
        },
        enumerable: true,
        configurable: true
    });
    /**
    *
    * @param storageName represents the storage name
    * @returns the local or session storage; in case there is a problem with storage, the memory storage is returned
    */ StorageFactory.prototype.getStorageByName = function(storageName) {
        var storageInstance = this.getStorageInstanceByName(storageName);
        if (!storageInstance) return this.memoryStorage;
        return this.verifyStorage(storageInstance) ? storageInstance : this.memoryStorage;
    };
    /**
     * method used to get the avilable storage and to give the possibility to mock the behaviour
     * @param storageName the storage name used to get the storage
     * @returns Storage or null
     */ StorageFactory.prototype.getStorageInstanceByName = function(storageName) {
        if (storageName === $h0Bwb.STORAGE_MODE.MemoryStorage) return this.memoryStorage;
        try {
            return storageName === $h0Bwb.STORAGE_MODE.LocalStorage ? window.localStorage : window.sessionStorage;
        } catch (ex) {
            $8d010a87fdae3684$var$Log_1.default.warn("Please change your cookies settings in order to allow local data to be set");
            return null;
        }
    };
    /**
     * returns the available storage; the priority is local storage and after that the session storage
     * if no local or session storage is available, the Memory Storage is returned
     */ StorageFactory.prototype.getAvailableStorage = function() {
        var storage = this.getStorageByName($h0Bwb.STORAGE_MODE.LocalStorage);
        if (storage instanceof $f4yrM.MemoryStorage) return this.getStorageByName($h0Bwb.STORAGE_MODE.SessionStorage);
        return storage;
    };
    /**
     *
     * @param storage represents the storage instance
     * @returns true if storage is working as expected otherwise false
     */ StorageFactory.prototype.verifyStorage = function(storage) {
        var storageKey = "test";
        try {
            storage.setItem(storageKey, "true");
            var storageValue = storage.getItem(storageKey);
            if (storageValue !== "true") return false;
            storage.removeItem(storageKey);
            return true;
        } catch (ex) {
            return false;
        }
    };
    return StorageFactory;
}();
module.exports.default = new $8d010a87fdae3684$var$StorageFactory();

});
parcelRegister("f4yrM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * In-Memory polyFill for localStorage and sessionStorage.
 *
 * @constructor
 * @description Needed for Mac and iOS Safari (v <= 10) in Private Mode. Note that this object doesn't actually
 * persist data across refresh, it just implements the [Storage]{@link external:Storage} interface.
 * @exports memoryStorage
 */ var $af91f32f31c51b80$var$MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        /**
         * @type {!Object}
         */ this.data = {};
        /**
         * property added in order to be compatible with Storage class
         */ this.length = 0;
    }
    /**
     * clear the memory data
     */ MemoryStorage.prototype.clear = function() {
        this.data = {};
        this.length = 0;
    };
    /**
     * @param key {String} represents the used key to get a value
     * @returns {Object} the value associated with the input key
     */ MemoryStorage.prototype.getItem = function(key) {
        var value = this.data[key];
        return value ? value : null;
    };
    /**
     *
     * @param key {string} represent the key which will be removed from memory
     * @returns {boolean} true if the key is removed otherwise false
     */ MemoryStorage.prototype.removeItem = function(key) {
        if (!this.data[key]) return false;
        delete this.data[key];
        --this.length;
        return true;
    };
    /**
     * @key {String} - the used key to store a value into memory
     * @value {any} - value associated with the input key
     */ MemoryStorage.prototype.setItem = function(key, value) {
        if (!this.data[key]) ++this.length;
        this.data[key] = value;
    };
    MemoryStorage.prototype.key = function(index) {
        throw new Error("Method not implemented. " + index);
    };
    return MemoryStorage;
}();
module.exports.MemoryStorage = $af91f32f31c51b80$var$MemoryStorage;

});

parcelRegister("h0Bwb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AdobeIdKey = "adobeid";
module.exports.AdobeIMSKey = "adobeIMS";
module.exports.AdobeImsFactory = "adobeImsFactory";
module.exports.DEFAULT_LANGUAGE = "en_US";
var $c61f8a15e4f009d0$var$STORAGE_MODE;
(function(STORAGE_MODE) {
    STORAGE_MODE["LocalStorage"] = "local";
    STORAGE_MODE["SessionStorage"] = "session";
    STORAGE_MODE["MemoryStorage"] = "memory";
})($c61f8a15e4f009d0$var$STORAGE_MODE = module.exports.STORAGE_MODE || (module.exports.STORAGE_MODE = {}));
module.exports.HEADERS = {
    AUTHORIZATION: "Authorization",
    X_IMS_CLIENT_ID: "X-IMS-ClientId",
    RETRY_AFTER: "Retry-after"
};
module.exports.PROFILE_STORAGE_KEY = "adobeid_ims_profile";
module.exports.TOKEN_STORAGE_KEY = "adobeid_ims_access_token";
module.exports.ON_IMSLIB_INSTANCE = "onImsLibInstance";
module.exports.ASK_FOR_IMSLIB_INSTANCE_DOM_EVENT_NAME = "getImsLibInstance";

});

parcelRegister("545sK", function(module, exports) {
"use strict";
var $3b019040ce4c8a4d$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3b019040ce4c8a4d$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3b019040ce4c8a4d$var$__read(arguments[i]));
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Wrapper for <code>console</code>. Checks <code>console</code> is available and <code>debug</code> Mode is enabled.
 *
 * @exports log
 *
 */ var $3b019040ce4c8a4d$var$Log = /** @class */ function() {
    function Log() {
        var _this = this;
        this.logEnabled = false;
        /**
         * Wrapper function.
         *
         * @param {String} method - Which <code>console</code> method to use.
         * @param {*} args - Arguments object
         *
         * @private
         */ this.print = function(method, args) {
            if (!_this.logEnabled) return;
            method.apply(void 0, $3b019040ce4c8a4d$var$__spread(args));
        };
        /**
         * Writes an error to the console when the evaluated expression is false.
         *
         * @example
         * log.assert(1 == 2, "Counting is hard.");
         *
         * @param {Boolean} expression - Expression to evaluate.
         * @param {String} message - Message to print if <code>epxression</code> is <code>false</code>.
         *
         * @static
         */ this.assert = function(val, message) {
            _this.print(console.assert, [
                val,
                message
            ]);
        };
        /**
         * Writes an error to the console when the evaluated expression is false.
         *
         * @example
         * log.assert(1 == 2, "Counting is hard.");
         *
         * @param {Boolean} expression - Expression to evaluate.
         * @param {String} message - Message to print if <code>epxression</code> is <code>false</code>.
         *
         * @static
         */ this.assertCondition = function(condition, message) {
            if (!condition()) _this.print(console.error, [
                message
            ]);
        };
        /**
         * Prints a message similar to <code>console.log()</code>, styles the message like an error, and includes a stack
         * trace from where the method wasval, called.
         *
         * @see {@link https://developers.google.com/web/tools/chrome-devtools/console/#filtering_the_console_output | Filtering the Console output}
         *
         * @example
         * log.error("Define window.adobeid", "would you?!");
         * @param {String} message - Message to print.
         */ this.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.error, args);
        };
        /**
         * logs a warnig message
         */ this.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.warn, args);
        };
        /**
         * Prints a message like <code>console.log()</code> but also shows an icon (blue circle with white "i") next to the
         * output.
         *
         * <code>console.info()</code> can be filtered in the Console, whereas <code>console.log()</code> can not.
         *
         * @example
         * log.info("Imslib.js Ready", "to Rumble");
         *
         * @param {String} message - Message to print.
         *
         * @static
         */ this.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            _this.print(console.info, args);
        };
    }
    Log.prototype.enableLogging = function() {
        this.logEnabled = true;
    };
    Log.prototype.disableLogging = function() {
        this.logEnabled = false;
    };
    return Log;
}();
module.exports.default = new $3b019040ce4c8a4d$var$Log();

});



parcelRegister("FRmK4", function(module, exports) {
"use strict";
var $07dd39c998db6176$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $07dd39c998db6176$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $07dd39c998db6176$var$UrlHelper_1 = $07dd39c998db6176$var$__importDefault((parcelRequire("fiyt1")));

var $07dd39c998db6176$var$Environment_1 = $07dd39c998db6176$var$__importDefault((parcelRequire("1Sn1w")));

var $jYOtt = parcelRequire("jYOtt");
/**
 * command responsable for user sign in
 */ var $07dd39c998db6176$var$SignInService = /** @class */ function(_super) {
    $07dd39c998db6176$var$__extends(SignInService, _super);
    function SignInService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ _this.signIn = function(redirectRequest) {
            var url = _this.createRedirectUrl(redirectRequest);
            $07dd39c998db6176$var$UrlHelper_1.default.setHrefUrl(url);
        };
        /**
         *
         * @param token { String } value used to authorize a user based on this token value
         * @param redirectRequest { IRedirectRequest } contains the object properties which are passed to the authorize api
         */ _this.authorizeToken = function(token, redirectRequest) {
            var parameters = _this.composeRedirectUrl(redirectRequest);
            if (token) {
                parameters.user_assertion = token;
                parameters.user_assertion_type = "urn:ietf:params:oauth:client-assertion-type:jwt-bearer";
            }
            var postForm = _this.createAuthorizeForm(parameters);
            postForm.submit();
        };
        return _this;
    }
    /**
     * returns a html form containing all the properties from the parameter object
     * @param parameters {object} contains the properties which will be passed to authorize api (as form submit post action)
     */ SignInService.prototype.createAuthorizeForm = function(parameters) {
        var formAction = $07dd39c998db6176$var$Environment_1.default.baseUrlAdobe + "/ims/authorize/v1";
        var form = document.createElement("form");
        form.style.display = "none";
        form.setAttribute("method", "post");
        form.setAttribute("action", formAction);
        var formEl = null;
        var paramValue = null;
        var paramValueAsString = "";
        for(var propertyName in parameters){
            paramValue = parameters[propertyName];
            if (typeof paramValue === "object") {
                if (Object.keys(paramValue).length === 0) continue;
                paramValueAsString = JSON.stringify(paramValue);
            } else paramValueAsString = paramValue;
            if (paramValueAsString !== "") {
                formEl = this.createFormElement("input", "text", propertyName, paramValueAsString);
                form.appendChild(formEl);
            }
        }
        document.getElementsByTagName("body")[0].appendChild(form);
        return form;
    };
    /**
     * create a new html form element; this element will be added to the form
     * @param inputType {String} input html element type
     * @param type {String} type of the input element
     * @param name {String} name of the input element
     * @param value {String} value for the element
     */ SignInService.prototype.createFormElement = function(inputType, type, name, value) {
        var formElement = document.createElement(inputType);
        formElement.setAttribute("type", type);
        formElement.setAttribute("name", name);
        formElement.setAttribute("value", value);
        return formElement;
    };
    return SignInService;
}($jYOtt.BaseSignInService);
module.exports.SignInService = $07dd39c998db6176$var$SignInService;

});
parcelRegister("fiyt1", function(module, exports) {
"use strict";
var $b23345e52e28d72b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b23345e52e28d72b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to implement the main functions used for query strings
 */ var $b23345e52e28d72b$var$UrlHelper = /** @class */ function() {
    function UrlHelper() {}
    /**
   * Encodes data as a query string.
   * @param {Object} data - The data.
   * @returns {string} - The encoded string.
    * @example
    * encoded = uriEncodeData({
    *   first: true,
    *   foo: {
    *     bar: 'foobar'
    *   }
    * }) // -> first=true&foo=%7B%22bar%22%3A%22foobar%22%7D
    */ UrlHelper.prototype.uriEncodeData = function(data) {
        if (typeof data !== "object") return "";
        var encodings = [];
        var encodedValue = "";
        var keyValue;
        for(var key in data){
            keyValue = data[key];
            if (keyValue === undefined) continue;
            encodedValue = this.encodeValue(keyValue);
            encodings.push(encodeURIComponent(key) + "=" + encodedValue);
        }
        return encodings.join("&");
    };
    /**
   * @param value : any; represents the value which will be encoded
   * @returns string.
   */ UrlHelper.prototype.encodeValue = function(value) {
        if (value === null) return "null";
        if (typeof value === "object") return encodeURIComponent(JSON.stringify(value));
        return encodeURIComponent(value);
    };
    /**
   * Opens the URL in the current page
   *
   * @param {!string} url
   */ UrlHelper.prototype.replaceUrl = function(url) {
        if (!url) return;
        window.location.replace(url);
    };
    UrlHelper.prototype.sleep = function(timeout) {
        return $b23345e52e28d72b$var$__awaiter(this, void 0, void 0, function() {
            return $b23345e52e28d72b$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    })
                ];
            });
        });
    };
    UrlHelper.prototype.replaceUrlAndWait = function(url, timeout) {
        return $b23345e52e28d72b$var$__awaiter(this, void 0, void 0, function() {
            return $b23345e52e28d72b$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!url) return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        window.location.replace(url);
                        return [
                            4 /*yield*/ ,
                            this.sleep(timeout)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                }
            });
        });
    };
    /**
   * Opens the URL in the current page
   * @param {!string} url
   */ UrlHelper.prototype.setHrefUrl = function(url) {
        if (!url) return;
        window.location.href = url;
    };
    /**
  * Change the hash from url to a new value without reloading the page
  * @param hash {String} represents the new hash value
  *
  */ UrlHelper.prototype.setHash = function(hash) {
        if (hash === void 0) hash = "";
        window.location.hash = hash;
    };
    return UrlHelper;
}();
module.exports.default = new $b23345e52e28d72b$var$UrlHelper();

});

parcelRegister("1Sn1w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3O0eZ = parcelRequire("3O0eZ");

var $9U37n = parcelRequire("9U37n");
/**
 * class used to store the variables used for ims flow
 */ var $15dcb1988bc2cdb9$var$Environment = /** @class */ function() {
    function Environment() {
        /**
         * @property {String} Represents the base url used on api (back-end) call in case of getProfile, getUserInfo and validateToken;
         */ this.baseUrlAdobe = "";
        /**
         * @property {string} Represents the base url used on api (back-end) call in case of logoutToken, checkStatus, listSocialProviders and exchangeIjt;
         */ this.baseUrlServices = "";
        /**
         * @property {object} Represents the base url used on api (back-end) call in case of checkToken;
         */ this.checkTokenEndpoint = new $9U37n.CheckTokenEndpoint();
        /**
         * @property {string} this parameter is passed to redirect uri during a sign in or sign out operation
         */ this.jslibver = "v2-v0.31.0-2-g1e8a8a8";
    }
    Environment.prototype.loadEnvironment = function(environment, useProxy, hostname) {
        if (useProxy === void 0) useProxy = false;
        if (hostname === void 0) hostname = "";
        var isStage = environment === $3O0eZ.IEnvironment.STAGE;
        if (isStage) {
            this.baseUrlAdobe = "https://ims-na1-stg1.adobelogin.com";
            this.baseUrlServices = "https://adobeid-na1-stg1.services.adobe.com";
        } else {
            this.baseUrlAdobe = "https://ims-na1.adobelogin.com";
            this.baseUrlServices = "https://adobeid-na1.services.adobe.com";
        }
        this.checkTokenEndpoint = $9U37n.CheckTokenEndpoint.computeEndpoint(useProxy, hostname, isStage, this.baseUrlServices);
    };
    return Environment;
}();
module.exports.default = new $15dcb1988bc2cdb9$var$Environment();

});
parcelRegister("3O0eZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Enumeration values for available environments
 */ var $2c563a6566325c52$var$IEnvironment;
(function(IEnvironment) {
    /**
     * Stage environment
     */ IEnvironment["STAGE"] = "stg1";
    /**
     * Prod environment
     */ IEnvironment["PROD"] = "prod";
})($2c563a6566325c52$var$IEnvironment = module.exports.IEnvironment || (module.exports.IEnvironment = {}));

});

parcelRegister("9U37n", function(module, exports) {
"use strict";
var $735bc32d1524e105$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $735bc32d1524e105$var$CheckTokenEndpoint = /** @class */ function() {
    function CheckTokenEndpoint(proxied, url, fallbackUrl) {
        if (proxied === void 0) proxied = false;
        if (url === void 0) url = "";
        if (fallbackUrl === void 0) fallbackUrl = "";
        this.proxied = proxied;
        this.url = url;
        this.fallbackUrl = fallbackUrl;
    }
    CheckTokenEndpoint.computeEndpoint = function(useProxy, hostname, isStage, servicesUrl) {
        var e_1, _a;
        if (useProxy) {
            var domainMap = isStage ? CheckTokenEndpoint.THIRD_PARTY_DOMAINS_STAGE : CheckTokenEndpoint.THIRD_PARTY_DOMAINS_PROD;
            try {
                for(var _b = $735bc32d1524e105$var$__values(Object.keys(domainMap)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var domain = _c.value;
                    if (hostname === domain || hostname.endsWith("." + domain)) return new CheckTokenEndpoint(true, domainMap[domain], servicesUrl);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        return new CheckTokenEndpoint(false, servicesUrl);
    };
    CheckTokenEndpoint.prototype.shouldFallbackToAdobe = function(e) {
        if (!this.proxied) return false;
        return e.error === "feature_disabled" && e.error_description === "cdsc";
    };
    // The /check/v*/token API is proxied on some third party domains and
    // imslib should use those endpoints when running on those domains.
    CheckTokenEndpoint.THIRD_PARTY_DOMAINS_PROD = {
        "behance.net": "https://sso.behance.net"
    };
    CheckTokenEndpoint.THIRD_PARTY_DOMAINS_STAGE = {
        "s2stagehance.com": "https://sso.s2stagehance.com"
    };
    return CheckTokenEndpoint;
}();
module.exports.CheckTokenEndpoint = $735bc32d1524e105$var$CheckTokenEndpoint;

});


parcelRegister("jYOtt", function(module, exports) {
"use strict";
var $e8bac61511638101$var$__assign = module.exports && module.exports.__assign || function() {
    $e8bac61511638101$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8bac61511638101$var$__assign.apply(this, arguments);
};
var $e8bac61511638101$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e8bac61511638101$var$UrlHelper_1 = $e8bac61511638101$var$__importDefault((parcelRequire("fiyt1")));

var $e8bac61511638101$var$Environment_1 = $e8bac61511638101$var$__importDefault((parcelRequire("1Sn1w")));

var $piMW2 = parcelRequire("piMW2");

var $3y0vB = parcelRequire("3y0vB");
/**
 * command responsable for user sign in
 */ var $e8bac61511638101$var$BaseSignInService = /** @class */ function() {
    function BaseSignInService() {
        var _this = this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ this.composeRedirectUrl = function(redirectRequest) {
            var apiName = "authorize";
            var apiParameters = redirectRequest.apiParameters, _a = redirectRequest.externalParameters, externalParameters = _a === void 0 ? {} : _a, _b = redirectRequest.adobeIdRedirectUri, adobeIdRedirectUri = _b === void 0 ? "" : _b, clientId = redirectRequest.clientId, localeAdobeId = redirectRequest.locale, _c = redirectRequest.state, state = _c === void 0 ? {} : _c;
            var _d = redirectRequest.scope, scope = _d === void 0 ? externalParameters["scope"] || apiParameters["scope"] || "" : _d;
            var apiExternalParams = $piMW2.RedirectHelper.mergeApiParamsWithExternalParams(apiParameters, externalParameters, apiName);
            if (state) apiExternalParams.state = $3y0vB.merge(apiExternalParams.state || {}, state);
            var redirectUrl = $piMW2.RedirectHelper.createRedirectUrl(adobeIdRedirectUri, clientId, apiExternalParams, apiName, scope);
            var locale = externalParameters.locale || localeAdobeId || "";
            var // eslint-disable-next-line @typescript-eslint/camelcase
            _e = redirectRequest.response_type, // eslint-disable-next-line @typescript-eslint/camelcase
            response_type = _e === void 0 ? apiExternalParams["response_type"] || "" : _e;
            var parameters = $e8bac61511638101$var$__assign($e8bac61511638101$var$__assign({}, apiExternalParams), {
                client_id: clientId,
                scope: scope,
                locale: locale,
                response_type: response_type,
                jslVersion: $e8bac61511638101$var$Environment_1.default.jslibver,
                redirect_uri: redirectUrl
            });
            return parameters;
        };
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         */ this.createRedirectUrl = function(redirectRequest) {
            var parameters = _this.composeRedirectUrl(redirectRequest);
            var queryStrings = $e8bac61511638101$var$UrlHelper_1.default.uriEncodeData(parameters);
            var url = $e8bac61511638101$var$Environment_1.default.baseUrlAdobe + "/ims/authorize/v1?" + queryStrings;
            return url;
        };
    }
    return BaseSignInService;
}();
module.exports.BaseSignInService = $e8bac61511638101$var$BaseSignInService;

});
parcelRegister("piMW2", function(module, exports) {
"use strict";
var $04c0e8dfc98bc994$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $04c0e8dfc98bc994$var$ApiHelpers_1 = $04c0e8dfc98bc994$var$__importDefault((parcelRequire("9zwbo")));

var $3y0vB = parcelRequire("3y0vB");
var $04c0e8dfc98bc994$var$RedirectHelper = /** @class */ function() {
    function RedirectHelper() {}
    /**
    * returns the initial redirect url; the priority value is redirect_uri from external parameters, adobeId and finally the href value from browsers
    * @param externalParameters
    * @param adobeIdRedirectUri
    */ RedirectHelper.getInitialRedirectUri = function(externalParameters, adobeIdRedirectUri) {
        var redirectParam = externalParameters["redirect_uri"] || adobeIdRedirectUri || window.location.href;
        var redirectValue = typeof redirectParam === "function" ? redirectParam() : redirectParam;
        var fromImsIndex = redirectValue.indexOf("from_ims");
        if (fromImsIndex === -1) return redirectValue;
        if (redirectValue[fromImsIndex - 1] === "#") fromImsIndex--;
        return redirectValue.substr(0, fromImsIndex);
    };
    /**
    * create the return url which it will be passed to authorize or logout endpoint
    * @param adobeIdRedirectUri {string} - represents the redirect_uri? set on AdobeId;
    * @param clientId {string} - represents the client id from AdobeId
    * @param externalParameters {Object} external parameters passed to library
    * @param apiName {string} api name
    *
    * @returns {string} final redirect url used for sign-in or reauth (authorize) or logout
    */ RedirectHelper.createDefaultRedirectUrl = function(adobeIdRedirectUri, clientId, externalParameters, apiName) {
        var initialRedirectUri = this.getInitialRedirectUri(externalParameters, adobeIdRedirectUri);
        //encode the hash in case that exists
        var redirectUri = this.createOldHash(initialRedirectUri);
        return redirectUri.indexOf("?") > 0 ? redirectUri + "&client_id=" + clientId + "&api=" + apiName : redirectUri + "?client_id=" + clientId + "&api=" + apiName;
    };
    /**
     * <uml>
     * start
     * :CreateDefaultRedirectUrl ;
     * :merge api parameters with external parameters
     * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
     * end
     * </uml>
     *
     * create the return url which it will be passed to authorization endpoint
     * @param redirectUri {string} - represents the base url href value
     * @param clientId {string} - represents the client id
     * @param externalParameters {Object} external parameters passed to library
     * @param apiName {string} api name
     * @parm scope {string} scope of sign in
     * @returns {string} final redirect url used for sign in
     */ RedirectHelper.createRedirectUrl = function(adobeIdRedirectUri, clientId, externalParameters, apiName, scope) {
        if (scope === void 0) scope = "";
        var redirectUri = this.createDefaultRedirectUrl(adobeIdRedirectUri, clientId, externalParameters, apiName);
        scope = scope || externalParameters["scope"] || "";
        if (scope) redirectUri = redirectUri + "&scope=" + scope;
        var reauth = externalParameters["reauth"] || "";
        if (reauth) redirectUri = redirectUri + "&reauth=" + reauth;
        return redirectUri;
    };
    /**
     * @param source {string} represent the url value
     * @returns {string} the url with hash
     */ RedirectHelper.createOldHash = function(source) {
        var index = source.indexOf("#");
        if (index < 0) return source + "#old_hash=&from_ims=true";
        var baseUrl = source.substring(0, index);
        var hash = source.substring(index + 1);
        return baseUrl + "#old_hash=" + hash + "&from_ims=true";
    };
    RedirectHelper.mergeApiParamsWithExternalParams = function(apiParameters, externalParameters, apiName) {
        return $3y0vB.merge($04c0e8dfc98bc994$var$ApiHelpers_1.default.getCustomApiParameters(apiParameters, apiName), externalParameters);
    };
    return RedirectHelper;
}();
module.exports.RedirectHelper = $04c0e8dfc98bc994$var$RedirectHelper;

});
parcelRegister("9zwbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3y0vB = parcelRequire("3y0vB");
/**
 * class used to store the helper functions
 */ var $6f8058c60c9751b6$var$ApiHelpers = /** @class */ function() {
    function ApiHelpers() {
        /**
       * Checks [adobeid.api_parameters]{@link adobeid} for custom parameters for an API.
       * @param apiName - represents the used api name
       * @param apiParameters - represents the parameters set from outside for api endpoints read from adobeId
       * @returns {!Object}
       */ this.getCustomApiParameters = function(apiParameters, apiName) {
            return apiParameters[apiName] || {};
        };
    }
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @param apiParameters the api parameters from AdobeId data
     * @param apiName api name
     * @returns IDictionary representing the merged properties
     */ ApiHelpers.prototype.mergeExternalParameters = function(externalParameters, apiParameters, apiName) {
        return $3y0vB.merge(this.getCustomApiParameters(apiParameters, apiName), externalParameters);
    };
    /***
     * @param value {String} represents the
     */ ApiHelpers.prototype.toJson = function(value) {
        try {
            if (typeof value !== "string") return value;
            return JSON.parse(value);
        } catch (_a) {
            return null;
        }
    };
    return ApiHelpers;
}();
module.exports.default = new $6f8058c60c9751b6$var$ApiHelpers();

});
parcelRegister("3y0vB", function(module, exports) {
"use strict";
// proudly found here: https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */ function $2954f11b255ee0e8$var$isObject(item) {
    return item !== null && item !== undefined && typeof item === "object" && !Array.isArray(item);
}
module.exports.isObject = $2954f11b255ee0e8$var$isObject;
/**
   * Deep merge two objects.
   * @param target
   * @param source
   */ function $2954f11b255ee0e8$var$merge(target, source) {
    if (target === null || target === undefined) return source;
    if (target === source) return target;
    if (!$2954f11b255ee0e8$var$isObject(target)) return target;
    var output = Object.assign({}, target);
    if ($2954f11b255ee0e8$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($2954f11b255ee0e8$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $2954f11b255ee0e8$var$merge(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}
module.exports.merge = $2954f11b255ee0e8$var$merge;

});





parcelRegister("TpXdn", function(module, exports) {
"use strict";
var $0a69451b8bc7ce3d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0a69451b8bc7ce3d$var$__assign = module.exports && module.exports.__assign || function() {
    $0a69451b8bc7ce3d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a69451b8bc7ce3d$var$__assign.apply(this, arguments);
};
var $0a69451b8bc7ce3d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $0a69451b8bc7ce3d$var$PopupOpener_1 = $0a69451b8bc7ce3d$var$__importDefault((parcelRequire("i2iWl")));

var $jYOtt = parcelRequire("jYOtt");
/**
 * command responsable for user sign in
 */ var $0a69451b8bc7ce3d$var$SignInModalService = /** @class */ function(_super) {
    $0a69451b8bc7ce3d$var$__extends(SignInModalService, _super);
    /**
     * constructor of the SignInModalService
     */ function SignInModalService(onPopupMessage, popupSettings) {
        var _this = _super.call(this) || this;
        /**
         * execute the sign in method which redirects the user to the login page
         * <uml>
         * start
         * :CreateRedirectUrl;
         * :merge api parameters with external parameters
         * :encode the merged parameters and call the /ims/authorize/v1/${encodedParameters} url
         * end
         * </uml>
         *
         * @param {IRedirectRequest} redirectRequest. contains all the adobeId necessary properties necessary for sign in
         * @param onPopupMessage {Function} represents the function used, as a hook, to be triggered when a message comes from popup
         */ _this.signIn = function(redirectRequest) {
            redirectRequest.state = $0a69451b8bc7ce3d$var$__assign($0a69451b8bc7ce3d$var$__assign({}, redirectRequest.state), {
                imslibmodal: true
            });
            var nonce = redirectRequest.state.nonce;
            var url = _this.createRedirectUrl(redirectRequest);
            $0a69451b8bc7ce3d$var$PopupOpener_1.default.openSignInWindow(url, nonce, _this.popupSettings, _this.onPopupMessage);
        };
        _this.onPopupMessage = onPopupMessage;
        _this.popupSettings = popupSettings;
        return _this;
    }
    return SignInModalService;
}($jYOtt.BaseSignInService);
module.exports.SignInModalService = $0a69451b8bc7ce3d$var$SignInModalService;

});
parcelRegister("i2iWl", function(module, exports) {
"use strict";
var $d2171afcec2ef10a$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d2171afcec2ef10a$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d2171afcec2ef10a$var$__read(arguments[i]));
    return ar;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d2171afcec2ef10a$var$URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
var $d2171afcec2ef10a$var$ALLOWED_ORIGINS = [
    "https://auth.services.adobe.com",
    "https://auth-stg1.services.adobe.com",
    "https://localhost.corp.adobe.com:9000"
];
/**
 * class used to open a new authorization popup
 */ var $d2171afcec2ef10a$var$PopupOpener = /** @class */ function() {
    function PopupOpener() {
        var _this = this;
        /**
         * refernce of the window object
         */ this.windowObjectReference = null;
        /**
         * represents the previous url used to open the popup window
         */ this.previousUrl = "";
        /**
         * open the popup window used for authorization
         * @param url {String} url of the popup window
         * @param popupSettings {object} contains the popup setting as height and width
         * @param onPopupMessage {Function} function used to transfer the data from popup
         */ this.openSignInWindow = function(url, popupHaspProp, popupSettings, onPopupMessage) {
            _this.onProcessLocation = onPopupMessage;
            _this.allowOrigin = popupSettings.allowOrigin;
            if (_this.timerId) clearInterval(_this.timerId);
            // remove any existing event listeners
            window.removeEventListener("message", _this.receiveMessage);
            // add the listener for receiving a message from the popup
            window.addEventListener("message", _this.receiveMessage);
            // window features
            var strWindowFeatures = "toolbar=no, menubar=no, width=" + popupSettings.width + ", height=" + popupSettings.height + ", top=" + popupSettings.top + ", left=" + popupSettings.left;
            if (!_this.windowObjectReference || _this.windowObjectReference && _this.windowObjectReference.closed) /* if the pointer to the window object in memory does not exist or if such pointer exists but the window was closed */ _this.windowObjectReference = window.open(url, popupSettings.title, strWindowFeatures);
            else if (_this.previousUrl !== url) {
                /* if the resource to load is different, then we load it in the already opened secondary window and then  we bring such window back on top/in front of its parent window. */ _this.windowObjectReference = window.open(url, popupSettings.title, strWindowFeatures);
                _this.windowObjectReference && _this.windowObjectReference.focus();
            } else /* else the window reference must exist and the window is not closed; therefore, we can bring it back on top of any other window with the focus() method. There would be no need to re-create
                    the window or to reload the referenced resource. */ _this.windowObjectReference.focus();
            var popupWnd = _this.windowObjectReference || {};
            if (!popupWnd.opener) _this.timerId = setInterval(function() {
                if (!popupWnd[popupHaspProp]) return;
                clearInterval(_this.timerId);
                _this.onProcessLocation && _this.onProcessLocation(popupWnd[popupHaspProp]);
                delete popupWnd[popupHaspProp];
                _this.windowObjectReference && _this.windowObjectReference.close();
            }, 500);
            // assign the previous URL
            _this.previousUrl = url;
        };
        /**
         * function used to receive the message from the popup window
         * @param event {window event} contains the dom event passed by popup window
         */ this.receiveMessage = function(event) {
            if (!$d2171afcec2ef10a$var$__spread($d2171afcec2ef10a$var$ALLOWED_ORIGINS, [
                _this.allowOrigin
            ]).includes(event.origin)) return;
            try {
                if (!$d2171afcec2ef10a$var$URL_REGEX.test(event.data)) return;
            } catch (err) {
                return;
            }
            _this.onProcessLocation && _this.onProcessLocation(event.data);
        };
    }
    return PopupOpener;
}();
module.exports.default = new $d2171afcec2ef10a$var$PopupOpener();

});


parcelRegister("lU5Be", function(module, exports) {
"use strict";
var $ff232bdcae1207d4$var$__assign = module.exports && module.exports.__assign || function() {
    $ff232bdcae1207d4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ff232bdcae1207d4$var$__assign.apply(this, arguments);
};
var $ff232bdcae1207d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $piMW2 = parcelRequire("piMW2");

var $ff232bdcae1207d4$var$UrlHelper_1 = $ff232bdcae1207d4$var$__importDefault((parcelRequire("fiyt1")));

var $ff232bdcae1207d4$var$Environment_1 = $ff232bdcae1207d4$var$__importDefault((parcelRequire("1Sn1w")));
/**
 * command responsable for user sign out
 */ var $ff232bdcae1207d4$var$SignOutService = /** @class */ function() {
    function SignOutService() {
        /**
         * @param {IRedirectRequest} redirectRequest. contains all the necessary properties necessary for sign out
         */ this.signOut = function(redirectRequest) {
            var apiName = "logout";
            // eslint-disable-next-line @typescript-eslint/camelcase
            var apiParameters = redirectRequest.apiParameters, externalParameters = redirectRequest.externalParameters, _a = redirectRequest.adobeIdRedirectUri, adobeIdRedirectUri = _a === void 0 ? "" : _a, clientId = redirectRequest.clientId;
            var apiExternalParams = $piMW2.RedirectHelper.mergeApiParamsWithExternalParams(apiParameters, externalParameters, apiName);
            var redirectUrl = $piMW2.RedirectHelper.createDefaultRedirectUrl(adobeIdRedirectUri, clientId, apiExternalParams, apiName);
            var parameters = $ff232bdcae1207d4$var$__assign($ff232bdcae1207d4$var$__assign({}, apiExternalParams), {
                client_id: clientId,
                redirect_uri: redirectUrl,
                jslVersion: $ff232bdcae1207d4$var$Environment_1.default.jslibver
            });
            var queryStrings = $ff232bdcae1207d4$var$UrlHelper_1.default.uriEncodeData(parameters);
            var url = $ff232bdcae1207d4$var$Environment_1.default.baseUrlAdobe + "/ims/logout/v1?" + queryStrings;
            $ff232bdcae1207d4$var$UrlHelper_1.default.replaceUrl(url);
        };
    }
    return SignOutService;
}();
module.exports.SignOutService = $ff232bdcae1207d4$var$SignOutService;

});

parcelRegister("343mA", function(module, exports) {
"use strict";
var $23b45ab7fb8eab0e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $23b45ab7fb8eab0e$var$__assign = module.exports && module.exports.__assign || function() {
    $23b45ab7fb8eab0e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23b45ab7fb8eab0e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h0Bwb = parcelRequire("h0Bwb");

var $lkoSZ = parcelRequire("lkoSZ");

var $3ux7u = parcelRequire("3ux7u");

var $c7IJY = parcelRequire("c7IJY");

var $1V6oS = parcelRequire("1V6oS");

var $gdMgf = parcelRequire("gdMgf");
/**
 *  Class used to store the adobe data values.
 *
 *  Ims library will use these values for all operations
 */ var $23b45ab7fb8eab0e$var$AdobeIdData = /** @class */ function(_super) {
    $23b45ab7fb8eab0e$var$__extends(AdobeIdData, _super);
    /**
     * @constructor Create the adobeIdData object with all necessary properties from adobeData input paramater
     *
     * It uses the input adobeData parameter or the object stored in window.adobeid
     */ function AdobeIdData(adobeData) {
        if (adobeData === void 0) adobeData = null;
        var _this = _super.call(this, adobeData) || this;
        /** @function {adobeid.onAccessTokenHasExpired} onAccessTokenHasExpired
         *  Function to be executed if the 'access_token' is invalid.
         */ _this.onAccessTokenHasExpired = null;
        /**  @function {adobeid.onAccessToken} - Function to be executed once imslib.js has acquired
         * an `access_token`.
         */ _this.onAccessToken = null;
        /**
         * @function {adobeid.onReauthAccessToken} Function used to trigger the reauth access token
         */ _this.onReauthAccessToken = null;
        /**
         * @function {adobeid.onError}
         * Function used to notify external libraries for ims errors
         */ _this.onError = null;
        /**
         * Handlers object is used to invoke the adobe id data events.
         *
         * When a token, profile is aquired, or token is expired and library is fully intialized, an event is triggered
         */ _this.handlers = {
            triggerOnAccessToken: function(data) {
                _this.onAccessToken && _this.onAccessToken(data);
            },
            triggerOnReauthAccessToken: function(data) {
                _this.onReauthAccessToken && _this.onReauthAccessToken(data);
            },
            triggerOnAccessTokenHasExpired: function() {
                _this.onAccessTokenHasExpired && _this.onAccessTokenHasExpired();
            },
            triggerOnReady: function(context) {
                if (context === void 0) context = null;
                _this.onReady && _this.onReady(context);
            },
            triggerOnError: function(errorType, error) {
                _this.onError && _this.onError(errorType, error);
            }
        };
        var adobeid = adobeData ? adobeData : window[$h0Bwb.AdobeIdKey];
        if (!adobeid || !adobeid.client_id) throw new Error("Please provide required adobeId, client_id information");
        var standalone = adobeid.standalone, autoValidateToken = adobeid.autoValidateToken, _a = adobeid.modalSettings, modalSettings = _a === void 0 ? {} : _a, _b = adobeid.modalMode, modalMode = _b === void 0 ? false : _b, onAccessToken = adobeid.onAccessToken, onReauthAccessToken = adobeid.onReauthAccessToken, onAccessTokenHasExpired = adobeid.onAccessTokenHasExpired, onReady = adobeid.onReady, onError = adobeid.onError, overrideErrorHandler = adobeid.overrideErrorHandler, onModalModeSignInComplete = adobeid.onModalModeSignInComplete;
        if (standalone && standalone.token) _this.standalone = new $3ux7u.StandaloneToken(standalone);
        _this.modalSettings = new $lkoSZ.PopupSettings(modalSettings);
        _this.modalMode = modalMode;
        _this.autoValidateToken = !!autoValidateToken;
        _this.onAccessToken = onAccessToken ? onAccessToken : null;
        _this.onReauthAccessToken = onReauthAccessToken ? onReauthAccessToken : null;
        _this.onAccessTokenHasExpired = onAccessTokenHasExpired ? onAccessTokenHasExpired : null;
        _this.onReady = onReady ? onReady : null;
        _this.onError = onError ? onError : null;
        _this.overrideErrorHandler = overrideErrorHandler;
        _this.onModalModeSignInComplete = onModalModeSignInComplete;
        return _this;
    }
    /**
     * Function used by IMSLib to use only the neccesarry properties from AdobeIdData for social provider
     * @param providerName provider name used for sign in
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdData.prototype.createSocialProviderRedirectRequest = function(providerName, requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
        var params = {
            idp_flow: "social.deep_link.web",
            provider_id: providerName
        };
        var signInParams = $23b45ab7fb8eab0e$var$__assign($23b45ab7fb8eab0e$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(signInParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
     */ AdobeIdData.prototype.createReAuthenticateRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType) {
        if (reauth === void 0) reauth = $c7IJY.IReauth.check;
        if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
        var params = {
            reauth: reauth
        };
        var reauthParams = $23b45ab7fb8eab0e$var$__assign($23b45ab7fb8eab0e$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(reauthParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdData.prototype.createSignUpRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
        var signupParams = $23b45ab7fb8eab0e$var$__assign($23b45ab7fb8eab0e$var$__assign({}, requestedParameters), {
            idp_flow: "create_account"
        });
        return this.createRedirectRequest(signupParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    return AdobeIdData;
}($gdMgf.AdobeIdThinData);
module.exports.AdobeIdData = $23b45ab7fb8eab0e$var$AdobeIdData;

});
parcelRegister("lkoSZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to store the modal settings
 */ var $f86ec50f1e9fbc81$var$PopupSettings = /** @class */ function() {
    function PopupSettings(data) {
        if (data === void 0) data = {};
        this.title = "Adobe ID";
        this.width = 600;
        this.top = 100;
        this.left = 100;
        var _a = data.title, title = _a === void 0 ? "Adobe ID" : _a, _b = data.width, width = _b === void 0 ? 600 : _b, _c = data.height, height = _c === void 0 ? 700 : _c, _d = data.top, top = _d === void 0 ? 100 : _d, _e = data.left, left = _e === void 0 ? 100 : _e, allowedOrigin = data.allowedOrigin;
        this.title = title;
        this.width = width;
        this.height = height;
        this.top = top;
        this.left = left;
        this.allowOrigin = allowedOrigin;
    }
    return PopupSettings;
}();
module.exports.PopupSettings = $f86ec50f1e9fbc81$var$PopupSettings;

});

parcelRegister("3ux7u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to encapsulate the token and expiration ms;
 * this values are passed from outside of the library by using adobeid
 */ var $28addd54f1271914$var$StandaloneToken = /** @class */ function() {
    function StandaloneToken(data) {
        this.token = "";
        /**
         * representing the session identifier
         */ this.sid = "";
        this.expirems = 0;
        var token = data.token, expirems = data.expirems;
        this.token = token;
        this.expirems = expirems;
    }
    return StandaloneToken;
}();
module.exports.StandaloneToken = $28addd54f1271914$var$StandaloneToken;

});

parcelRegister("c7IJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Enumeration values used for reAuthenticate method
 *
 * Default value is check
 */ var $8d38d809145c0f37$var$IReauth;
(function(IReauth) {
    /**
     * Forces the reauth process to show the credentials screen to the user
     */ IReauth["force"] = "force";
    /**
     * Starts the reauthentication check flow. Which won't prompt the user for reauthentication if the user already performed an authentication in a period of time configured on the client id.
     */ IReauth["check"] = "check";
})($8d38d809145c0f37$var$IReauth = module.exports.IReauth || (module.exports.IReauth = {}));

});

parcelRegister("1V6oS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Enumeration values used for available grant types
 *
 * Default value is token
 */ var $166014434d1cf366$var$IGrantTypes;
(function(IGrantTypes) {
    /**
     * token
     */ IGrantTypes["token"] = "token";
    /**
     * authorization code
     */ IGrantTypes["code"] = "code";
})($166014434d1cf366$var$IGrantTypes = module.exports.IGrantTypes || (module.exports.IGrantTypes = {}));

});

parcelRegister("gdMgf", function(module, exports) {
"use strict";
var $bcf34bdff1c23e02$var$__assign = module.exports && module.exports.__assign || function() {
    $bcf34bdff1c23e02$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bcf34bdff1c23e02$var$__assign.apply(this, arguments);
};
var $bcf34bdff1c23e02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h0Bwb = parcelRequire("h0Bwb");

var $3O0eZ = parcelRequire("3O0eZ");

var $bcf34bdff1c23e02$var$Environment_1 = $bcf34bdff1c23e02$var$__importDefault((parcelRequire("1Sn1w")));

var $1Qecl = parcelRequire("1Qecl");

var $bcf34bdff1c23e02$var$Log_1 = $bcf34bdff1c23e02$var$__importDefault((parcelRequire("545sK")));

var $c7IJY = parcelRequire("c7IJY");

var $1V6oS = parcelRequire("1V6oS");

var $kTYb4 = parcelRequire("kTYb4");
/**
 *  Class used to store the adobe data values.
 *
 *  Ims library will use these values for all operations
 */ var $bcf34bdff1c23e02$var$AdobeIdThinData = /** @class */ function() {
    /**
     * @constructor Create the adobeIdData object with all necessary properties from adobeData input paramater
     *
     * It uses the input adobeData parameter or the object stored in window.adobeid
     */ function AdobeIdThinData(adobeData) {
        if (adobeData === void 0) adobeData = null;
        /**
         * represents the class used to store the analytics parameters
         */ this.analyticsParameters = new $1Qecl.AnalyticsParameters();
        /**
          @property Object containing various custom parameters for IMS.
          This object is used in case a custom API parameter is desired to be sent to the back-end.
      
          E.G. { logout: 'your_custom_value' }
      
          The list of api's which can be customized are: authorize, validate_token, profile, userinfo, logout, logout_token, check, providers, ijt
        */ this.api_parameters = {};
        /**
          @property {string} Localization value used by ims library.
      
          Default value is `en_US`
        */ this.locale = "";
        /**
         * @property {string} - The scopes used to acquire access tokens. A comma separated list of client scopes.
         * No whitespace.
         * Default scopes: AdobeID
         */ this.scope = "AdobeID";
        /**
         * @property {string} - The client id used by ims library
         */ this.client_id = "";
        /**
         * represents the used environment; default is prod and in case the value is stg1, the stage environment is used
         */ this.environment = $3O0eZ.IEnvironment.PROD;
        /**
         *  use the local storage for token management; default value is false;
         */ this.useLocalStorage = false;
        /** @function {adobeid.onReady} [onReady] - Function to be executed once imslib.js has been fully
         * initialized.
         */ this.onReady = null;
        this.onModalModeSignInComplete = null;
        this.proxiedCheckToken = false;
        var adobeid = adobeData ? adobeData : window[$h0Bwb.AdobeIdKey];
        if (!adobeid || !adobeid.client_id) throw new Error("Please provide required adobeId, client_id information");
        var api_parameters = adobeid.api_parameters, client_id = adobeid.client_id, locale = adobeid.locale, scope = adobeid.scope, ijt = adobeid.ijt, _a = adobeid.environment, environment = _a === void 0 ? $3O0eZ.IEnvironment.PROD : _a, redirect_uri = adobeid.redirect_uri, useLocalStorage = adobeid.useLocalStorage, logsEnabled = adobeid.logsEnabled, onReady = adobeid.onReady, rideRedirectUri = adobeid.rideRedirectUri, proxiedCheckToken = adobeid.proxiedCheckToken;
        this.environment = environment;
        this.api_parameters = api_parameters ? api_parameters : {};
        this.client_id = client_id;
        this.locale = locale || $h0Bwb.DEFAULT_LANGUAGE;
        this.scope = scope ? scope.replace(/\s/gi, "") : "";
        this.redirect_uri = redirect_uri;
        this.ijt = ijt;
        this.useLocalStorage = useLocalStorage;
        if (logsEnabled) $bcf34bdff1c23e02$var$Log_1.default.enableLogging();
        else $bcf34bdff1c23e02$var$Log_1.default.disableLogging();
        this.onReady = onReady ? onReady : null;
        this.rideRedirectUri = rideRedirectUri;
        this.proxiedCheckToken = proxiedCheckToken;
        this.fillAnalyticsParameters(adobeid);
        $bcf34bdff1c23e02$var$Environment_1.default.loadEnvironment(environment, proxiedCheckToken, window.location.hostname);
    }
    /**
     * fill the analytic parameters with the values provided by adobeid data
     * @param adobeid represents the adobeid data provided to library
     */ AdobeIdThinData.prototype.fillAnalyticsParameters = function(adobeid) {
        var _a = adobeid.analytics, _b = _a === void 0 ? {} : _a, _c = _b.appCode, appCode = _c === void 0 ? "" : _c, _d = _b.appVersion, appVersion = _d === void 0 ? "" : _d;
        var analyticsParameters = this.analyticsParameters;
        analyticsParameters.appCode = appCode;
        analyticsParameters.appVersion = appVersion;
    };
    /**
     * Function used by IMSLib to use only the neccesarry properties from AdobeIdData for social provider
     * @param providerName provider name used for sign in
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdThinData.prototype.createSocialProviderRedirectRequest = function(providerName, requestedParameters, contextToBePassedOnRedirect, nonce, grantType) {
        var params = {
            idp_flow: "social.deep_link.web",
            provider_id: providerName
        };
        var signInParams = $bcf34bdff1c23e02$var$__assign($bcf34bdff1c23e02$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(signInParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param reauth {string}; represents the re authenticate value. available values are: check and force. default value is "check"
     */ AdobeIdThinData.prototype.createReAuthenticateRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce, reauth, grantType) {
        if (reauth === void 0) reauth = $c7IJY.IReauth.check;
        if (grantType === void 0) grantType = $1V6oS.IGrantTypes.token;
        var params = {
            reauth: reauth
        };
        var reauthParams = $bcf34bdff1c23e02$var$__assign($bcf34bdff1c23e02$var$__assign({}, requestedParameters), params);
        return this.createRedirectRequest(reauthParams, contextToBePassedOnRedirect, nonce, grantType);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param requestedParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     */ AdobeIdThinData.prototype.createSignUpRedirectRequest = function(requestedParameters, contextToBePassedOnRedirect, nonce) {
        var signupParams = $bcf34bdff1c23e02$var$__assign($bcf34bdff1c23e02$var$__assign({}, requestedParameters), {
            idp_flow: "create_account"
        });
        return this.createRedirectRequest(signupParams, contextToBePassedOnRedirect, nonce, $1V6oS.IGrantTypes.token);
    };
    /**
     * Function used by ims to use only the neccesarry properties from AdobeIdData on sign in and reauth methods
     * @param externalParameters {Object} the external parameters used for signin and reauth methods
     * @param contextToBePassedOnRedirect {any | undefined} represents the context which is passed during redirect
     * @param nonce {string} - string representing the nonce value used for CSRF
     * @param grantType {IGrantTypes} represents the grant type used for sign in flow
     */ AdobeIdThinData.prototype.createRedirectRequest = function(externalParameters, contextToBePassedOnRedirect, nonce, grantType) {
        var _this = this;
        var _a = this, _b = _a.api_parameters, apiParameters = _b === void 0 ? {} : _b, clientId = _a.client_id, _c = _a.redirect_uri, adobeIdRedirectUri = _c === void 0 ? "" : _c, scope = _a.scope, locale = _a.locale;
        var state = this.createRedirectState(contextToBePassedOnRedirect, nonce);
        var redirectRequest = {
            adobeIdRedirectUri: adobeIdRedirectUri,
            apiParameters: apiParameters,
            clientId: clientId,
            externalParameters: externalParameters,
            scope: scope,
            locale: locale,
            response_type: grantType,
            state: state
        };
        if (grantType === $1V6oS.IGrantTypes.token) return Promise.resolve(redirectRequest);
        var codeChallenge = new $kTYb4.CodeChallenge();
        return codeChallenge.createCodeChallenge(nonce).then(function(challengeResponse) {
            externalParameters.code_challenge = challengeResponse.challenge;
            externalParameters.code_challenge_method = "S256";
            var codeState = _this.createRedirectState(contextToBePassedOnRedirect, nonce);
            redirectRequest.state = codeState;
            return Promise.resolve(redirectRequest);
        });
    };
    /**
     * create the stae object used during redirect; if the adobeid.context is empty and no analytics parameters, the state will ne null
     * @param context represents the external parameters
     */ AdobeIdThinData.prototype.createRedirectState = function(context, nonce) {
        var _a = this.analyticsParameters, _b = _a.appCode, appCode = _b === void 0 ? "" : _b, _c = _a.appVersion, appVersion = _c === void 0 ? "" : _c;
        var state = context === undefined ? {} : {
            context: context
        };
        if (appCode) state["ac"] = appCode;
        if (appVersion) state["av"] = appVersion;
        state["jslibver"] = $bcf34bdff1c23e02$var$Environment_1.default.jslibver;
        state["nonce"] = nonce;
        return Object.keys(state).length ? state : null;
    };
    AdobeIdThinData.prototype.triggerOnReady = function() {
        this.onReady && this.onReady(undefined);
    };
    AdobeIdThinData.prototype.computeRideRedirectUri = function(code) {
        if (!this.rideRedirectUri) return window.location.href;
        if (typeof this.rideRedirectUri === "string") return this.rideRedirectUri === "DEFAULT" ? null : this.rideRedirectUri;
        return this.rideRedirectUri(code);
    };
    return AdobeIdThinData;
}();
module.exports.AdobeIdThinData = $bcf34bdff1c23e02$var$AdobeIdThinData;

});
parcelRegister("1Qecl", function(module, exports) {
"use strict";
/**
 * class used to store the analytics parameters
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1575a933a0916fdb$var$AnalyticsParameters = /** @class */ function() {
    function AnalyticsParameters() {
        /**
        * represents the application code value;
        * this value (if exists) will be sent to the server.
        */ this.appCode = "";
        /**
         * represents the application version value;
         * this value (if exists) will be sent to the server.
         */ this.appVersion = "";
    }
    return AnalyticsParameters;
}();
module.exports.AnalyticsParameters = $1575a933a0916fdb$var$AnalyticsParameters;

});

parcelRegister("kTYb4", function(module, exports) {
"use strict";
var $f3779fb050c37f5e$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f3779fb050c37f5e$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f3779fb050c37f5e$var$__read(arguments[i]));
    return ar;
};
var $f3779fb050c37f5e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f3779fb050c37f5e$var$StorageFactory_1 = $f3779fb050c37f5e$var$__importDefault((parcelRequire("c6yNM")));
module.exports.ONE_HOUR = 12960000;
var $f3779fb050c37f5e$var$CodeChallenge = /** @class */ function() {
    function CodeChallenge() {
        this.storage = $f3779fb050c37f5e$var$StorageFactory_1.default.getAvailableStorage();
    }
    CodeChallenge.prototype.b64Uri = function(r) {
        return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    };
    /**
     *
     * @param nonce {String} represents the key used to store the code verifier
     * @param verifierLength {number} represents the verifier length
     * @returns {ICodeChallenge} verifier and challenge codes
     */ CodeChallenge.prototype.createCodeChallenge = function(nonce, verifierLength) {
        var _this = this;
        if (verifierLength === void 0) verifierLength = 43;
        var cryptoObj = window["msCrypto"] || window.crypto;
        var verifier = this.b64Uri(Array.prototype.map.call(cryptoObj.getRandomValues(new Uint8Array(verifierLength)), function(r) {
            return String.fromCharCode(r);
        }).join("")).substring(0, verifierLength);
        var uintVerifierArr = new Uint8Array(verifier.length);
        for(var i = 0; i < verifier.length; i++)uintVerifierArr[i] = verifier.charCodeAt(i);
        var cryptoDigest = cryptoObj.subtle.digest("SHA-256", uintVerifierArr);
        return new Promise(function(resolve, reject) {
            if (window["CryptoOperation"]) {
                cryptoDigest.onerror = function(err) {
                    return reject(err);
                };
                cryptoDigest.oncomplete = function(response) {
                    var uintArr = new Uint8Array(response.target.result);
                    var challenge = _this.b64Uri(String.fromCharCode.apply(String, $f3779fb050c37f5e$var$__spread(uintArr)));
                    return resolve(_this.saveVerifierAndReturn(nonce, {
                        verifier: verifier,
                        challenge: challenge
                    }));
                };
            } else cryptoDigest.then(function(response) {
                var uintArr = new Uint8Array(response);
                var challenge = _this.b64Uri(String.fromCharCode.apply(String, $f3779fb050c37f5e$var$__spread(uintArr)));
                return resolve(_this.saveVerifierAndReturn(nonce, {
                    verifier: verifier,
                    challenge: challenge
                }));
            });
        });
    };
    /**
     *
     * @param nonce {String} represents the key used to store the code verifier
     * @param challengeAndVerifier {ICodeChallenge} represents the code challenge and code verifier
     * @returns ICodeChallenge
     */ CodeChallenge.prototype.saveVerifierAndReturn = function(nonce, challengeAndVerifier) {
        var verifiers = this.getVerifierValuesFromStorage();
        var storageValue = {
            verifier: challengeAndVerifier.verifier || "",
            expiry: new Date().getTime().toString()
        };
        verifiers[nonce] = storageValue;
        this.storage.setItem("verifiers", JSON.stringify(verifiers));
        return Promise.resolve(challengeAndVerifier);
    };
    /**
   * Returns the nonce values from storage as an Object or null
   * @returns {IDictionary | null}
   */ CodeChallenge.prototype.getVerifierValuesFromStorage = function() {
        var storageVerifiers = this.storage.getItem("verifiers");
        var verifiers = storageVerifiers ? JSON.parse(storageVerifiers) : {};
        return this.clearOlderVerifiers(verifiers);
    };
    CodeChallenge.prototype.clearOlderVerifiers = function(verifiers, olderThan) {
        if (olderThan === void 0) olderThan = module.exports.ONE_HOUR;
        var oneHourAgo = Date.now() - olderThan;
        var expiry = 0;
        Object.keys(verifiers).forEach(function(key) {
            expiry = parseInt(verifiers[key]);
            if (expiry < oneHourAgo) delete verifiers[key];
        });
        return verifiers;
    };
    /**
     * rerturns the verifier from storage
     * @param key {String} represents the key used to stora the verfier
     */ CodeChallenge.prototype.getVerifierByKey = function(key) {
        var verifiers = this.getVerifierValuesFromStorage();
        var verifierObj = verifiers ? verifiers[key] : {};
        delete verifiers[key];
        this.storage.setItem("verifiers", JSON.stringify(verifiers));
        return verifierObj ? verifierObj["verifier"] : "";
    };
    return CodeChallenge;
}();
module.exports.CodeChallenge = $f3779fb050c37f5e$var$CodeChallenge;

});



parcelRegister("hk0ws", function(module, exports) {
"use strict";
var $c9c4b5aab55b13de$var$__assign = module.exports && module.exports.__assign || function() {
    $c9c4b5aab55b13de$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9c4b5aab55b13de$var$__assign.apply(this, arguments);
};
var $c9c4b5aab55b13de$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h0Bwb = parcelRequire("h0Bwb");

var $c9c4b5aab55b13de$var$UrlHelper_1 = $c9c4b5aab55b13de$var$__importDefault((parcelRequire("fiyt1")));

var $c9c4b5aab55b13de$var$ApiHelpers_1 = $c9c4b5aab55b13de$var$__importDefault((parcelRequire("9zwbo")));

var $c9c4b5aab55b13de$var$Environment_1 = $c9c4b5aab55b13de$var$__importDefault((parcelRequire("1Sn1w")));

var $c9c4b5aab55b13de$var$ImsXhr_1 = $c9c4b5aab55b13de$var$__importDefault((parcelRequire("3AvvU")));
/**
 * class used as a entry point for Ims api's
 * @todo discuss rate limit --> code 429 on http response.
 */ var $c9c4b5aab55b13de$var$ImsApis = /** @class */ function() {
    /**
     * imsApis constructor;
     */ function ImsApis(apiParameters) {
        if (apiParameters === void 0) apiParameters = {};
        this.CONTENT_FORM_ENCODED = "application/x-www-form-urlencoded;charset=utf-8";
        this.apiParameters = apiParameters;
    }
    /**
     * validate the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.validateToken = function(request) {
        var token = request.token, client_id = request.client_id;
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "validate_token")), {
            type: "access_token",
            client_id: client_id,
            token: token
        }));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlAdobe + "/ims/validate_token/v1?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var config = this.formEncoded();
        this.addClientIdInHeader(client_id, config);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
     * retrieve the profile based on the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getProfile = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "profile"));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlAdobe + "/ims/profile/v1?" + queryStrings + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(url, config);
    };
    /**
     * @returns the user info based on the input token
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getUserInfo = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "userinfo"));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlAdobe + "/ims/userinfo/v1?" + queryStrings + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(url, config);
    };
    /**
      * invalidate the input token
      * @param request IAuthorizedApiRequest contains clientId and token information
      */ ImsApis.prototype.logoutToken = function(apiRequest) {
        var client_id = apiRequest.client_id, access_token = apiRequest.token;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "logout_token"));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/logout/v1?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var config = this.addClientIdInHeader(client_id);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post(url, $c9c4b5aab55b13de$var$__assign({
            client_id: client_id,
            access_token: access_token
        }, additionalParams), config);
    };
    /**
     * Does an API to check the cookie status of the browser.
     */ ImsApis.prototype.checkStatus = function() {
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/check/v1/status";
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(url);
    };
    /**
     * @returns a new token
     * @param request IUnAuthorizedApiRequest contains clientId information
     * @param userId { string } represents the user id associated with logged user
     * @todo We will probably need also check token v5
     */ ImsApis.prototype.checkToken = function(apiRequest, externalParameters, userId) {
        var client_id = apiRequest.client_id, scope = apiRequest.scope;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "check_token"));
        var apiBody = $c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), {
            client_id: client_id,
            scope: scope
        });
        if (userId) apiBody.user_id = userId;
        return this.callCheckToken($c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData(apiBody), client_id, "/check/v6/token?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver);
    };
    /**
     * @returns a new token and profile for the existing user
     * @param request IUnAuthorizedApiRequest contains clientId information
     * @param userId contains the user id of the logged user
     * https://wiki.corp.adobe.com/display/ims/IMS+API+-+check+token#IMSAPIchecktoken-Version6
     */ ImsApis.prototype.switchProfile = function(apiRequest, externalParameters, userId) {
        if (userId === void 0) userId = "";
        var client_id = apiRequest.client_id, _a = apiRequest.scope, scope = _a === void 0 ? "" : _a;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "check_token"));
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), {
            client_id: client_id,
            scope: scope,
            user_id: userId
        }));
        return this.callCheckToken(data, client_id, "/check/v6/token?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver);
    };
    /**
     * @returns list of api providers
     * @param request IUnAuthorizedApiRequest contains clientId information
     */ ImsApis.prototype.listSocialProviders = function(apiRequest) {
        var client_id = apiRequest.client_id;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "providers"));
        var queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/social/v1/providers?" + queryStrings + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var config = this.addClientIdInHeader(client_id);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(url, config);
    };
    /**
    * @see {@link https://wiki.corp.adobe.com/display/ims/Implicit+Jump+Tokens |Implicit Jump Tokens}
    * @param request IUnAuthorizedApiRequest contains clientId and token information
    * @param ijt {string}
    */ ImsApis.prototype.exchangeIjt = function(apiRequest, ijt) {
        var client_id = apiRequest.client_id;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "ijt"));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/jump/implicit/" + ijt;
        var queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign({
            client_id: client_id
        }, additionalParams));
        var apiUrl = url + "?" + queryStrings + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        if (apiUrl.length > 2048) {
            delete additionalParams["redirect_uri"];
            queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData(additionalParams);
            apiUrl = url + "?" + queryStrings;
        }
        var config = this.addClientIdInHeader(client_id);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(apiUrl, config);
    };
    /**
     * Returns the URL to the avatar of a user
     * @param {UserId} userId
     * @returns {String}
     */ ImsApis.prototype.avatarUrl = function(userId) {
        return $c9c4b5aab55b13de$var$Environment_1.default.baseUrlAdobe + "/ims/avatar/download/" + userId;
    };
    /**
     * Makes a request to IMS to get the Floodgate release flags.
     * Optionally accepts an access token from which to decode the release flags.
     * @param request IAuthorizedApiRequest contains clientId and token information
     */ ImsApis.prototype.getReleaseFlags = function(request) {
        var token = request.token, client_id = request.client_id;
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.getCustomApiParameters(this.apiParameters, "fg_value"));
        var config = this.createAuthorizationHeader(token);
        this.addClientIdInHeader(client_id, config);
        var queryStrings = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign({
            client_id: client_id
        }, additionalParams));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlAdobe + "/ims/fg/value/v1?" + queryStrings + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.get(url, config);
    };
    /**
     * Exchange the user's access_token for a Transitory Access Code (TAC) for target client and scope
     * @param tacRequest {ITransitoryAuthorizationRequest} - contains the request parameters
     * @param externalParameters {object} - contains the possible parameters used to override the api parameters
     * @param clientId {string} - the adobeid.client_id value
     */ ImsApis.prototype.getTransitoryAuthorizationCode = function(tacRequest, externalParameters, clientId) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "check_token"));
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), tacRequest));
        return this.callCheckToken(data, clientId, "/check/v6/token?client_id=" + clientId + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver);
    };
    /**
     * returns an access token from a authorization or device code
     * @param authorizationRequest {AuthorizationCode} contains the authorization request parameters
     * @param externalParameters {object} - contains the possible parameters used to override the api parameters
     */ ImsApis.prototype.getTokenFromCode = function(authorizationRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "token"));
        additionalParams.grant_type = "authorization_code";
        delete authorizationRequest.other;
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/token/v3?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), authorizationRequest));
        var config = this.formEncoded();
        this.addClientIdInHeader(authorizationRequest.client_id, config);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
     * Allows a client to launch a system-browser and arrive at another IMS-integrated application
     * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ims&title=IMS+API+-+jumptoken }
     * @param jumpTokenRequest {JumpTokenRequest}
     * @param externalParameters {IDictionary}
     * @returns JumpTokenResponse
     */ ImsApis.prototype.jumpToken = function(jumpTokenRequest, externalParameters, clientId) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "jumptoken"));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/jumptoken/v1?client_id=" + clientId + "&jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), jumpTokenRequest));
        var config = this.formEncoded();
        this.addClientIdInHeader(clientId, config);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post(url, data, config);
    };
    /**
       * Provides signin / signup utility via the social native headless API
       * @see {@link https://wiki.corp.adobe.com/pages/viewpage.action?pageId=1106020498 }
       * @param id_token from provider
       * @param provider_id either google, facebook or apple
       */ ImsApis.prototype.socialHeadlessSignIn = function(socialHeadlessSignInRequest, externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        var additionalParams = $c9c4b5aab55b13de$var$__assign({}, $c9c4b5aab55b13de$var$ApiHelpers_1.default.mergeExternalParameters(externalParameters, this.apiParameters, "jumptoken"));
        var url = $c9c4b5aab55b13de$var$Environment_1.default.baseUrlServices + "/ims/social/v2/native?jslVersion=" + $c9c4b5aab55b13de$var$Environment_1.default.jslibver;
        var data = $c9c4b5aab55b13de$var$UrlHelper_1.default.uriEncodeData($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign($c9c4b5aab55b13de$var$__assign({}, additionalParams), socialHeadlessSignInRequest), {
            response_type: "implicit_jump"
        }));
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post(url, data, this.formEncoded());
    };
    /**
     * create the authorization header in case the accesToken exists
     * @param accessToken {string};
     * @returns {string}
     */ ImsApis.prototype.createAuthorizationHeader = function(accessToken) {
        var headers = {};
        if (accessToken) headers[$h0Bwb.HEADERS.AUTHORIZATION] = "Bearer " + accessToken;
        return headers;
    };
    /**
     *
     * @param headers the header which will be sent to ims server on API request
     */ ImsApis.prototype.formEncoded = function(headers) {
        if (headers === void 0) headers = {};
        headers["content-type"] = this.CONTENT_FORM_ENCODED;
        return headers;
    };
    /**
     * add clientId in header
     * @param clientId {string};
     * @param headers {IDictionary};
     */ ImsApis.prototype.addClientIdInHeader = function(clientId, headers) {
        if (headers === void 0) headers = {};
        headers["client_id"] = clientId;
        return headers;
    };
    ImsApis.prototype.callCheckToken = function(data, clientId, pathSuffix) {
        var config = this.formEncoded();
        this.addClientIdInHeader(clientId, config);
        return $c9c4b5aab55b13de$var$ImsXhr_1.default.post($c9c4b5aab55b13de$var$Environment_1.default.checkTokenEndpoint.url + "/ims" + pathSuffix, data, config).catch(function(e) {
            if (!$c9c4b5aab55b13de$var$Environment_1.default.checkTokenEndpoint.shouldFallbackToAdobe(e)) throw e;
            return $c9c4b5aab55b13de$var$ImsXhr_1.default.post($c9c4b5aab55b13de$var$Environment_1.default.checkTokenEndpoint.fallbackUrl + "/ims" + pathSuffix, data, config);
        });
    };
    return ImsApis;
}();
module.exports.ImsApis = $c9c4b5aab55b13de$var$ImsApis;

});
parcelRegister("3AvvU", function(module, exports) {
"use strict";
var $29cd2dd95f9081e5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29cd2dd95f9081e5$var$Debouncer_1 = $29cd2dd95f9081e5$var$__importDefault((parcelRequire("h8gYf")));

var $29cd2dd95f9081e5$var$HttpErrorHandler_1 = $29cd2dd95f9081e5$var$__importDefault((parcelRequire("d2nm3")));

var $29cd2dd95f9081e5$var$Xhr_1 = $29cd2dd95f9081e5$var$__importDefault((parcelRequire("haW18")));
module.exports.default = new /** @class */ (function() {
    function ImsXhr() {
        this.triggerOnError = null;
    }
    /**
     * check if the cache contains data for the same url and parameters value;
     * if true, returns the cached value otherwise make the http call
     * @param url - url used to make a POST http request
     * @param data - dat passed to the back-end
     * @param config - http configuration
    */ ImsXhr.prototype.post = function(url, data, config) {
        var _this = this;
        if (config === void 0) config = {};
        var cachedData = $29cd2dd95f9081e5$var$Debouncer_1.default.getCachedApiResponse(url, data);
        if (cachedData) {
            var status_1 = cachedData.status, data_1 = cachedData.data;
            return status_1 === 200 ? Promise.resolve(data_1) : Promise.reject(data_1);
        }
        return $29cd2dd95f9081e5$var$Xhr_1.default.post(url, data, config).then(function(response) {
            return _this.storeApiResponse(url, JSON.stringify(data), response);
        }).catch(function(ex) {
            return _this.verifyError(url, JSON.stringify(data), ex);
        });
    };
    /**
     * check if the cache contains data for the input url
     * if true, returns the cached value otherwise make the http call
     * @param url - url used to make a POST http request
     * @param config - contains xmlhttprequest headers
    */ ImsXhr.prototype.get = function(url, config) {
        var _this = this;
        if (config === void 0) config = {};
        var cachedData = $29cd2dd95f9081e5$var$Debouncer_1.default.getCachedApiResponse(url);
        if (cachedData) {
            var status_2 = cachedData.status, data = cachedData.data;
            return status_2 === 200 ? Promise.resolve(data) : Promise.reject(data);
        }
        return $29cd2dd95f9081e5$var$Xhr_1.default.get(url, config).then(function(response) {
            return _this.storeApiResponse(url, "", response);
        }).catch(function(ex) {
            return _this.verifyError(url, "", ex);
        });
    };
    /**
     *
     * @param exception {ApiResponse} - represents the back-end service
     * @param url: {string} - url used to call the api
     * @param bodyParams: {string} represents the body parameters
     */ ImsXhr.prototype.verifyError = function(url, bodyParams, exception) {
        this.storeApiResponse(url, bodyParams, exception);
        var httpErrorResponse = $29cd2dd95f9081e5$var$HttpErrorHandler_1.default.verify(exception, url);
        return Promise.reject(httpErrorResponse || exception.data);
    };
    /**
    *
    * @param response {any} - represents the back-end service
    * @param url url: {string} - url used to call the api
    * @param bodyParams {string} represents the body parameters
    */ ImsXhr.prototype.storeApiResponse = function(url, bodyParams, response) {
        if (bodyParams === void 0) bodyParams = "";
        $29cd2dd95f9081e5$var$Debouncer_1.default.storeApiResponse(url, bodyParams, response);
        return Promise.resolve(response.data);
    };
    return ImsXhr;
}());

});
parcelRegister("h8gYf", function(module, exports) {
"use strict";
/**
 * class used for caching the api calls for a second.
 * The flow is:
 * 1. make api call from ImsLib
 * 2. if the Debouncer cache already contains a response for that api/parameters -> return the cashed response
 *
 */ var $c790590fbd2ff2f4$var$__assign = module.exports && module.exports.__assign || function() {
    $c790590fbd2ff2f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c790590fbd2ff2f4$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c790590fbd2ff2f4$var$Debouncer = /** @class */ function() {
    function Debouncer() {
        var _this = this;
        /**
         * debounce time value; one second
         */ this.DEBOUNCE_TIME = 1000;
        /**
         * dictionary with all executed methods for the last second
         */ this.cache = {};
        /**
         *
         * @param url {String} - url used to make the api
         * @param bodyParams {String} - the hash associated with the request parameters
         * @param response {ApiResponse} - data received as a http response
         */ this.storeApiResponse = function(url, bodyParams, response) {
            if (url === void 0) url = "";
            if (bodyParams === void 0) bodyParams = "";
            _this.cacheApiResponse(url, bodyParams, response);
        };
    }
    /**
     * starts to execute a specific API. if there is a cached response, it will be returned
     * @param url - api url
     * @param parameters - represents the parameters used to call the api
     */ Debouncer.prototype.getCachedApiResponse = function(url, parameters) {
        if (parameters === void 0) parameters = "";
        var hash = typeof parameters === "string" ? parameters : JSON.stringify(parameters);
        var cachedUrlValues = this.cache[url];
        if (!cachedUrlValues) return null;
        var cachedHash = cachedUrlValues[hash];
        if (!cachedHash) return null;
        return cachedHash.data;
    };
    /**
     *
     * @param url {String} - url used to make the api
     * @param bodyParams {String} - the hash associated with the request parameters
     * @param response {ApiResponse} - data received as a http response
     */ Debouncer.prototype.cacheApiResponse = function(url, bodyParams, response) {
        if (url === void 0) url = "";
        if (bodyParams === void 0) bodyParams = "";
        var cachedUrlValues = this.cache[url];
        if (!cachedUrlValues) {
            cachedUrlValues = {};
            this.cache[url] = cachedUrlValues;
        }
        var timerId = this.createClearCachedDataTimer(url, bodyParams);
        cachedUrlValues[bodyParams] = {
            timerId: timerId,
            data: $c790590fbd2ff2f4$var$__assign({}, response)
        };
    };
    /**
     * create the timer for a url/hash
     * @param url - {string} - represents the url used to make the http call
     * @param hash {String} - the hash associated with the request parameters
     */ Debouncer.prototype.createClearCachedDataTimer = function(url, hash) {
        var _this = this;
        var timerId = setTimeout(function() {
            var cachedUrlValues = _this.cache[url] || {};
            var methodValues = cachedUrlValues[hash];
            if (!methodValues) return;
            if (methodValues && methodValues.timerId) {
                clearTimeout(methodValues.timerId);
                delete cachedUrlValues[hash];
            }
        }, this.DEBOUNCE_TIME);
        return timerId;
    };
    return Debouncer;
}();
module.exports.default = new $c790590fbd2ff2f4$var$Debouncer();

});

parcelRegister("d2nm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gdMgf = parcelRequire("gdMgf");

var $fwlYT = parcelRequire("fwlYT");

var $aCG43 = parcelRequire("aCG43");
/**
 * class used to create a IHttpErrorResponse object in case the code is != 200
 */ var $97dd94003e658702$var$HttpErrorHandler = /** @class */ function() {
    function HttpErrorHandler() {
        this.adobeIdThinData = null;
    }
    HttpErrorHandler.prototype.verify = function(exception, url) {
        if (url === void 0) url = "";
        var status = exception.status, data = exception.data;
        if (!status) return new $aCG43.HttpErrorResponse({
            error: "networkError",
            message: data || ""
        });
        if (status == 401) return new $aCG43.HttpErrorResponse({
            error: "unauthorized"
        });
        var rideException = this.parseTokenResponseForRideErrors(data, url);
        if (rideException) return rideException;
        if (status == 409) return data;
        if (status == 429) return new $aCG43.HttpErrorResponse({
            error: "rate_limited",
            retryAfter: data.retryAfter ? parseInt(data.retryAfter) : 10
        });
        if (status.toString().match(/5\d{2}/g)) return new $aCG43.HttpErrorResponse({
            error: "server_error"
        });
        return null;
    };
    /**
        * parse the check token response to see if there are any ride errors
        * @param refreshException represents the response from check token call
        * @param url the called url; part of the PBA Expired Idle Session workaround
        * @returns a RideException or null in case that the error code is not one from RideExceptions
        */ HttpErrorHandler.prototype.parseTokenResponseForRideErrors = function(refreshException, url) {
        if (!refreshException) return null;
        var error = refreshException.error, jump = refreshException.jump;
        if (!error) return null;
        var isRideError = error.indexOf("ride_") === 0;
        if (!isRideError) {
            // the PBA Expired Idle Session workaround: If a check/token call fails
            // because the session has been idle longer that the org policy limit,
            // a `token_expired` error is returned. But it should've been a ride exception
            // so the user is redirected to SUSI. Until the fix is made in the backend
            // this workaround has been implemented
            if (error === "token_expired" && url.indexOf("check/v6/token") >= 0) return new $fwlYT.RideException("ride_pba_idle_session", "", true);
            return null;
        }
        var jumpValue = this.addRedirectUriToJump(error, jump);
        return new $fwlYT.RideException(error, jumpValue);
    };
    HttpErrorHandler.prototype.addRedirectUriToJump = function(error, jump) {
        if (!jump || typeof jump !== "string") return "";
        var jumpValue = jump;
        if (!this.adobeIdThinData) this.adobeIdThinData = new $gdMgf.AdobeIdThinData();
        var redirectUri = this.adobeIdThinData.computeRideRedirectUri(error);
        if (!redirectUri || redirectUri.length === 0) return jumpValue;
        try {
            var jumpUrl = new URL(jumpValue);
            jumpUrl.searchParams.append("redirect_uri", redirectUri);
            return jumpUrl.toString();
        } catch (e) {
            return jumpValue;
        }
    };
    /**
     * check if the exception status has the code equal 401
     * @param exception represents the exception caught during get profile method
     * @returns true if the status code is 401, otherwise false
     */ HttpErrorHandler.prototype.isUnauthorizedException = function(exception) {
        var _a = exception.status, status = _a === void 0 ? 0 : _a;
        return status === 401;
    };
    return HttpErrorHandler;
}();
module.exports.default = new $97dd94003e658702$var$HttpErrorHandler();

});
parcelRegister("fwlYT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to store the ride errors after a check token call
 */ var $b4cae52d67de09e3$var$RideException = /** @class */ function() {
    function RideException(code, jump, isPbaExpiredIdleSessionWorkaround) {
        if (isPbaExpiredIdleSessionWorkaround === void 0) isPbaExpiredIdleSessionWorkaround = false;
        /**
         * new redirect url in case of a ride error
         */ this.jump = "";
        this.code = code;
        this.jump = jump;
        this.isPbaExpiredIdleSessionWorkaround = isPbaExpiredIdleSessionWorkaround;
    }
    return RideException;
}();
module.exports.RideException = $b4cae52d67de09e3$var$RideException;

});

parcelRegister("aCG43", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to pass the http errors to external applications
 */ var $7bbe1514895401ce$var$HttpErrorResponse = /** @class */ function() {
    function HttpErrorResponse(data) {
        var error = data.error, _a = data.retryAfter, retryAfter = _a === void 0 ? 0 : _a, _b = data.message, message = _b === void 0 ? "" : _b;
        this.error = error;
        this.retryAfter = retryAfter;
        this.message = message;
    }
    return HttpErrorResponse;
}();
module.exports.HttpErrorResponse = $7bbe1514895401ce$var$HttpErrorResponse;

});


parcelRegister("haW18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kyr12 = parcelRequire("kyr12");
module.exports.default = new /** @class */ (function() {
    function Xhr() {}
    Xhr.prototype.http = function(options) {
        return new Promise(function(resolve, reject) {
            var xmlHttpObject = window.XMLHttpRequest;
            var xhr = new xmlHttpObject();
            xhr.withCredentials = true;
            xhr.open(options.method, options.url, true);
            var addHeaders = function(headers) {
                if (!headers) return;
                Object.keys(headers).forEach(function(key) {
                    xhr.setRequestHeader(key, headers[key]);
                });
            };
            xhr.onload = function onload() {
                if (this.status >= 200 && this.status < 300) return resolve(new $kyr12.ApiResponse(this.status, this.response));
                return reject(new $kyr12.ApiResponse(this.status, this.response));
            };
            xhr.onerror = function onerror() {
                var error = new $kyr12.ApiResponse(this.status, this.response);
                return reject(error);
            };
            addHeaders(options.headers);
            xhr.send(options.data);
        });
    };
    Xhr.prototype.post = function(url, data, headers) {
        if (headers === void 0) headers = {};
        return this.http({
            headers: headers,
            method: "POST",
            url: url,
            data: data
        });
    };
    Xhr.prototype.get = function(url, headers) {
        if (headers === void 0) headers = {};
        return this.http({
            headers: headers,
            method: "GET",
            url: url
        });
    };
    return Xhr;
}());

});
parcelRegister("kyr12", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to store the xhr error response
 */ var $ef6bf06329cc2ebb$var$ApiResponse = /** @class */ function() {
    function ApiResponse(status, message) {
        this.status = 0;
        this.data = "";
        this.status = status;
        this.data = this.toJson(message);
    }
    ApiResponse.prototype.toJson = function(value) {
        try {
            if (typeof value !== "string") return value;
            return JSON.parse(value);
        } catch (_a) {
            return value;
        }
    };
    return ApiResponse;
}();
module.exports.ApiResponse = $ef6bf06329cc2ebb$var$ApiResponse;

});




parcelRegister("cGX1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6l4f6 = parcelRequire("6l4f6");
/**
 * class used to trigger profile errors
 */ var $93d730b8d795f6c5$var$ProfileException = /** @class */ function() {
    function ProfileException(message) {
        this.message = null;
        this.errorType = $6l4f6.IErrorType.PROFILE_EXCEPTION;
        this.message = message;
    }
    return ProfileException;
}();
module.exports.ProfileException = $93d730b8d795f6c5$var$ProfileException;

});
parcelRegister("6l4f6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Enumeration values used for ims error types
 */ /**
 * Enumeration values used for ims error types
 */ var $49d7febbc1e44b0e$var$IErrorType;
(function(IErrorType) {
    /**
     * error triggered in case of exception on adobe ims initialize
     */ IErrorType["INITIALIZE_ERROR"] = "initialize_error";
    /**
     * http exception type
     */ IErrorType["HTTP"] = "http";
    /**
     * fragment exception type
     */ IErrorType["FRAGMENT"] = "fragment";
    /**
     * csrf exception type
     */ IErrorType["CSRF"] = "csrf";
    /**
     * error triggered when get token method is called using a different api than the ones allowed
     */ IErrorType["NOT_ALLOWED"] = "not_allowed";
    /**
     * exception triggered when the profile api throws exception
     */ IErrorType["PROFILE_EXCEPTION"] = "profile_exception";
    /**
     * token expired error
     */ IErrorType["TOKEN_EXPIRED"] = "token_expired";
    /**
      * social providers error type
      */ IErrorType["SOCIAL_PROVIDERS"] = "SOCIAL_PROVIDERS";
    /**
    * ride exception sent to the client in case ther is no jump
    */ IErrorType["RIDE_EXCEPTION"] = "ride_exception";
})($49d7febbc1e44b0e$var$IErrorType = module.exports.IErrorType || (module.exports.IErrorType = {}));

});


parcelRegister("gwRwe", function(module, exports) {
"use strict";
var $c0892637d05a19a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c0892637d05a19a7$var$StorageFactory_1 = $c0892637d05a19a7$var$__importDefault((parcelRequire("c6yNM")));

var $h0Bwb = parcelRequire("h0Bwb");

var $cGX1o = parcelRequire("cGX1o");

var $aCG43 = parcelRequire("aCG43");

var $4AD9k = parcelRequire("4AD9k");
/**
 * class used to implement the profile methods
 */ var $c0892637d05a19a7$var$ProfileService = /** @class */ function() {
    function ProfileService(profileServiceRequest) {
        this.profileServiceRequest = profileServiceRequest;
        this.storage = $c0892637d05a19a7$var$StorageFactory_1.default.getStorageByName($h0Bwb.STORAGE_MODE.SessionStorage);
    }
    /**
     *
     * @param token {string} - the string used to obtain the profile information
     */ ProfileService.prototype.getProfile = function(token) {
        var _this = this;
        var _a = this.profileServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis;
        var sessionProfile = this.getProfileFromStorage();
        if (sessionProfile) return Promise.resolve(sessionProfile);
        return imsApis.getProfile({
            client_id: clientId,
            token: token
        }).then(function(profile) {
            // const { data: profile } = response;
            if (!profile) throw new $cGX1o.ProfileException("NO profile response");
            if (Object.keys(profile).length === 0) throw new $cGX1o.ProfileException("NO profile value");
            _this.saveProfileToStorage(profile);
            return Promise.resolve(profile);
        }).catch(function(ex) {
            if (ex instanceof $aCG43.HttpErrorResponse) return Promise.reject(ex);
            _this.removeProfile();
            return Promise.reject(ex);
        });
    };
    /**
    * private method used to compose the key used for storage
    * @param clientId
    * @param scope
    * @param isReAuth default false
    */ ProfileService.prototype.getProfileStorageKey = function() {
        var _a = this.profileServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var isReAuth = false;
        return $h0Bwb.PROFILE_STORAGE_KEY + "/" + clientId + "/" + isReAuth + "/" + $4AD9k.sortScopes(scope);
    };
    /**
     * read the profile from session storage
     */ ProfileService.prototype.getProfileFromStorage = function() {
        var profileStorageKey = this.getProfileStorageKey();
        var sessionProfile = this.storage.getItem(profileStorageKey);
        return sessionProfile && JSON.parse(sessionProfile);
    };
    /**
     *
     * @param profile {Object} object containing the profile information
     * save the profile to session storage
     */ ProfileService.prototype.saveProfileToStorage = function(profile) {
        var profileStorageKey = this.getProfileStorageKey();
        this.storage.setItem(profileStorageKey, JSON.stringify(profile));
    };
    /**
     * remove the profile value from the SessionStorage
     */ ProfileService.prototype.removeProfile = function() {
        var profileStorageKey = this.getProfileStorageKey();
        this.storage.removeItem(profileStorageKey);
    };
    /**
     *
     * @param userId {string} represents the user id of the new logged user
     * @returns { boolean } - true if the profile was removed, otherwise false
     */ ProfileService.prototype.removeProfileIfOtherUser = function(userId) {
        if (!userId) return;
        var profile = this.getProfileFromStorage();
        if (!profile || profile.userId === userId) return;
        this.removeProfile();
    };
    return ProfileService;
}();
module.exports.ProfileService = $c0892637d05a19a7$var$ProfileService;

});
parcelRegister("4AD9k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3578e47c2af3bb7f$var$SCOPE_SEPARATOR = ",";
function $3578e47c2af3bb7f$var$sortScopes(scopes) {
    return scopes.split($3578e47c2af3bb7f$var$SCOPE_SEPARATOR).sort().join($3578e47c2af3bb7f$var$SCOPE_SEPARATOR);
}
module.exports.sortScopes = $3578e47c2af3bb7f$var$sortScopes;
function $3578e47c2af3bb7f$var$validateScopeInclusion(requestedScope, tokenScope) {
    var tokenScopes = (tokenScope === null || tokenScope === void 0 ? void 0 : tokenScope.split($3578e47c2af3bb7f$var$SCOPE_SEPARATOR)) || [];
    var requestedScopes = (requestedScope === null || requestedScope === void 0 ? void 0 : requestedScope.split($3578e47c2af3bb7f$var$SCOPE_SEPARATOR)) || [];
    return requestedScopes.every(function(scope) {
        return tokenScopes.includes(scope);
    });
}
module.exports.validateScopeInclusion = $3578e47c2af3bb7f$var$validateScopeInclusion;

});


parcelRegister("csDaY", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/camelcase */ var $91267d1b80f172fc$var$__assign = module.exports && module.exports.__assign || function() {
    $91267d1b80f172fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $91267d1b80f172fc$var$__assign.apply(this, arguments);
};
var $91267d1b80f172fc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $91267d1b80f172fc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $91267d1b80f172fc$var$StorageFactory_1 = $91267d1b80f172fc$var$__importDefault((parcelRequire("c6yNM")));

var $h0Bwb = parcelRequire("h0Bwb");

var $hzAhd = parcelRequire("hzAhd");

var $91267d1b80f172fc$var$FragmentHelper_1 = $91267d1b80f172fc$var$__importDefault((parcelRequire("hsEsQ")));

var $6ToQ8 = parcelRequire("6ToQ8");

var $1QykO = parcelRequire("1QykO");

var $9DNFT = parcelRequire("9DNFT");

var $fwlYT = parcelRequire("fwlYT");

var $iWL10 = parcelRequire("iWL10");

var $91267d1b80f172fc$var$Log_1 = $91267d1b80f172fc$var$__importDefault((parcelRequire("545sK")));

var $aCG43 = parcelRequire("aCG43");

var $aRUy1 = parcelRequire("aRUy1");

var $8vy8k = parcelRequire("8vy8k");

var $kTYb4 = parcelRequire("kTYb4");

var $4AD9k = parcelRequire("4AD9k");

var $kZbFU = parcelRequire("kZbFU");
var $91267d1b80f172fc$var$ALLOWED_FRAGMENT_APIS = [
    "authorize",
    "check_token"
];
var $91267d1b80f172fc$var$ONE_SECOND_MILLIS = 1000;
/**
 * class used to store the specific token methods
 */ var $91267d1b80f172fc$var$TokenService = /** @class */ function() {
    function TokenService(tokenServiceRequest, csrfService) {
        var _this = this;
        /**
         * tries to get a valid token; if there is no token, the refresh method is called
         * @param externalParameters represents the external parameters used for refresh token
         * @returns TokenProfileResponse
         */ this.getTokenAndProfile = function(externalParameters) {
            if (externalParameters === void 0) externalParameters = {};
            var tokenResponse = _this.getTokenFields();
            if (tokenResponse instanceof $8vy8k.ModalSignInEvent) return Promise.reject(tokenResponse);
            if (tokenResponse instanceof $6ToQ8.FragmentException) return Promise.reject(tokenResponse);
            if (tokenResponse instanceof $aRUy1.AuthorizationCode) {
                var imsApis = _this.tokenServiceRequest.imsApis;
                return imsApis.getTokenFromCode(tokenResponse, externalParameters).then(function(tokenApiResponse) {
                    var access_token = tokenApiResponse.access_token, state = tokenApiResponse.state, expires_in = tokenApiResponse.expires_in, _a = tokenApiResponse.scope, scope = _a === void 0 ? "" : _a, profile = $91267d1b80f172fc$var$__rest(tokenApiResponse, [
                        "access_token",
                        "state",
                        "expires_in",
                        "scope"
                    ]);
                    var tokenFields = new $hzAhd.TokenFields({
                        scope: scope,
                        tokenValue: access_token,
                        valid: true,
                        state: state,
                        other: tokenResponse.other
                    }, new Date(new Date().getTime() + parseFloat(expires_in)));
                    return Promise.resolve(new $9DNFT.TokenProfileResponse(tokenFields, profile));
                });
            }
            if (tokenResponse instanceof $hzAhd.TokenFields) {
                if (tokenResponse.fromFragment || !_this.tokenServiceRequest.autoValidateToken) return Promise.resolve(new $9DNFT.TokenProfileResponse(tokenResponse, null));
                return _this.callValidateTokenApi(tokenResponse.tokenValue).then(function() {
                    return new $9DNFT.TokenProfileResponse(tokenResponse, null);
                }).catch(function() {
                    return _this.callRefreshToken(externalParameters);
                });
            } else return _this.callRefreshToken(externalParameters);
        };
        var useLocalStorage = tokenServiceRequest.useLocalStorage;
        this.csrfService = csrfService;
        this.tokenServiceRequest = tokenServiceRequest;
        this.storage = $91267d1b80f172fc$var$StorageFactory_1.default.getStorageByName(useLocalStorage ? $h0Bwb.STORAGE_MODE.LocalStorage : $h0Bwb.STORAGE_MODE.SessionStorage);
    }
    /**
     *
     * @returns {TokenFields} representing the token fields from fragment or local storage
     */ TokenService.prototype.getTokenFields = function() {
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var fragmentResult = this.getTokenFromFragment();
        if (fragmentResult instanceof $8vy8k.ModalSignInEvent) return fragmentResult;
        if (fragmentResult instanceof $6ToQ8.FragmentException) return fragmentResult;
        if (fragmentResult instanceof $aRUy1.AuthorizationCode) return fragmentResult;
        if (fragmentResult && fragmentResult.validate(clientId, scope)) {
            fragmentResult.fromFragment = true;
            this.addTokenToStorage(fragmentResult);
            return fragmentResult;
        }
        return this.getTokenFieldsFromStorage();
    };
    /**
     * method used to validate the local storage token value
     */ TokenService.prototype.validateToken = function() {
        var tokenFields = this.getTokenFieldsFromStorage();
        if (!tokenFields) return Promise.reject(null);
        return this.callValidateTokenApi(tokenFields.tokenValue);
    };
    /**
     * method used to retrieve the token release flags
     */ TokenService.prototype.getReleaseFlags = function() {
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis;
        var tokenFields = this.getTokenFieldsFromStorage();
        if (!tokenFields) return Promise.reject(null);
        return imsApis.getReleaseFlags({
            token: tokenFields.tokenValue,
            client_id: clientId
        });
    };
    /**
     * method used to retrieve the token release flags decoded from B32
     */ TokenService.prototype.getDecodedReleaseFlags = function() {
        return this.getReleaseFlags().then(function(result) {
            return $kZbFU.decodeToBitstring(result.releaseFlags, true);
        });
    };
    /**
     * method used to call the validate token api
     * @param token {String} validate the input token value
     */ TokenService.prototype.callValidateTokenApi = function(token) {
        var _this = this;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope, imsApis = _a.imsApis;
        return imsApis.validateToken({
            client_id: clientId,
            token: token
        }).then(function(tokenResponseData) {
            $91267d1b80f172fc$var$Log_1.default.info("validateToken response", tokenResponseData);
            var tokenFields = new $hzAhd.TokenFields($91267d1b80f172fc$var$__assign($91267d1b80f172fc$var$__assign({}, tokenResponseData), {
                tokenValue: token
            }), new Date(parseFloat(tokenResponseData.expires_at)));
            if (tokenFields.validate(clientId, scope)) {
                _this.addTokenToStorage(tokenFields);
                return Promise.resolve(tokenFields);
            }
            throw new Error("could not validate tokenFields");
        }).catch(function(ex) {
            $91267d1b80f172fc$var$Log_1.default.error("validateToken response", ex);
            if (ex instanceof $aCG43.HttpErrorResponse) return Promise.reject(ex);
            _this.removeTokenFromLocalStorage();
            return Promise.reject(ex);
        });
    };
    /**
     * @returns the object values from the url fragment
     */ TokenService.prototype.getTokenFromFragment = function(url) {
        var fragmentValues = $91267d1b80f172fc$var$FragmentHelper_1.default.fragmentToObject(url);
        if (!fragmentValues) return null;
        var token = fragmentValues.access_token, scope = fragmentValues.scope, error = fragmentValues.error, api = fragmentValues.api, _a = fragmentValues.state, state = _a === void 0 ? {} : _a, expires_in = fragmentValues.expires_in, client_id = fragmentValues.client_id, _b = fragmentValues.code, code = _b === void 0 ? "" : _b, other = $91267d1b80f172fc$var$__rest(fragmentValues, [
            "access_token",
            "scope",
            "error",
            "api",
            "state",
            "expires_in",
            "client_id",
            "code"
        ]);
        var _c = state || {}, imslibmodal = _c.imslibmodal, nonce = _c.nonce;
        if (imslibmodal === true) return new $8vy8k.ModalSignInEvent(nonce);
        if (!fragmentValues.from_ims) return null;
        if (client_id !== this.tokenServiceRequest.clientId) return null;
        if (error) return new $6ToQ8.FragmentException($1QykO.IFragmentExceptionType.FRAGMENT, error);
        if (!$91267d1b80f172fc$var$ALLOWED_FRAGMENT_APIS.includes(api)) return new $6ToQ8.FragmentException($1QykO.IFragmentExceptionType.API_NOT_ALLOWED, "api should be authorize or check token and " + api + " is used");
        var validCsrf = this.csrfService.verify(nonce);
        if (!validCsrf) return new $6ToQ8.FragmentException($1QykO.IFragmentExceptionType.CSRF, "CSRF exception");
        if (code) {
            var codeChallenge = new $kTYb4.CodeChallenge();
            var verifier = codeChallenge.getVerifierByKey(nonce);
            if (!verifier) throw new Error("no verifier value has been found");
            return new $aRUy1.AuthorizationCode($91267d1b80f172fc$var$__assign($91267d1b80f172fc$var$__assign({}, fragmentValues), {
                verifier: verifier
            }));
        }
        if (!token) return null;
        var tokenFields = new $hzAhd.TokenFields({
            client_id: client_id,
            scope: scope,
            tokenValue: token,
            valid: true,
            state: state,
            other: other
        }, new Date(new Date().getTime() + parseFloat(expires_in)));
        return tokenFields;
    };
    TokenService.prototype.getItemFromStorage = function(key) {
        return this.storage.getItem(key);
    };
    /**
     * @returns the TokenFields structure from local storage or null
     * @isReauth boolean value; true if token is for reauthentification
     */ TokenService.prototype.getTokenFieldsFromStorage = function(isReauth) {
        if (isReauth === void 0) isReauth = false;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        var tokenStorageKey = this.getAccessTokenKey(isReauth);
        var tokenData = this.getItemFromStorage(tokenStorageKey);
        if (!tokenData) return null;
        var parsedToken = JSON.parse(tokenData);
        var expire = parsedToken.expire ? new Date(Date.parse(parsedToken.expire)) : new Date(parsedToken.expiresAtMilliseconds);
        var tokenFields = new $hzAhd.TokenFields(parsedToken, expire);
        return tokenFields.validate(clientId, scope) ? tokenFields : null;
    };
    /**
     * private method used to compose the key used for storage
     * @param clientId
     * @param scope
     * @param isReAuth default false; true means that the key is for re-authentification
     */ TokenService.prototype.getAccessTokenKey = function(isReauth) {
        if (isReauth === void 0) isReauth = false;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope;
        return $h0Bwb.TOKEN_STORAGE_KEY + "/" + clientId + "/" + isReauth + "/" + $4AD9k.sortScopes(scope);
    };
    /**
     * save the token into local storage
     * @param tokenFragment - object with the values from fragment
     */ TokenService.prototype.addTokenToStorage = function(tokenFields) {
        if (!tokenFields) return;
        var isReauth = tokenFields.isReauth();
        var tokenStorageKey = this.getAccessTokenKey(isReauth);
        var clonedTokenFields = $91267d1b80f172fc$var$__assign({}, tokenFields);
        clonedTokenFields.state = {};
        clonedTokenFields.other = "{}";
        var storagePayload = JSON.stringify(clonedTokenFields);
        this.storage.setItem(tokenStorageKey, storagePayload);
    };
    /**
     * remove the token from local storage
     */ TokenService.prototype.removeTokenFromLocalStorage = function() {
        var tokenStorageKey = this.getAccessTokenKey();
        this.storage.removeItem(tokenStorageKey);
    };
    /**
     * remove the reauth token from local storage
     */ TokenService.prototype.removeReauthTokenFromLocalStorage = function() {
        var tokenStorageKey = this.getAccessTokenKey(true);
        this.storage.removeItem(tokenStorageKey);
    };
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.refreshToken = function(externalParameters) {
        var _this = this;
        if (externalParameters === void 0) externalParameters = {};
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis, scope = _a.scope;
        var tokenFields = this.getTokenFieldsFromStorage();
        var userId = tokenFields ? tokenFields.user_id : "";
        return imsApis.checkToken({
            client_id: clientId,
            scope: scope
        }, externalParameters, userId).then(function(data) {
            if (!data) throw new Error("refresh token --> no response");
            var access_token = data.access_token, expires_in = data.expires_in, token_type = data.token_type, error = data.error, _a = data.error_description, error_description = _a === void 0 ? "" : _a, sid = data.sid, profileValues = $91267d1b80f172fc$var$__rest(data, [
                "access_token",
                "expires_in",
                "token_type",
                "error",
                "error_description",
                "sid"
            ]);
            if (error) throw new Error(error + " " + error_description);
            var profile = Object.keys(profileValues).length ? profileValues : null;
            var tokenInfo = {
                token: access_token,
                expire: new Date(Date.now() + parseFloat(expires_in)),
                token_type: token_type,
                sid: sid
            };
            var tokenFields = _this.updateToken(tokenInfo) || {};
            var refreshTokenResponse = {
                tokenInfo: $91267d1b80f172fc$var$__assign($91267d1b80f172fc$var$__assign({}, tokenInfo), {
                    impersonatorId: tokenFields.impersonatorId || "",
                    isImpersonatedSession: tokenFields.isImpersonatedSession || false,
                    pbaSatisfiedPolicies: tokenFields.pbaSatisfiedPolicies || []
                }),
                profile: profile
            };
            return Promise.resolve(refreshTokenResponse);
        }).catch(function(refreshTokenException) {
            if (refreshTokenException === void 0) refreshTokenException = {};
            if (refreshTokenException instanceof $aCG43.HttpErrorResponse) return Promise.reject(refreshTokenException);
            if (refreshTokenException instanceof $fwlYT.RideException) return Promise.reject(refreshTokenException);
            _this.removeTokenFromLocalStorage();
            return Promise.reject(new $iWL10.TokenExpiredException(refreshTokenException));
        });
    };
    /**
     * function used to change the user profile
     * @param externalParameters external parameters received outside of the library
     * @param userId {String} represents the user id used to get the new token and profile
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.switchProfile = function(userId, externalParameters) {
        var _this = this;
        if (externalParameters === void 0) externalParameters = {};
        var _a = this.tokenServiceRequest, clientId = _a.clientId, imsApis = _a.imsApis, scope = _a.scope;
        return imsApis.switchProfile({
            client_id: clientId,
            scope: scope
        }, externalParameters, userId).then(function(data) {
            if (!data) throw new Error("refresh token --> no response");
            var access_token = data.access_token, expires_in = data.expires_in, token_type = data.token_type, error = data.error, _a = data.error_description, error_description = _a === void 0 ? "" : _a, sid = data.sid, profileValues = $91267d1b80f172fc$var$__rest(data, [
                "access_token",
                "expires_in",
                "token_type",
                "error",
                "error_description",
                "sid"
            ]);
            if (error) throw new Error(error + " " + error_description);
            var profile = Object.keys(profileValues).length ? profileValues : null;
            var tokenInfo = {
                token: access_token,
                expire: new Date(Date.now() + parseFloat(expires_in)),
                token_type: token_type,
                sid: sid
            };
            var tokenFields = _this.updateToken(tokenInfo) || {};
            var refreshTokenResponse = {
                tokenInfo: $91267d1b80f172fc$var$__assign($91267d1b80f172fc$var$__assign({}, tokenInfo), {
                    impersonatorId: tokenFields.impersonatorId || "",
                    isImpersonatedSession: tokenFields.isImpersonatedSession || false
                }),
                profile: profile
            };
            return Promise.resolve(refreshTokenResponse);
        }).catch(function(switchTokenException) {
            if (switchTokenException === void 0) switchTokenException = {};
            return Promise.reject(switchTokenException);
        });
    };
    /**
     *
     * @param externalParameters external parameters received outside of the library
     * @returns IRefreshTokenResponse containing the refresh token information
     */ TokenService.prototype.callRefreshToken = function(externalParameters) {
        if (externalParameters === void 0) externalParameters = {};
        return this.refreshToken(externalParameters).then(function(tokenResponse) {
            var _a = tokenResponse.tokenInfo, token = _a.token, expire = _a.expire, profile = tokenResponse.profile;
            var refreshTokenFields = new $hzAhd.TokenFields({
                valid: true,
                tokenValue: token
            }, expire);
            var tokenProfileResponse = new $9DNFT.TokenProfileResponse(refreshTokenFields, profile);
            return Promise.resolve(tokenProfileResponse);
        }).catch(function(ex) {
            return Promise.reject(ex);
        });
    };
    /**
     * update the token into local storage after a refresh action
     * @param tokenInfo {ITokenInformation}
     *
     */ TokenService.prototype.updateToken = function(tokenInfo) {
        var token = tokenInfo.token, expire = tokenInfo.expire;
        var tokenFields = new $hzAhd.TokenFields({
            tokenValue: token
        }, expire);
        if (!tokenFields) return null;
        tokenFields.tokenValue = token;
        this.addTokenToStorage(tokenFields);
        return tokenFields;
    };
    /**
     * remove the tokens from the local storage
     */ TokenService.prototype.purge = function() {
        this.removeTokenFromLocalStorage();
        this.removeReauthTokenFromLocalStorage();
    };
    /**
     * set a new access token
     * @param tokenInfo {StandaloneToken} represents the token and expiration ms
     */ TokenService.prototype.setStandAloneToken = function(standaloneToken) {
        var token = standaloneToken.token, sid = standaloneToken.sid, _a = standaloneToken.expirems, expirems = _a === void 0 ? -1 : _a;
        var _b = this.tokenServiceRequest, clientId = _b.clientId, scope = _b.scope;
        var expire = new Date(new Date().getTime() + expirems);
        var tokenFields = new $hzAhd.TokenFields({
            valid: true,
            tokenValue: token
        }, expire);
        if (!tokenFields.validate(clientId, scope)) return false;
        var tokenInfoToBeSaved = {
            expire: expire,
            token: token,
            sid: sid
        };
        this.updateToken(tokenInfoToBeSaved);
        return true;
    };
    /**
     * method used during initialization in order to get a ijt token
     * @returns {Promise<TokenProfileResponse>} ijt response
     */ TokenService.prototype.exchangeIjt = function(ijt) {
        var _this = this;
        var _a = this.tokenServiceRequest, clientId = _a.clientId, scope = _a.scope, imsApis = _a.imsApis;
        var apiRequest = {
            client_id: clientId,
            scope: scope
        };
        return imsApis.exchangeIjt(apiRequest, ijt).then(function(ijtResponse) {
            var valid = ijtResponse.valid, access_token = ijtResponse.access_token, expires_in = ijtResponse.expires_in, profile = ijtResponse.profile;
            if (valid === false) return Promise.reject(ijtResponse);
            var expire = new Date(Date.now() + parseFloat(expires_in) * $91267d1b80f172fc$var$ONE_SECOND_MILLIS);
            var ijtTokenFields = new $hzAhd.TokenFields({
                valid: true,
                tokenValue: access_token
            }, expire);
            _this.addTokenToStorage(ijtTokenFields);
            var tokenProfileResponse = new $9DNFT.TokenProfileResponse(ijtTokenFields, profile);
            return Promise.resolve(tokenProfileResponse);
        });
    };
    return TokenService;
}();
module.exports.TokenService = $91267d1b80f172fc$var$TokenService;

});
parcelRegister("hzAhd", function(module, exports) {
"use strict";
var $ccb1d8593d63c7e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/* eslint-disable @typescript-eslint/camelcase */ var $ccb1d8593d63c7e9$var$ApiHelpers_1 = $ccb1d8593d63c7e9$var$__importDefault((parcelRequire("9zwbo")));

var $ccb1d8593d63c7e9$var$Log_1 = $ccb1d8593d63c7e9$var$__importDefault((parcelRequire("545sK")));

var $4AD9k = parcelRequire("4AD9k");
/**
 * class used to store the token fields obtained during validation and validate the token against values from adobeIdData
 */ var $ccb1d8593d63c7e9$var$TokenFields = /** @class */ function() {
    /**
     *
     * @param tokenProps {object} represents the server answer for a validation token request
     * @param expire {Date} represents the token expiration date
     *
     * this class is used to create a TokenFields instance based on storage object;
     * if token was saved by ImsLib v1, the token field is stored in access_token property and expiration in 'expiresAtMilliseconds',
     * otherwise, (for imsLIb v2) 'tokenValue' and 'expire' properties are used
     */ function TokenFields(tokenProps, expire) {
        var _this = this;
        this.REAUTH_SCOPE = "reauthenticated";
        this.valid = false;
        this.isReauth = function() {
            return _this.scope.indexOf(_this.REAUTH_SCOPE) >= 0;
        };
        /**
         * represents the client id associated with this token fields
         */ this.client_id = "";
        /**
         * represents the scope used to retrieve the token
         */ this.scope = "";
        /**
         * represents the token expiration date
         */ this.expire = new Date();
        /**
         * represents the user_id associated with the token
         */ this.user_id = "";
        this.tokenValue = "";
        /**
         * represents the session identifier
         */ this.sid = "";
        this.state = null;
        /**
         * true if the token fields is created based on the fragment values and not from storage
         */ this.fromFragment = false;
        this.impersonatorId = "";
        this.isImpersonatedSession = false;
        var valid = tokenProps.valid, tokenValue = tokenProps.tokenValue, access_token = tokenProps.access_token, state = tokenProps.state, other = tokenProps.other;
        var token = tokenValue || access_token;
        var parsedToken = this.parseJwt(token);
        if (!parsedToken) throw new Error("token cannot be decoded " + token);
        this.state = $ccb1d8593d63c7e9$var$ApiHelpers_1.default.toJson(state);
        var client_id = parsedToken.client_id, user_id = parsedToken.user_id, tokenScope = parsedToken.scope, sid = parsedToken.sid, imp_id = parsedToken.imp_id, imp_sid = parsedToken.imp_sid, pba = parsedToken.pba;
        this.client_id = client_id;
        this.expire = expire;
        this.user_id = user_id;
        this.scope = tokenScope;
        this.valid = valid;
        this.tokenValue = token;
        this.sid = sid;
        this.other = other;
        this.impersonatorId = imp_id || "";
        this.isImpersonatedSession = !!imp_sid;
        this.pbaSatisfiedPolicies = pba && pba.split(",") || [];
    }
    /**
     * parse the token value
     */ TokenFields.prototype.parseJwt = function(token) {
        if (!token) return null;
        try {
            return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
        } catch (ex) {
            $ccb1d8593d63c7e9$var$Log_1.default.error("error on decoding token ", token, ex);
            return null;
        }
    };
    /**
     *
     * @param adobeClientId client id provided on adobe id
     * @param adobeIdScope scope value provided in adobe id
     * @returns {boolean} true if token is valid otherwise false
     */ TokenFields.prototype.validate = function(adobeClientId, adobeIdScope) {
        var _a = this, valid = _a.valid, client_id = _a.client_id, scope = _a.scope, expire = _a.expire;
        // check if is expired
        if (expire < new Date()) {
            $ccb1d8593d63c7e9$var$Log_1.default.error("token invalid  --> expires_at", expire);
            return false;
        }
        if (valid != undefined && !valid) {
            $ccb1d8593d63c7e9$var$Log_1.default.error("token invalid  --> valid");
            return false;
        }
        if (client_id !== adobeClientId) {
            $ccb1d8593d63c7e9$var$Log_1.default.error("token invalid  --> client id", client_id, adobeClientId);
            return false;
        }
        if (!$4AD9k.validateScopeInclusion(adobeIdScope, scope)) {
            $ccb1d8593d63c7e9$var$Log_1.default.error("token invalid  --> scope", " token scope =", scope, "vs adobeIdScope =", adobeIdScope, ".");
            return false;
        }
        return true;
    };
    return TokenFields;
}();
module.exports.TokenFields = $ccb1d8593d63c7e9$var$TokenFields;

});

parcelRegister("hsEsQ", function(module, exports) {
"use strict";
var $cb64708781c016de$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cb64708781c016de$var$ApiHelpers_1 = $cb64708781c016de$var$__importDefault((parcelRequire("9zwbo")));
/**
 * class used to implement the main functions used for fragment
 */ var $cb64708781c016de$var$FragmentHelper = /** @class */ function() {
    function FragmentHelper() {}
    FragmentHelper.prototype.fragmentToObject = function(urlArg) {
        var currentHash = this.getHashFromURL(urlArg);
        if (!currentHash) return null;
        var url = this.processHashUrl(currentHash);
        var oldHash = this.getOldHash(url);
        // fragment values should contain only values starting with old_hash
        //this is in case when hash route is used: e.g.: https://localhost.corp.adobe.com:9000/#/cdn#old_hash=...
        //#/cdn# should be ignored when getQueryParamsAsMap is called;
        var urlWithoutRoute = oldHash ? url.slice(url.indexOf("old_hash")) : url;
        var urlWithoutOldHash = this.removeOldHash(urlWithoutRoute);
        var imsResponseAsMap = this.getQueryParamsAsMap(urlWithoutOldHash);
        if (oldHash) imsResponseAsMap["old_hash"] = oldHash;
        var stateAsString = imsResponseAsMap["state"];
        if (stateAsString) imsResponseAsMap["state"] = $cb64708781c016de$var$ApiHelpers_1.default.toJson(stateAsString);
        return imsResponseAsMap;
    };
    /**
     * function used to determine the old_hash value contained into the source
     * @param source {String} represents the input source used to determine the old_hash
     * @returns {String}
     */ FragmentHelper.prototype.getOldHash = function(source) {
        if (!source) return "";
        var match = source.match("old_hash=(.*?)&from_ims=true");
        if (!match) return "";
        return match[1];
    };
    /**
     * remove the old hash value from the input string
     * @param source {String} represents the input source
     */ FragmentHelper.prototype.removeOldHash = function(source) {
        if (!source) return source;
        return source.replace(/old_hash=(.*?)&from_ims=true/gi, "from_ims=true");
    };
    /**
   * Gets the hash from an url.
   * @param {string=} url The URL from which to get the hash.
   * If missing use the current page's URL.
   * @Note: the # is not returned from url
   * @returns {string}
   */ FragmentHelper.prototype.getHashFromURL = function(url) {
        if (url === void 0) url = window.location.href;
        var index = url.indexOf("#");
        return index !== -1 ? url.substring(index + 1) : "";
    };
    /**
   * Parses a query string to a JSON.
   * @NOTE Sometimes, the query string is actually a hash, due to inconsistent servers
   * @param source {String}; represents the inpt strring value wich will be transformed to object
   * @returns {!Object}
   */ FragmentHelper.prototype.getQueryParamsAsMap = function(source) {
        if (!source) return {};
        var paramMap = {};
        //in case the source starts with #, ? or &, the first character is removed. 
        source = source.replace(/^(#\/|\/|#|\?|&)/, "");
        source.split("&").forEach(function(keyValuePair) {
            if (keyValuePair.length) {
                var arr = keyValuePair.split("=");
                paramMap[arr[0]] = decodeURIComponent(arr[1]);
            }
        });
        return paramMap;
    };
    /**
   * @param source {string} represent the input source wich will be processed
   * The backend appends a second "#" sign to redirect_uri, even if it already contains one.
   * @see https://jira.corp.adobe.com/browse/IMSB-4107554
   */ FragmentHelper.prototype.processHashUrl = function(source) {
        return source.replace("?error", "#error").replace(/#/gi, "&").replace("from_ims=true?", "from_ims=true&");
    };
    return FragmentHelper;
}();
module.exports.default = new $cb64708781c016de$var$FragmentHelper();

});

parcelRegister("6ToQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $504b25cebb1729cb$var$FragmentException = /** @class */ function() {
    function FragmentException(type, message) {
        this.message = "";
        this.type = "";
        this.type = type;
        this.message = message;
    }
    return FragmentException;
}();
module.exports.FragmentException = $504b25cebb1729cb$var$FragmentException;

});

parcelRegister("1QykO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Enumeration values used for defining possible fragment exception types
 *
 */ var $158547e78af861ca$var$IFragmentExceptionType;
(function(IFragmentExceptionType) {
    /**
     * fragment exception type
     */ IFragmentExceptionType["FRAGMENT"] = "fragment";
    /**
     * csrf exception type
     */ IFragmentExceptionType["CSRF"] = "csrf";
    IFragmentExceptionType["NOT_AUTHORIZE"] = "not_authorize";
    IFragmentExceptionType["API_NOT_ALLOWED"] = "not_allowed";
})($158547e78af861ca$var$IFragmentExceptionType = module.exports.IFragmentExceptionType || (module.exports.IFragmentExceptionType = {}));

});

parcelRegister("9DNFT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $704e49f2c4e77262$var$TokenProfileResponse = /** @class */ function() {
    function TokenProfileResponse(tokenFields, profile) {
        this.profile = null;
        this.tokenFields = tokenFields;
        this.profile = profile;
    }
    return TokenProfileResponse;
}();
module.exports.TokenProfileResponse = $704e49f2c4e77262$var$TokenProfileResponse;

});

parcelRegister("iWL10", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to encapsulate the token expired message
 */ var $dcb21d049c2ca943$var$TokenExpiredException = /** @class */ function() {
    function TokenExpiredException(exception) {
        this.exception = null;
        this.exception = exception;
    }
    return TokenExpiredException;
}();
module.exports.TokenExpiredException = $dcb21d049c2ca943$var$TokenExpiredException;

});

parcelRegister("aRUy1", function(module, exports) {
"use strict";
var $7e9ab7cded90ae9b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used to store the authorization code fields
 */ var $7e9ab7cded90ae9b$var$AuthorizationCode = /** @class */ function() {
    /**
     * this class is used to create a AuthorizationCode instance based on authorization server response
     * @param authProps {object} represents the authorization server response
     */ function AuthorizationCode(authProps) {
        /**
         * represents the client id associated with this token fields
         */ this.client_id = "";
        /**
         * represents the scope used to retrieve the token
         */ this.scope = "";
        /**
         * represents the code recived during the authorization
         */ this.code = "";
        /**
         * represents the state used during initialize
         */ this.state = null;
        /**
         * represents the code_verifier used to generate the code_challenge (used during authorization flow)
         */ this.code_verifier = "";
        /**
         * represents the other properties from url
         */ this.other = null;
        var code = authProps.code, state = authProps.state, client_id = authProps.client_id, scope = authProps.scope, verifier = authProps.verifier, other = $7e9ab7cded90ae9b$var$__rest(authProps, [
            "code",
            "state",
            "client_id",
            "scope",
            "verifier"
        ]);
        this.state = state;
        this.client_id = client_id;
        this.code = code;
        this.scope = scope;
        this.code_verifier = verifier;
        this.other = other;
    }
    return AuthorizationCode;
}();
module.exports.AuthorizationCode = $7e9ab7cded90ae9b$var$AuthorizationCode;

});

parcelRegister("8vy8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * class used only by the popup window in order to know that the parent should be notified
 * it is triggered by getTokenFields if the redirect state contains imslibmodal propery
 * during imslib initialization, if this type of event is received than the parent window will be notified
 */ var $631bb21f940132e0$var$ModalSignInEvent = /** @class */ function() {
    /**
     * this type of event is triggered by get token from fragment method (in case imslibmodal from fragment is true)
     * @param wndRedirectPropName {String} represents the property used by popup window to set the redirect url
     */ function ModalSignInEvent(wndRedirectPropName) {
        /**
         * represents the property used by popup window, to set the redirect url
         * this property will be used only if the popup.opener is not defined (edge bug)
         */ this.wndRedirectPropName = "";
        this.wndRedirectPropName = wndRedirectPropName;
    }
    return ModalSignInEvent;
}();
module.exports.ModalSignInEvent = $631bb21f940132e0$var$ModalSignInEvent;

});

parcelRegister("kZbFU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Base32 decoding module.
 * It uses the alphabet defined in {@link https://tools.ietf.org/html/rfc4648#page-9|RFC 4648}
*/ var $f4728f87fd8ef5e8$var$alphabet = "abcdefghijklmnopqrstuvwxyz234567".split("");
var $f4728f87fd8ef5e8$var$indexTable = $f4728f87fd8ef5e8$var$alphabet.reduce(function(acc, curr, idx) {
    acc[curr] = idx;
    return acc;
}, {
    "=": 0
});
/**
     * Pads the string with the given char until the required length
     *
     * @param  {!string} ch The character used to pad
     * @param  {!number} num The required string length
     * @param  {!string} str The starting string to pad
     * @return {!string}
     */ var $f4728f87fd8ef5e8$var$leftPad = function(ch, num, str) {
    var charsNeeded = num - str.length;
    if (charsNeeded > 0) // +1 here because we're using join
    str = new Array(charsNeeded + 1).join(ch) + str;
    return str;
};
/**
     * Converts a number to a string representation of it in binary and
     * pads it with 0s until it's 5 bits in length.
     *
     * @param  {!number} num The number
     * @return {!string} The padded binary string
     */ var $f4728f87fd8ef5e8$var$toBase32PaddedBinary = function(num) {
    return $f4728f87fd8ef5e8$var$leftPad("0", 5, num.toString(2));
};
var $f4728f87fd8ef5e8$var$validateEncodedData = function(chars) {
    if (chars.length % 8 !== 0) throw new Error("Data length is not a multiple of 8");
    chars.forEach(function(ch) {
        if (!(ch in $f4728f87fd8ef5e8$var$indexTable)) throw new Error("Unknown encoded character " + ch);
    });
    var foundPaddingChar = false;
    chars.forEach(function(ch) {
        if (ch !== "=" && foundPaddingChar) throw new Error("Found padding char in the middle of the string");
        else if (ch === "=") foundPaddingChar = true;
    });
};
var $f4728f87fd8ef5e8$var$countPadding = function(chars) {
    var idx = chars.length - 1;
    var count = 0;
    while(chars[idx] === "="){
        ++count;
        --idx;
    }
    return count;
};
/**
   * Converts every byte in a bitstring to it's least-significant-bit representation
   *
   * @example
   * var bitstring = '00000111';
   * bitstringToLSB(bitstring); // => '11100000'
   *
   * @param  {string} bitstring A string of 0s and 1s
   * @return {string} The LSB representation of the bitstring
   */ var $f4728f87fd8ef5e8$var$bitstringToLSB = function(bitstring) {
    var BYTE_LENGTH = 8;
    var result = "";
    if (bitstring.length % 8 !== 0) throw new Error("Length must be a multiple of 8");
    for(var byteStart = 0, len = bitstring.length; byteStart < len; byteStart += BYTE_LENGTH){
        var byte = bitstring.slice(byteStart, byteStart + BYTE_LENGTH);
        result += byte.split("").reverse().join("");
    }
    return result;
};
/**
     * Decodes a base32-encoded string to a bitstring.
     *
     * The function uses the base32 alphabet defined in {@link https://tools.ietf.org/html/rfc4648#page-9|RFC 4648}.
     * This function does not take into account character aliases.
     *
     * @param  {!string} str The base32-encode data
     * @return {!string} A bitstring of the decoded data
     *
     * @throws {Error} If the data contains non-base32 characters
     *
     * @memberof module:base32
     * @public
     */ module.exports.decodeToBitstring = function(str, lsb) {
    /* Decoding algorithm
       * 1. validate data (length is multiple of 8, no unknown chars, padding is at the end)
       * 2. convert data to binary based on the lookup table
       * 3. remove extraneous 0s added from padding
       *   3.1. remove five 0s for each padding char =
       *   3.2. remove a 0 until data.length is a multiple of 8
       */ if (lsb === void 0) lsb = false;
    if (typeof str !== "string") throw new Error("Data is not a string");
    var chars = str.toLowerCase().split("");
    $f4728f87fd8ef5e8$var$validateEncodedData(chars);
    var paddingCount = $f4728f87fd8ef5e8$var$countPadding(chars);
    var binary = [];
    chars.forEach(function(ch) {
        binary.push($f4728f87fd8ef5e8$var$toBase32PaddedBinary($f4728f87fd8ef5e8$var$indexTable[ch]));
    });
    var data = binary.join("");
    // remove padding:
    // five 0s for each `=`
    if (paddingCount > 0) data = data.slice(0, -5 * paddingCount);
    // remove all the 0s until data.length is dividable by 8
    if (data.length % 8 !== 0) data = data.slice(0, -1 * (data.length % 8));
    return lsb ? $f4728f87fd8ef5e8$var$bitstringToLSB(data) : data;
};

});


parcelRegister("ejCBD", function(module, exports) {
"use strict";
var $a6c0c95f3c43ffae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a6c0c95f3c43ffae$var$Log_1 = $a6c0c95f3c43ffae$var$__importDefault((parcelRequire("545sK")));
/**
 * auto refresh minutes interval
 */ var $a6c0c95f3c43ffae$var$ONE_MIN_MS = 60000;
var $a6c0c95f3c43ffae$var$ONE_SECOND_MS = 1000;
var $a6c0c95f3c43ffae$var$REFRESH_INTERVAL_BEFORE_EXPIRATION_MIN = 1;
var $a6c0c95f3c43ffae$var$USER_INTERACTION_EVENTS = [
    "keyup",
    "mousemove"
];
/**
 * class used for automatically refresh the token.
 * the refreshToken method is automatically triggered one minute before the token expires
 * if the user interacted with the page at all after the startAutoRefreshFlow was called.
 */ var $a6c0c95f3c43ffae$var$TokenAutoRefresh = /** @class */ function() {
    function TokenAutoRefresh() {
        var _this = this;
        /**
         * Holds the date of the last user interaction
         */ this.lastUserInteraction = Date.now();
        /**
         * Flag that the user was active at all during this refresh cycle
         */ this.userActive = false;
        /**
         * Handler for user interactions
         * Initiates the Token Refresh one minute before it expires, if any interaction is detected
         * Returns immediately if the refresh is already scheduled
         * @returns
         */ this.userInteractionHandler = function() {
            _this.lastUserInteraction = Date.now();
            _this.userActive = true;
        };
        /**
        * Initializes the event listeners for user interaction
        * The function passed must be the member bound to this instance
        */ this.initializeDomEvents = function() {
            $a6c0c95f3c43ffae$var$USER_INTERACTION_EVENTS.forEach(function(eventName) {
                return window.addEventListener(eventName, _this.userInteractionHandler);
            });
        };
        /**
         * Clears event listeners
         */ this.clearDomEvents = function() {
            $a6c0c95f3c43ffae$var$USER_INTERACTION_EVENTS.forEach(function(eventName) {
                return window.removeEventListener(eventName, _this.userInteractionHandler);
            });
        };
    }
    /**
     * starts the autorefresh flow
     * @param autoRefreshParameters {@link ITokenAutoRefreshParams} parameters used for auto refresh flow
     */ TokenAutoRefresh.prototype.startAutoRefreshFlow = function(autoRefreshParameters) {
        var _this = this;
        var _a;
        if (!autoRefreshParameters || !autoRefreshParameters.expire || !autoRefreshParameters.refreshTokenMethod) {
            $a6c0c95f3c43ffae$var$Log_1.default.info("Won't schedule token auto-refresh", !autoRefreshParameters, !autoRefreshParameters.expire, !autoRefreshParameters.refreshTokenMethod);
            return;
        }
        this.refreshParameters = autoRefreshParameters;
        if (this.refreshTimerId) {
            $a6c0c95f3c43ffae$var$Log_1.default.info("Auto-refresh timer already set, clearing");
            clearTimeout(this.refreshTimerId);
        }
        this.clearDomEvents();
        this.initializeDomEvents();
        var interval = this.fromNowToNMinutesBeforeDate((_a = this.refreshParameters) === null || _a === void 0 ? void 0 : _a.expire, $a6c0c95f3c43ffae$var$REFRESH_INTERVAL_BEFORE_EXPIRATION_MIN);
        $a6c0c95f3c43ffae$var$Log_1.default.info("Auto-refresh timer will run after (seconds)", interval / $a6c0c95f3c43ffae$var$ONE_SECOND_MS);
        this.refreshTimerId = setTimeout(function() {
            var _a;
            if (_this.userActive) {
                var userInactiveSince = Math.floor((Date.now() - _this.lastUserInteraction) / $a6c0c95f3c43ffae$var$ONE_SECOND_MS);
                (_a = _this.refreshParameters) === null || _a === void 0 || _a.refreshTokenMethod({
                    userInactiveSince: userInactiveSince
                }, true);
                $a6c0c95f3c43ffae$var$Log_1.default.info("Auto-refresh performed, user was inactive for (seconds)", userInactiveSince);
            } else $a6c0c95f3c43ffae$var$Log_1.default.info("Auto-refresh skipped, user was never active");
        }, interval);
    };
    /**
     * Returns the milliseconds interval from now to a given date minus N minutes
     * @param toDate represents the target date
     * @param nMinutes represents the number of minutes to substract from the target date
     * @returns the interval in milliseconds; if the resulting interval is <= 0,
     * this method returns nMinutes in ms
     */ TokenAutoRefresh.prototype.fromNowToNMinutesBeforeDate = function(toDate, nMinutes) {
        var interval = toDate.getTime() - Date.now() - nMinutes * $a6c0c95f3c43ffae$var$ONE_MIN_MS;
        if (interval <= 0) return nMinutes * $a6c0c95f3c43ffae$var$ONE_MIN_MS;
        return interval;
    };
    return TokenAutoRefresh;
}();
module.exports.default = new $a6c0c95f3c43ffae$var$TokenAutoRefresh();

});



parcelRegister("3LITL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exchangeToken = module.exports.initializeShellDataForHeader = module.exports.getPaginatedAccountClusters = module.exports.getAccountCluster = module.exports.initializeShellDataForReload = module.exports.initializeShellDataForLogin = module.exports.TOKEN_EXCHANGE_QUERY = module.exports.SHELL_HEADER_QUERY = module.exports.ACCOUNT_CLUSTER_QUERY = module.exports.ACCOUNTS_QUERY = module.exports.LOGIN_QUERY = module.exports.RELOAD_QUERY = void 0;

var $apIgy = parcelRequire("apIgy");

var $bllbv = parcelRequire("bllbv");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $7633bec5a9d3e49e$var$PREF_PARAMS = `appId: "${$apIgy.PREF_APPID}", groupId: "${$apIgy.PREF_GROUPID}", level: "${$bllbv.SettingsLevel.USER}"`;
const $7633bec5a9d3e49e$var$GQL_FRAGMENTS = {
    extendedAccountData: `
    fragment extendedFragment on ImsExtendedAccountClusterData {
      data {
        orgs {
          aemInstances {
            domain
            title
          }
          aepRegion
          hasAEP
          imsOrgId
          orgName
          tenantId
        }
        owningOrg {
          aemInstances {
            domain
            title
          }
          aepRegion
          imsOrgId
          hasAEP
          tenantId
          orgName
        }
        exchangeToken {
          token {
            access_token
            expires_in
          }
          profile
        }
        userId
        userType
      }
      next
      preferredLanguages
    }
  `
};
const $7633bec5a9d3e49e$var$RELOAD_QUERY = `
  query shellInitDataQuery($includeAEM: Boolean, $selectedOrg: String) {
    getSettings(${$7633bec5a9d3e49e$var$PREF_PARAMS}, settings: {
      coachMarks: {},
      defaultOrg: "",
      lastLoggedInOrg: "",
      lastRecents: {},
      lastSelectedSubOrgs: {},
      shellNav: {},
      theme: "",
      recentSandboxes: [],
      userConsent: {},
      userConsentDismissed: 0,
      userRoles: {},
      userRolesTimeline: {},
      userSandboxes: {}
    }) {
      settings
    }
    getConsentPermissions(useMpsCache: true) {
      last_update_dts
      permissions {
        name
        enabled
        last_update_dts
      }
    }
    imsExtendedAccountClusterData(includeAEM: $includeAEM, selectedOrg: $selectedOrg) {
      ...extendedFragment
    }
  }
  ${$7633bec5a9d3e49e$var$GQL_FRAGMENTS.extendedAccountData}
`;
module.exports.RELOAD_QUERY = $7633bec5a9d3e49e$var$RELOAD_QUERY;
const $7633bec5a9d3e49e$var$LOGIN_QUERY = `
  query shellInitDataQuery($includeAEM: Boolean, $selectedOrg: String) {
    imsExtendedAccountClusterData(includeAEM: $includeAEM, selectedOrg: $selectedOrg) {
      ...extendedFragment
    }
    getSettings(${$7633bec5a9d3e49e$var$PREF_PARAMS}, settings: {
      coachMarks: {},
      defaultOrg: "",
      lastLoggedInOrg: "",
      lastRecents: {},
      lastSelectedSubOrgs: {},
      recentSandboxes: [],
      shellNav: {},
      theme: "",
      userConsent: {},
      userConsentDismissed: 0,
      userRoles: {},
      userRolesTimeline: {},
      userSandboxes: {}
    }) {
      settings
    }
    getConsentPermissions(useMpsCache: true) {
      last_update_dts
      permissions {
        name
        enabled
        last_update_dts
      }
    }
    userProfileJson(ignoreImsCache: false)
  }
  ${$7633bec5a9d3e49e$var$GQL_FRAGMENTS.extendedAccountData}
`;
module.exports.LOGIN_QUERY = $7633bec5a9d3e49e$var$LOGIN_QUERY;
const $7633bec5a9d3e49e$var$ACCOUNTS_QUERY = `
  query extendedAccountData($from: String!, $includeAEM: Boolean) {
    imsExtendedAccountClusterData(from: $from, includeAEM: $includeAEM) {
      ...extendedFragment
    }
  }
  ${$7633bec5a9d3e49e$var$GQL_FRAGMENTS.extendedAccountData}
`;
module.exports.ACCOUNTS_QUERY = $7633bec5a9d3e49e$var$ACCOUNTS_QUERY;
const $7633bec5a9d3e49e$var$ACCOUNT_CLUSTER_QUERY = `
  query extendedAccountData($includeAEM: Boolean) {
    imsExtendedAccountClusterData(includeAEM: $includeAEM) {
      ...extendedFragment
    }
  }
  ${$7633bec5a9d3e49e$var$GQL_FRAGMENTS.extendedAccountData}
`;
module.exports.ACCOUNT_CLUSTER_QUERY = $7633bec5a9d3e49e$var$ACCOUNT_CLUSTER_QUERY;
const $7633bec5a9d3e49e$var$SHELL_HEADER_QUERY = `
  query shellHeaderQuery($locale: String, $config_version: Int, $settings: JSON!, $imageKeySize: [Int]!) {
    getSettings(settings: $settings, appId: "pulse", groupId: "notifications") {
      settings
    }
    getPPSProfile {
      images
      encodedImage(imageKey: $imageKeySize)
    }
    userOrgPreferences {
      displayAlert
    }
    timeline(config_version: $config_version, locale: $locale)
    userProfileJson
  }
`;
module.exports.SHELL_HEADER_QUERY = $7633bec5a9d3e49e$var$SHELL_HEADER_QUERY;
const $7633bec5a9d3e49e$var$TOKEN_EXCHANGE_QUERY = `
  query userTokenQuery($targetUserId: String!) {
    exchangeToken(targetUserId: $targetUserId) {
      token {
        access_token
        expires_in
      }
      profile
    }
  }
`;
module.exports.TOKEN_EXCHANGE_QUERY = $7633bec5a9d3e49e$var$TOKEN_EXCHANGE_QUERY;
const $7633bec5a9d3e49e$var$initializeShellDataForLogin = (options)=>(0, $apIgy.gqlQuery)($7633bec5a9d3e49e$var$LOGIN_QUERY, options, {
        ignoreErrorsOnPaths: [
            "getSettings",
            "getConsentPermissions"
        ]
    });
module.exports.initializeShellDataForLogin = $7633bec5a9d3e49e$var$initializeShellDataForLogin;
const $7633bec5a9d3e49e$var$initializeShellDataForReload = (options)=>(0, $apIgy.gqlQuery)($7633bec5a9d3e49e$var$RELOAD_QUERY, options, {
        ignoreErrorsOnPaths: [
            "getSettings",
            "getConsentPermissions"
        ]
    });
module.exports.initializeShellDataForReload = $7633bec5a9d3e49e$var$initializeShellDataForReload;
const $7633bec5a9d3e49e$var$getAccountCluster = (options)=>(0, $apIgy.gqlQuery)($7633bec5a9d3e49e$var$ACCOUNT_CLUSTER_QUERY, options);
module.exports.getAccountCluster = $7633bec5a9d3e49e$var$getAccountCluster;
const $7633bec5a9d3e49e$var$getPaginatedAccountClusters = (options)=>(0, $apIgy.gqlQuery)($7633bec5a9d3e49e$var$ACCOUNTS_QUERY, options);
module.exports.getPaginatedAccountClusters = $7633bec5a9d3e49e$var$getPaginatedAccountClusters;
const $7633bec5a9d3e49e$var$initializeShellDataForHeader = ({ getProfile: getProfile, ...options })=>(0, $apIgy.gqlQuery)(getProfile ? $7633bec5a9d3e49e$var$SHELL_HEADER_QUERY : $7633bec5a9d3e49e$var$SHELL_HEADER_QUERY.replace(/.*userProfileJson.*\n/, ""), options, {
        ignoreErrorsOnPaths: [
            "getPPSProfile",
            "getSettings",
            "userOrgPreferences",
            "timeline"
        ]
    });
module.exports.initializeShellDataForHeader = $7633bec5a9d3e49e$var$initializeShellDataForHeader;
const $7633bec5a9d3e49e$var$exchangeToken = (options)=>(0, $apIgy.gqlQuery)($7633bec5a9d3e49e$var$TOKEN_EXCHANGE_QUERY, options);
module.exports.exchangeToken = $7633bec5a9d3e49e$var$exchangeToken;

});
parcelRegister("apIgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gqlQuery = module.exports.setAuthPromise = module.exports.setUnauthorizedHandler = module.exports.GraphQLError = module.exports.PREF_GROUPID = module.exports.PREF_APPID = void 0;

var $4ua75 = parcelRequire("4ua75");

var $iNslS = parcelRequire("iNslS");

var $ad86a19730004a94$var$_metrics = $ad86a19730004a94$var$_interopRequireWildcard((parcelRequire("17AVh")));
function $ad86a19730004a94$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $ad86a19730004a94$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $ad86a19730004a94$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ad86a19730004a94$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ad86a19730004a94$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
const $ad86a19730004a94$var$PREF_APPID = "userPreferences";
module.exports.PREF_APPID = $ad86a19730004a94$var$PREF_APPID;
const $ad86a19730004a94$var$PREF_GROUPID = "exc-preferences";
module.exports.PREF_GROUPID = $ad86a19730004a94$var$PREF_GROUPID;
let $ad86a19730004a94$var$metrics;
let $ad86a19730004a94$var$unauthorizedHandler;
class $ad86a19730004a94$var$GraphQLError extends Error {
    constructor(message, requestId, errors){
        super(message);
        $ad86a19730004a94$var$_defineProperty(this, "_errors", void 0);
        $ad86a19730004a94$var$_defineProperty(this, "_requestId", void 0);
        this._requestId = requestId;
        this._errors = errors;
        Object.setPrototypeOf(this, $ad86a19730004a94$var$GraphQLError.prototype);
    }
    get requestId() {
        return this._requestId;
    }
    get errors() {
        return this._errors;
    }
}
module.exports.GraphQLError = $ad86a19730004a94$var$GraphQLError;
const $ad86a19730004a94$var$getErrorInfo = (json, operationName)=>{
    const errorMessages = [];
    const totalErrors = {};
    (json.errors || []).forEach((err)=>{
        errorMessages.push(err.message);
        const status = err.extensions?.response?.status || err.extensions?.code || "Unknown Server Error";
        totalErrors[status] = totalErrors[status] || [];
        totalErrors[status].push({
            error: err.message,
            path: err.path && err.path.join(".")
        });
        $ad86a19730004a94$var$metrics.error(`[GraphQL Service Error in ${operationName}] Message: ${err.message}`, err, {
            requestId: json.reqId
        });
    });
    return {
        description: errorMessages.join(",") || "Unknown GQL Error",
        totalErrors: totalErrors
    };
};
const $ad86a19730004a94$var$handleRequestError = async (res, reqId, operationName)=>{
    let errorDescription = "";
    let gqlErrors = {};
    try {
        if (res.status === 401 && $ad86a19730004a94$var$unauthorizedHandler) $ad86a19730004a94$var$unauthorizedHandler();
        const errorJson = await res.json(); // Form the error message object based off whether it is an io error or not
        if (errorJson?.error_code) {
            errorDescription = `${errorJson.message} (${errorJson.error_code})`;
            gqlErrors = {
                [res.status]: errorDescription
            };
        } else ({ description: errorDescription, totalErrors: gqlErrors } = $ad86a19730004a94$var$getErrorInfo(errorJson, operationName));
    } catch  {
        errorDescription = "Unknown GQL Error.";
    }
    throw new $ad86a19730004a94$var$GraphQLError(`${res.status} - ${errorDescription}`, reqId, gqlErrors);
};
const $ad86a19730004a94$var$getGqlResponse = async (res, ignoreErrorsOnPaths, operationName)=>{
    const reqId = res?.headers && res.headers.get("x-request-id") || "n/a";
    if (res && !res.ok) await $ad86a19730004a94$var$handleRequestError(res, reqId, operationName);
    const json = await res.json() || {};
    if (json.errors) {
        const { description: description, totalErrors: totalErrors } = $ad86a19730004a94$var$getErrorInfo(json, operationName);
        const failingPaths = [];
        for(const path in json.data){
            // If the path is required, log to EIM and throw an error
            if (json.data[path] === null && !ignoreErrorsOnPaths.includes(path)) {
                $ad86a19730004a94$var$metrics.error(`Non-2xx response from backing services in gql: ${description}`, {
                    ignoreErrorsOnPaths: ignoreErrorsOnPaths,
                    operationName: operationName,
                    path: path,
                    reqId: reqId,
                    totalErrors: totalErrors
                });
                throw new $ad86a19730004a94$var$GraphQLError(`Non-2xx response from backing services in gql: ${description}`, reqId, totalErrors);
            } // Any number of the ignored paths could be failing, so we should keep track of
            // which paths are failing so we can log the data to EIM
            json.data[path] === null && failingPaths.push(path);
        } // If there are errors, but we have not thrown an error for a required path,
        // log a warning to EIM
        $ad86a19730004a94$var$metrics.warn(`Non-2xx response from ignored path:  ${description}`, {
            ignoreErrorsOnPaths: ignoreErrorsOnPaths,
            operationName: operationName,
            paths: failingPaths,
            reqId: reqId,
            totalErrors: totalErrors
        });
    }
    json.reqID = reqId;
    return json;
};
const $ad86a19730004a94$var$request = (query, variables, scope, ignoreErrorsOnPaths, operationName)=>(0, $4ua75.query)({
        data: {
            query: query,
            variables: variables
        },
        maxRetries: 5,
        scope: scope,
        totalFetchTime: 10000
    }).then((res)=>$ad86a19730004a94$var$getGqlResponse(res, ignoreErrorsOnPaths, operationName));
let $ad86a19730004a94$var$authPromise;
const $ad86a19730004a94$var$setUnauthorizedHandler = (handler)=>$ad86a19730004a94$var$unauthorizedHandler = handler;
module.exports.setUnauthorizedHandler = $ad86a19730004a94$var$setUnauthorizedHandler;
const $ad86a19730004a94$var$setAuthPromise = (auth)=>$ad86a19730004a94$var$authPromise = auth;
module.exports.setAuthPromise = $ad86a19730004a94$var$setAuthPromise;
const $ad86a19730004a94$var$gqlQuery = async (query, variables, options)=>{
    if (!$ad86a19730004a94$var$metrics) $ad86a19730004a94$var$metrics = $ad86a19730004a94$var$_metrics.default.create("exc.core.GraphQlService");
     // Wait for auth to be ready before making GraphQL calls.
    $ad86a19730004a94$var$authPromise && await $ad86a19730004a94$var$authPromise;
    const { ignoreErrorsOnPaths: ignoreErrorsOnPaths = [], scope: scope = $4ua75.FetchScope.ORG } = options || {};
    const queryName = (0, $iNslS.getOperationName)(query) || "GraphQl";
    const gqlTimer = $ad86a19730004a94$var$metrics.start(queryName);
    try {
        const response = await $ad86a19730004a94$var$request(query, variables, scope, ignoreErrorsOnPaths, queryName);
        const { data: data } = response;
        if (data) {
            gqlTimer.time("data.initialized", `Initialized Shell Data from GQL required for ${queryName}.`, {
                requestId: response.reqID
            });
            $ad86a19730004a94$var$metrics.info(`Initialized Shell Data required for ${queryName} using GQL.`, {
                requestId: response.reqID
            });
        } else $ad86a19730004a94$var$metrics.error(`GQL returned invalid/null response for ${queryName} Data`);
        return data;
    } catch (error) {
        gqlTimer.time("failure", `Failed to initialize Shell App Data for ${queryName} using GQL. Error: ${(0, $iNslS.getErrorMessage)(error)}`, {
            level: $ad86a19730004a94$var$_metrics.Level.ERROR
        });
        throw error;
    }
};
module.exports.gqlQuery = $ad86a19730004a94$var$gqlQuery;

});
parcelRegister("4ua75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetch = $7586d8ee370a0f76$var$fetch;
module.exports.getPrefetched = $7586d8ee370a0f76$var$getPrefetched;
module.exports.query = $7586d8ee370a0f76$var$query;
module.exports.getApolloClient = $7586d8ee370a0f76$var$getApolloClient;
module.exports.createApolloClient = $7586d8ee370a0f76$var$createApolloClient;
module.exports.FetchScope = module.exports.ROUTING = module.exports.DEFAULT_STATUS_CODES_TO_RETRY = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * APIs that simplify code to make authenticated network requests for resources, execute GraphQL
 * queries, etc..
 *
 * ***Import:***
 *
 * ```typescript
 * import {fetch, query} from '@adobe/exc-app/network';
 * ```
 *
 * ***Default export:***
 *
 * [NetworkApi](../interfaces/network.networkapi.md)
 *
 * ***Usage:***
 *
 * ```typescript
 * import {fetch, query} from '@adobe/exc-app/network';
 *
 * // Performs a window.fetch call with Authorization and x-api-key headers set
 * const fetchResponse = await fetch('https://localhost', {auth: 'Header', method: 'GET'});
 *
 * // Executes a query for resources to the ExC GraphQL service
 * const queryResponse = await query({
 *   data: {
 *     query: `
 *       query PPSQuery($userId: String!, $apiKey: String!) {
 *         getPPSProfile(userId: $userId, apiKey: $apiKey) {
 *           images
 *         }
 *       }`,
 *     variables: {
 *       apiKey: 'test-app',
 *       userId: '123@AdobeID'
 *     }
 *   },
 *   operationName: 'PPSAvatar'
 * });
 *
 * ```
 * @packageDocumentation
 * @module network
 */ /**
 * Default status codes which imply a transient error and can be retried.
 */ const $7586d8ee370a0f76$var$DEFAULT_STATUS_CODES_TO_RETRY = [
    429,
    502,
    503,
    504
];
module.exports.DEFAULT_STATUS_CODES_TO_RETRY = $7586d8ee370a0f76$var$DEFAULT_STATUS_CODES_TO_RETRY;
let $7586d8ee370a0f76$var$ROUTING;
/**
 * Query request interface.
 */ module.exports.ROUTING = $7586d8ee370a0f76$var$ROUTING;
(function(ROUTING) {
    ROUTING[ROUTING["AEP_PROFILE_BASED"] = 0] = "AEP_PROFILE_BASED";
    ROUTING[ROUTING["DEFAULT"] = 1] = "DEFAULT";
    ROUTING[ROUTING["REGION_BASED_PER_QUERY"] = 2] = "REGION_BASED_PER_QUERY";
})($7586d8ee370a0f76$var$ROUTING || (module.exports.ROUTING = $7586d8ee370a0f76$var$ROUTING = {}));
/**
 * This parameter will be used to specify what headers are automatically added to the API call.
 */ let $7586d8ee370a0f76$var$FetchScope;
/**
 * Defines the object containing any custom settings that you want to apply to the request. You can
 * also additionally specify the 'auth' parameter to automatically set the Authentication, API key in Headers/Query params.
 *
 * ***Example:***
 *
 * `{auth: 'Header', body: 'xyz', headers: {'Content-Type': 'text/plain'}, method: 'POST'}` or
 * `{auth: 'Header', method: 'GET'}` or
 * `{method: 'GET'}`
 */ module.exports.FetchScope = $7586d8ee370a0f76$var$FetchScope;
(function(FetchScope) {
    FetchScope["NONE"] = "NONE";
    FetchScope["AUTH"] = "AUTH";
    FetchScope["ORG"] = "ORG";
    FetchScope["SANDBOX"] = "SANDBOX";
    FetchScope["SANDBOX_PLUS"] = "SANDBOX_PLUS";
})($7586d8ee370a0f76$var$FetchScope || (module.exports.FetchScope = $7586d8ee370a0f76$var$FetchScope = {}));
/**
 * Provides an interface for fetching resources powered by the global 'fetch' API.
 *
 * ***Example:***
 *
 * ```typescript
 * // performs a window.fetch call
 * let response = await fetch('https://example.com/api/ping');
 *
 * // performs a window.fetch call with Authorization and x-api-key headers set
 * response = await fetch('https://localhost', {auth: 'Header', method: 'GET'});
 *
 * // performs a window.fetch call with user_token and client_id query parameters added to the URL
 * const request = new Request('https://localhost', {
 *   body: JSON.stringify({k: 'v'}),
 *   headers: new Headers(),
 *   method: 'POST'
 * });
 * response = await fetch(request, {auth: 'Header'});
 * ```
 * @param input The resource that you wish to fetch. It can either be the URL of the resource you
 * want to fetch or a Request object.
 * @param init An object containing any custom settings that you want to apply to the request.
 * @returns The promise for the response to the fetch operation.
 */ function $7586d8ee370a0f76$var$fetch(input, init) {
    return (0, $ihFuI.getImpl)("network").fetch(input, init);
}
/**
 * Provides an interface for querying known data.
 * Data querying and caching are managed in Unified Shell in advance.
 *
 * This is an experimental feature.
 * @template T
 * @param key - Data Contract key
 * @param options - Prefetch options
 * @returns Promise for the contract execution response
 */ function $7586d8ee370a0f76$var$getPrefetched(key, options) {
    return (0, $ihFuI.getImpl)("network").getPrefetched(key, options);
}
/**
 * Provides an interface for querying resources via GraphqQL.
 * In order to consume query, please make sure the respective query resolver is
 * available in the GraphQL Service.
 * ***Example:***
 *
 * ```typescript
 * const PPS_QUERY = `
 *   query PPSQuery($userId: String!, $apiKey: String!) {
 *     getPPSProfile(userId: $userId, apiKey: $apiKey) {
 *       images
 *     }
 *   }`;
 *
 * // queries the respective resource via GraphQL and returns HTTP Response {ok: true, status: 200, ...}
 * query({data: {query: PPS_QUERY, variables: {
 *   userId: '123@AdobeID',
 *   apiKey: 'test-app',
 * }}, operationName: 'PPSAvatar'});
 *
 * // queries the respective resource via GraphQL and returns HTTP Response {ok: true, status: 200, ...}
 * query({data: {query: `
 *   query PPSQuery {
 *     getPPSProfile(userId: "123@AdobeID", apiKey: "test-app") {
 *       images
 *     }
 *   }`
 * }});
 * ```
 * @param input Query request containing desired GQL Query.
 * @returns The promise for the response to the query operation.
 */ function $7586d8ee370a0f76$var$query(input) {
    return (0, $ihFuI.getImpl)("network").query(input);
}
/**
 * Provides an interface for querying resources via GraphqQL using ApolloClient
 * ***Example***
 * ```typescript
 *  const apolloClientModule = await getApolloClient();
 *  const apolloClient = apolloClientModule.apolloClient;
 *  const gql = apolloClientModule.gql;
 *  const result = await apolloClient.query({
 *    query: gql`query  user {
 *      id
 *      name
 *    }`,
 *    variables : {}
 *  });
 *  console.log(result.data);
 * ```
 * @param options Configuration to create ApolloClient instance
 * @returns GraphQL query response
 *
 */ function $7586d8ee370a0f76$var$getApolloClient(options) {
    return (0, $ihFuI.getImpl)("network").getApolloClient(options);
}
function $7586d8ee370a0f76$var$createApolloClient(apolloClientProvided, options) {
    return (0, $ihFuI.getImpl)("network").createApolloClient(apolloClientProvided, options);
}

});


parcelRegister("bllbv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SettingsLevel = void 0;
/*************************************************************************
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * @ignore
 */ let $be97d5eba2e54788$var$SettingsLevel;
module.exports.SettingsLevel = $be97d5eba2e54788$var$SettingsLevel;
(function(SettingsLevel) {
    SettingsLevel["ORG"] = "org";
    SettingsLevel["USER"] = "user";
    SettingsLevel["USERORG"] = "userorg";
})($be97d5eba2e54788$var$SettingsLevel || (module.exports.SettingsLevel = $be97d5eba2e54788$var$SettingsLevel = {}));

});


parcelRegister("9OLey", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Internal = void 0;

var $ihFuI = parcelRequire("ihFuI");
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/ /**
 * Internal APIs, meant to be used by Unified Shell only.
 * @ignore
 */ /**
 * @ignore
 */ class $61d10a836751a8e2$var$Internal {
    static addPoller(poller) {
        return (0, $ihFuI.getImpl)("internal").addPoller(poller);
    }
    static configureMetrics(config) {
        return (0, $ihFuI.getImpl)("internal").configureMetrics(config);
    }
    static configureNetwork(config) {
        return (0, $ihFuI.getImpl)("internal").configureNetwork(config);
    }
    static configurePolling(config) {
        return (0, $ihFuI.getImpl)("internal").configurePolling(config);
    }
    static flush() {
        return (0, $ihFuI.getImpl)("internal").flush();
    }
    static getActivityMonitor() {
        return (0, $ihFuI.getImpl)("internal").getActivityMonitor();
    }
    static preloadEngine() {
        return (0, $ihFuI.getImpl)("internal").preloadEngine();
    }
    static registerActivityEmitter(emitter) {
        return (0, $ihFuI.getImpl)("internal").registerActivityEmitter(emitter);
    }
    static removePoller(handle) {
        return (0, $ihFuI.getImpl)("internal").removePoller(handle);
    }
    static setApplication(app) {
        return (0, $ihFuI.getImpl)("internal").setApplication(app);
    }
    static setFilter(filterFunction) {
        return (0, $ihFuI.getImpl)("internal").setFilter(filterFunction);
    }
    static setUser(user, version) {
        return (0, $ihFuI.getImpl)("internal").setUser(user, version);
    }
    static clearUser(version) {
        return (0, $ihFuI.getImpl)("internal").clearUser(version);
    }
    static waitForGainsight() {
        return (0, $ihFuI.getImpl)("internal").waitForGainsight();
    }
}
module.exports.Internal = $61d10a836751a8e2$var$Internal;

});

parcelRegister("3e6zu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.SW_CACHE_NAME = module.exports.MANIFEST_EP = module.exports.ONE_HOUR = void 0;

var $iNslS = parcelRequire("iNslS");

var $c0cwc = parcelRequire("c0cwc");

var $hCG2Z = parcelRequire("hCG2Z");

var $15j1u = parcelRequire("15j1u");

var $2acc0b98c3350c5f$var$_metrics = $2acc0b98c3350c5f$var$_interopRequireWildcard((parcelRequire("17AVh")));

var $c3nD4 = parcelRequire("c3nD4");
function $2acc0b98c3350c5f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $2acc0b98c3350c5f$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $2acc0b98c3350c5f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2acc0b98c3350c5f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2acc0b98c3350c5f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/** Timeout for service worker to fetch and check HTML */ const $2acc0b98c3350c5f$var$ONE_HOUR = 3600000;
module.exports.ONE_HOUR = $2acc0b98c3350c5f$var$ONE_HOUR;
const $2acc0b98c3350c5f$var$MANIFEST_EP = "/service-worker/manifest";
module.exports.MANIFEST_EP = $2acc0b98c3350c5f$var$MANIFEST_EP;
const $2acc0b98c3350c5f$var$SW_CACHE_NAME = "unifiedShellCache";
module.exports.SW_CACHE_NAME = $2acc0b98c3350c5f$var$SW_CACHE_NAME;
const $2acc0b98c3350c5f$var$THUNDERBIRD_SCOPE = `${$c3nD4.THUNDERBIRD_ROOT}/`;
class $2acc0b98c3350c5f$var$ServiceWorkerRegisterService {
    constructor(){
        $2acc0b98c3350c5f$var$_defineProperty(this, "metrics", $2acc0b98c3350c5f$var$_metrics.default.create("exc.core.services.ServiceWorkerRegisterService"));
        $2acc0b98c3350c5f$var$_defineProperty(this, "isActive", false);
        $2acc0b98c3350c5f$var$_defineProperty(this, "activeLogged", false);
    }
    async checkDisabled() {
        const queryValue = (0, $hCG2Z.getQueryValue)("sw_enabled");
        if (queryValue === "false" || (0, $15j1u.isSkyline)()) $2acc0b98c3350c5f$var$ServiceWorkerRegisterService.SW_DISABLED = true;
        if (queryValue === "true") $2acc0b98c3350c5f$var$ServiceWorkerRegisterService.SW_DISABLED = false;
    }
    logRegistration(registration) {
        if (!this.activeLogged) {
            if (registration.active) {
                this.activeLogged = true;
                this.metrics.event("ServiceWorker.active", {
                    navigationPreload: !!registration.navigationPreload,
                    state: registration.active.state
                });
            }
            if (registration.installing) this.metrics.event("ServiceWorker.installing");
            if (registration.waiting) this.metrics.event("ServiceWorker.waiting");
        }
    }
    /**
   * Registers service worker.
   */ async registerServiceWorker() {
        await this.checkDisabled();
        if ($2acc0b98c3350c5f$var$ServiceWorkerRegisterService.SW_DISABLED) {
            this.metrics.event("App.serviceWorkerDisabled");
            return;
        }
        if (navigator.serviceWorker) {
            let sw = `${location.origin}/sw.js`;
            const version = (0, $hCG2Z.getQueryParams)()["unified-shell_version"];
            if (version) sw += `?unified-shell_version=${version}`;
            if (!this.isActive || navigator.serviceWorker.controller?.scriptURL !== sw) try {
                const [registration] = await Promise.all([
                    navigator.serviceWorker.register(sw, {
                        scope: "/"
                    }),
                    navigator.serviceWorker.register(sw, {
                        scope: $2acc0b98c3350c5f$var$THUNDERBIRD_SCOPE
                    })
                ]);
                this.isActive = !!registration.active;
                this.logRegistration(registration);
            } catch (err) {
                this.metrics.event("ServiceWorker.registrationError", {
                    level: $2acc0b98c3350c5f$var$_metrics.Level.ERROR
                }, {
                    error: (0, $iNslS.getErrorMessage)(err)
                });
            }
            else {
                const registrations = await navigator.serviceWorker.getRegistrations();
                if (registrations.length < 2) navigator.serviceWorker.register(sw, {
                    scope: $2acc0b98c3350c5f$var$THUNDERBIRD_SCOPE
                });
            }
        }
    }
    /**
   * Unregisters the service worker.
   */ async unregister() {
        const { serviceWorker: serviceWorker } = navigator;
        $2acc0b98c3350c5f$var$ServiceWorkerRegisterService.SW_DISABLED = true;
        if (serviceWorker) {
            const registrations = await serviceWorker.getRegistrations();
            for (const registration of registrations)registration.unregister().then((success)=>{
                if (success) this.metrics.event("App.serviceWorkerUnregistered");
                else this.metrics.event("App.serviceWorkerUnregistrationFail", {
                    level: $2acc0b98c3350c5f$var$_metrics.Level.ERROR
                });
            });
        }
    }
    /**
   * Loads the client side code that operates the service worker.
   */ load() {
        const swEnabled = (0, $hCG2Z.getQueryValue)("sw_enabled");
        const { serviceWorker: serviceWorker } = navigator;
        if (serviceWorker) {
            // Get HTML from Service Worker.
            if (serviceWorker.controller?.state === "activated") {
                this.isActive = true;
                (0, $c0cwc.getHtmlFromWorker)();
            }
            serviceWorker.ready?.then((registration)=>{
                if (!this.isActive) {
                    this.isActive = !!registration.active;
                    (0, $c0cwc.getHtmlFromWorker)();
                }
                this.logRegistration(registration);
            });
            if (swEnabled === "false") {
                this.unregister();
                return;
            }
            serviceWorker.addEventListener("message", (event)=>{
                const { additionalData: additionalData, eimEvent: eimEvent, message: message, level: level = $2acc0b98c3350c5f$var$_metrics.Level.INFO } = event.data;
                if (eimEvent && message) this.metrics.event(`ServiceWorker.${eimEvent}`, message, additionalData, {
                    level: level
                });
            });
            window.addEventListener("load", ()=>this.registerServiceWorker());
        } else this.metrics.event("ServiceWorker.NotSupported", {
            level: $2acc0b98c3350c5f$var$_metrics.Level.WARN
        });
    }
    /**
   * Prepares Service Worker before user redirects to SUSI in order to improve post login load time.
   * If Service Worker is active already, check manifest to download new version during login.
   * If this is a user's first visit, register the worker.
   */ async prepareForLogin() {
        if ((0, $c0cwc.isWorkerActivated)()) {
            const registerPromise = navigator.serviceWorker.getRegistrations().then((registrations)=>{
                if (registrations.length < 2) return this.registerServiceWorker();
            });
            return Promise.all([
                fetch($2acc0b98c3350c5f$var$MANIFEST_EP),
                registerPromise
            ]);
        }
        const swCacheExists = window.caches && await caches.has($2acc0b98c3350c5f$var$SW_CACHE_NAME); // If the cache already exists, perhaps the user disabled the service worker intentionally.
        // We won't register in that case.
        if (!swCacheExists) return this.registerServiceWorker();
    }
}
module.exports.default = $2acc0b98c3350c5f$var$ServiceWorkerRegisterService;
$2acc0b98c3350c5f$var$_defineProperty($2acc0b98c3350c5f$var$ServiceWorkerRegisterService, "SW_DISABLED", false);

});
parcelRegister("c0cwc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getHtmlFromWorker = module.exports.isWorkerActivated = module.exports.getWindowConfig = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ let $7a30a418ae3d84b0$var$initialHtmlPromise = undefined;
const $7a30a418ae3d84b0$var$getWindowConfig = ()=>window.config;
module.exports.getWindowConfig = $7a30a418ae3d84b0$var$getWindowConfig;
const $7a30a418ae3d84b0$var$isWorkerActivated = ()=>navigator.serviceWorker?.controller?.state === "activated";
module.exports.isWorkerActivated = $7a30a418ae3d84b0$var$isWorkerActivated;
const $7a30a418ae3d84b0$var$getHtmlFromWorker = ()=>{
    const { lastModified: lastModified, spaVersion: spaVersion } = $7a30a418ae3d84b0$var$getWindowConfig();
    const endpoint = `/service-worker/indexhtml?lastModified=${lastModified}&spaVersion=${spaVersion}`;
    if (!$7a30a418ae3d84b0$var$initialHtmlPromise) $7a30a418ae3d84b0$var$initialHtmlPromise = fetch(endpoint);
    return $7a30a418ae3d84b0$var$initialHtmlPromise;
};
module.exports.getHtmlFromWorker = $7a30a418ae3d84b0$var$getHtmlFromWorker;

});

parcelRegister("15j1u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSkylineInstance = $0ca503a19425fcd4$var$getSkylineInstance;
module.exports.isSkyline = $0ca503a19425fcd4$var$isSkyline;

var $hCG2Z = parcelRequire("hCG2Z");
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ function $0ca503a19425fcd4$var$getSkylineInstance(url) {
    var hostname = (url || window.location || {}).hostname;
    if (/\.adobeaemcloud\.com/.test(hostname)) return hostname.split(".")[0];
    return (0, $hCG2Z.getQueryValue)("skyline");
}
/**
 * Determines whether current environment is AEM skyline.
 */ function $0ca503a19425fcd4$var$isSkyline(url) {
    return !!$0ca503a19425fcd4$var$getSkylineInstance(url);
}

});

parcelRegister("c3nD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THUNDERBIRD_SPA_ROOT = module.exports.THUNDERBIRD_ROOT = module.exports.SPA_ROOT = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $80ada89a4dff2180$var$SPA_ROOT = "/solutions";
module.exports.SPA_ROOT = $80ada89a4dff2180$var$SPA_ROOT;
const $80ada89a4dff2180$var$THUNDERBIRD_ROOT = "/thunderbird";
module.exports.THUNDERBIRD_ROOT = $80ada89a4dff2180$var$THUNDERBIRD_ROOT;
const $80ada89a4dff2180$var$THUNDERBIRD_SPA_ROOT = `${$80ada89a4dff2180$var$THUNDERBIRD_ROOT}${$80ada89a4dff2180$var$SPA_ROOT}`;
module.exports.THUNDERBIRD_SPA_ROOT = $80ada89a4dff2180$var$THUNDERBIRD_SPA_ROOT;

});



var $652dd874823fdcb8$exports = {};

(parcelRequire("3cmwu")).register(new URL("", import.meta.url).toString(), JSON.parse('["jA7Xt","polyfills.3dea3409.js","hdSxF","compression.e2e14236.js","1vCZj","pako.0ea1d2a4.js"]'));

"use strict";
// ie9- setTimeout & setInterval additional parameters fix

var $aSeGt = parcelRequire("aSeGt");

var $aHywL = parcelRequire("aHywL");
var $93970aff8c8a6365$exports = {};

var $aSeGt = parcelRequire("aSeGt");
var $93970aff8c8a6365$var$navigator = $aSeGt.navigator;
$93970aff8c8a6365$exports = $93970aff8c8a6365$var$navigator && $93970aff8c8a6365$var$navigator.userAgent || "";


var $92bb133d4f9a454b$var$slice = [].slice;
var $92bb133d4f9a454b$var$MSIE = /MSIE .\./.test($93970aff8c8a6365$exports); // <- dirty ie9- check
var $92bb133d4f9a454b$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $92bb133d4f9a454b$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == "function" ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$aHywL($aHywL.G + $aHywL.B + $aHywL.F * $92bb133d4f9a454b$var$MSIE, {
    setTimeout: $92bb133d4f9a454b$var$wrap($aSeGt.setTimeout),
    setInterval: $92bb133d4f9a454b$var$wrap($aSeGt.setInterval)
});



var $aHywL = parcelRequire("aHywL");
var $ecc6bd02f7f6ec5f$exports = {};

var $c5eX0 = parcelRequire("c5eX0");
var $bf6c000ec0c51824$exports = {};
// fast apply, http://jsperf.lnkit.com/fast-apply/5
$bf6c000ec0c51824$exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};



var $k0xSC = parcelRequire("k0xSC");

var $79BiK = parcelRequire("79BiK");

var $aSeGt = parcelRequire("aSeGt");
var $ecc6bd02f7f6ec5f$var$process = $aSeGt.process;
var $ecc6bd02f7f6ec5f$var$setTask = $aSeGt.setImmediate;
var $ecc6bd02f7f6ec5f$var$clearTask = $aSeGt.clearImmediate;
var $ecc6bd02f7f6ec5f$var$MessageChannel = $aSeGt.MessageChannel;
var $ecc6bd02f7f6ec5f$var$Dispatch = $aSeGt.Dispatch;
var $ecc6bd02f7f6ec5f$var$counter = 0;
var $ecc6bd02f7f6ec5f$var$queue = {};
var $ecc6bd02f7f6ec5f$var$ONREADYSTATECHANGE = "onreadystatechange";
var $ecc6bd02f7f6ec5f$var$defer, $ecc6bd02f7f6ec5f$var$channel, $ecc6bd02f7f6ec5f$var$port;
var $ecc6bd02f7f6ec5f$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($ecc6bd02f7f6ec5f$var$queue.hasOwnProperty(id)) {
        var fn = $ecc6bd02f7f6ec5f$var$queue[id];
        delete $ecc6bd02f7f6ec5f$var$queue[id];
        fn();
    }
};
var $ecc6bd02f7f6ec5f$var$listener = function(event) {
    $ecc6bd02f7f6ec5f$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$ecc6bd02f7f6ec5f$var$setTask || !$ecc6bd02f7f6ec5f$var$clearTask) {
    $ecc6bd02f7f6ec5f$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $ecc6bd02f7f6ec5f$var$queue[++$ecc6bd02f7f6ec5f$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $bf6c000ec0c51824$exports(typeof fn == "function" ? fn : Function(fn), args);
        };
        $ecc6bd02f7f6ec5f$var$defer($ecc6bd02f7f6ec5f$var$counter);
        return $ecc6bd02f7f6ec5f$var$counter;
    };
    $ecc6bd02f7f6ec5f$var$clearTask = function clearImmediate(id) {
        delete $ecc6bd02f7f6ec5f$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("cAEsp"))($ecc6bd02f7f6ec5f$var$process) == "process") $ecc6bd02f7f6ec5f$var$defer = function(id) {
        $ecc6bd02f7f6ec5f$var$process.nextTick($c5eX0($ecc6bd02f7f6ec5f$var$run, id, 1));
    };
    else if ($ecc6bd02f7f6ec5f$var$Dispatch && $ecc6bd02f7f6ec5f$var$Dispatch.now) $ecc6bd02f7f6ec5f$var$defer = function(id) {
        $ecc6bd02f7f6ec5f$var$Dispatch.now($c5eX0($ecc6bd02f7f6ec5f$var$run, id, 1));
    };
    else if ($ecc6bd02f7f6ec5f$var$MessageChannel) {
        $ecc6bd02f7f6ec5f$var$channel = new $ecc6bd02f7f6ec5f$var$MessageChannel();
        $ecc6bd02f7f6ec5f$var$port = $ecc6bd02f7f6ec5f$var$channel.port2;
        $ecc6bd02f7f6ec5f$var$channel.port1.onmessage = $ecc6bd02f7f6ec5f$var$listener;
        $ecc6bd02f7f6ec5f$var$defer = $c5eX0($ecc6bd02f7f6ec5f$var$port.postMessage, $ecc6bd02f7f6ec5f$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($aSeGt.addEventListener && typeof postMessage == "function" && !$aSeGt.importScripts) {
        $ecc6bd02f7f6ec5f$var$defer = function(id) {
            $aSeGt.postMessage(id + "", "*");
        };
        $aSeGt.addEventListener("message", $ecc6bd02f7f6ec5f$var$listener, false);
    // IE8-
    } else if ($ecc6bd02f7f6ec5f$var$ONREADYSTATECHANGE in $79BiK("script")) $ecc6bd02f7f6ec5f$var$defer = function(id) {
        $k0xSC.appendChild($79BiK("script"))[$ecc6bd02f7f6ec5f$var$ONREADYSTATECHANGE] = function() {
            $k0xSC.removeChild(this);
            $ecc6bd02f7f6ec5f$var$run.call(id);
        };
    };
    else $ecc6bd02f7f6ec5f$var$defer = function(id) {
        setTimeout($c5eX0($ecc6bd02f7f6ec5f$var$run, id, 1), 0);
    };
}
$ecc6bd02f7f6ec5f$exports = {
    set: $ecc6bd02f7f6ec5f$var$setTask,
    clear: $ecc6bd02f7f6ec5f$var$clearTask
};


$aHywL($aHywL.G + $aHywL.B, {
    setImmediate: $ecc6bd02f7f6ec5f$exports.set,
    clearImmediate: $ecc6bd02f7f6ec5f$exports.clear
});


var $ab5a6257d4398817$exports = {};
"use strict";
var $acbae0e0dbec2ef8$exports = {};
// 22.1.3.31 Array.prototype[@@unscopables]

var $acbae0e0dbec2ef8$var$UNSCOPABLES = (parcelRequire("1Q5lc"))("unscopables");
var $acbae0e0dbec2ef8$var$ArrayProto = Array.prototype;

if ($acbae0e0dbec2ef8$var$ArrayProto[$acbae0e0dbec2ef8$var$UNSCOPABLES] == undefined) (parcelRequire("k8fni"))($acbae0e0dbec2ef8$var$ArrayProto, $acbae0e0dbec2ef8$var$UNSCOPABLES, {});
$acbae0e0dbec2ef8$exports = function(key) {
    $acbae0e0dbec2ef8$var$ArrayProto[$acbae0e0dbec2ef8$var$UNSCOPABLES][key] = true;
};


var $f02235d70282de33$exports = {};
$f02235d70282de33$exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};



var $lwojb = parcelRequire("lwojb");

var $5j9rP = parcelRequire("5j9rP");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
$ab5a6257d4398817$exports = (parcelRequire("9lJXd"))(Array, "Array", function(iterated, kind) {
    this._t = $5j9rP(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $f02235d70282de33$exports(1);
    }
    if (kind == "keys") return $f02235d70282de33$exports(0, index);
    if (kind == "values") return $f02235d70282de33$exports(0, O[index]);
    return $f02235d70282de33$exports(0, [
        index,
        O[index]
    ]);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$lwojb.Arguments = $lwojb.Array;
$acbae0e0dbec2ef8$exports("keys");
$acbae0e0dbec2ef8$exports("values");
$acbae0e0dbec2ef8$exports("entries");



var $iqr3M = parcelRequire("iqr3M");

var $38Rz6 = parcelRequire("38Rz6");

var $aSeGt = parcelRequire("aSeGt");

var $k8fni = parcelRequire("k8fni");

var $lwojb = parcelRequire("lwojb");

var $1Q5lc = parcelRequire("1Q5lc");
var $f0ae873c4a57678f$var$ITERATOR = $1Q5lc("iterator");
var $f0ae873c4a57678f$var$TO_STRING_TAG = $1Q5lc("toStringTag");
var $f0ae873c4a57678f$var$ArrayValues = $lwojb.Array;
var $f0ae873c4a57678f$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $f0ae873c4a57678f$var$collections = $iqr3M($f0ae873c4a57678f$var$DOMIterables), $f0ae873c4a57678f$var$i = 0; $f0ae873c4a57678f$var$i < $f0ae873c4a57678f$var$collections.length; $f0ae873c4a57678f$var$i++){
    var $f0ae873c4a57678f$var$NAME = $f0ae873c4a57678f$var$collections[$f0ae873c4a57678f$var$i];
    var $f0ae873c4a57678f$var$explicit = $f0ae873c4a57678f$var$DOMIterables[$f0ae873c4a57678f$var$NAME];
    var $f0ae873c4a57678f$var$Collection = $aSeGt[$f0ae873c4a57678f$var$NAME];
    var $f0ae873c4a57678f$var$proto = $f0ae873c4a57678f$var$Collection && $f0ae873c4a57678f$var$Collection.prototype;
    var $f0ae873c4a57678f$var$key;
    if ($f0ae873c4a57678f$var$proto) {
        if (!$f0ae873c4a57678f$var$proto[$f0ae873c4a57678f$var$ITERATOR]) $k8fni($f0ae873c4a57678f$var$proto, $f0ae873c4a57678f$var$ITERATOR, $f0ae873c4a57678f$var$ArrayValues);
        if (!$f0ae873c4a57678f$var$proto[$f0ae873c4a57678f$var$TO_STRING_TAG]) $k8fni($f0ae873c4a57678f$var$proto, $f0ae873c4a57678f$var$TO_STRING_TAG, $f0ae873c4a57678f$var$NAME);
        $lwojb[$f0ae873c4a57678f$var$NAME] = $f0ae873c4a57678f$var$ArrayValues;
        if ($f0ae873c4a57678f$var$explicit) {
            for($f0ae873c4a57678f$var$key in $ab5a6257d4398817$exports)if (!$f0ae873c4a57678f$var$proto[$f0ae873c4a57678f$var$key]) $38Rz6($f0ae873c4a57678f$var$proto, $f0ae873c4a57678f$var$key, $ab5a6257d4398817$exports[$f0ae873c4a57678f$var$key], true);
        }
    }
}



var $dDEjQ = parcelRequire("dDEjQ");
(0, $dDEjQ.getBootstrap)().load();


//# sourceMappingURL=polyfills.3dea3409.js.map
